// rdata.js

const flashData = {
"31": {
    polity: {


      "constitution-introduction":[
        {
          slno: 1,
          title: "Political Science",
          points: [
            "Study of state, government, political processes, and institutions.",
            "Deals with power, authority, law, and justice.",
          ],
        },
        {
          slno: 2,
          title: "Politics",
          points: [
            "Activities related to governance and power.",
            "Involves elections, decision-making, and conflict resolution.",
          ],
        },
        {
          slno: 3,
          title: "State",
          points: [
            "A political institution with: Population, Territory, Government, Sovereignty.",
            "Permanent, abstract concept.",
          ],
        },
        {
          slno: 4,
          title: "Government",
          points: [
            "Agency of the state.",
            "Temporary, changeable after elections.",
            "Types: Democratic, Authoritarian, Monarchical.",
          ],
        },
        {
          slno: 5,
          title: "Nation",
          points: [
            "A group with common race, language, culture, history, or aspiration.",
            "Example: India = Nation-state with diverse population.",
          ],
        },
        {
          slno: 6,
          title: "Society",
          points: [
            "Network of relationships among people.",
            "Older than state; state emerges from society.",
          ],
        },
        {
          slno: 7,
          title: "Sovereignty",
          points: [
            "Absolute, supreme power of the state.",
            "Internal: Supreme inside boundaries.",
            "External: Freedom from foreign control.",
          ],
        },
        {
          slno: 8,
          title: "Law",
          points: [
            "Set of rules enforced by state.",
            "Maintains order, ensures justice.",
          ],
        },
        {
          slno: 9,
          title: "Liberty",
          points: [
            "Freedom to act and express within law.",
            "Types: Positive Liberty – Capacity to act, Negative Liberty – Freedom from interference.",
          ],
        },
        {
          slno: 10,
          title: "Equality",
          points: [
            "Absence of discrimination.",
            "Types: Political (vote), Economic (no extreme poverty/wealth), Social (no caste bias).",
          ],
        },
        {
          slno: 11,
          title: "Rights",
          points: [
            "Legal claims protected by the state.",
            "Derived from society; not natural.",
            "Examples: Right to vote, speech, education.",
          ],
        },
        {
          slno: 12,
          title: "Justice",
          points: [
            "Giving each individual their due.",
            "Types: Social Justice – Ending discrimination, Economic Justice – Equal economic opportunities, Political Justice – Equal political rights.",
          ],
        },
        {
          slno: 13,
          title: "Liberty vs Equality",
          points: [
            "Must go hand in hand.",
            "Liberty without equality = exploitation.",
            "Equality without liberty = slavery.",
          ],
        },
        {
          slno: 14,
          title: "Power",
          points: [
            "Ability to influence/control others' behavior.",
            "Political power = control over laws, policies.",
          ],
        },
        {
          slno: 15,
          title: "Authority",
          points: [
            "Legitimate use of power.",
            "Accepted by people; lawful.",
          ],
        },
        {
          slno: 16,
          title: "Legitimacy",
          points: [
            "Moral or legal right to rule.",
            "Based on popular consent.",
          ],
        },
        {
          slno: 17,
          title: "Political System",
          points: [
            "Interconnected institutions involved in governance.",
            "Includes: Govt, judiciary, parties, pressure groups.",
          ],
        },
        {
          slno: 18,
          title: "Constitution",
          points: [
            "Fundamental law of land.",
            "Defines structure, power, rights, duties.",
            "India = Written, rigid + flexible.",
          ],
        },
        {
          slno: 19,
          title: "Democracy",
          points: [
            "Govt by the people.",
            "Types: Direct (Ancient Greece), Indirect/Representative (Modern states).",
          ],
        },
        {
          slno: 20,
          title: "Features of Democracy",
          points: [
            "Universal Adult Franchise.",
            "Rule of law.",
            "Separation of powers.",
            "Fundamental rights.",
          ],
        },
        {
          slno: 21,
          title: "Types of State",
          points: [
            "Unitary (UK).",
            "Federal (India, USA).",
            "Presidential (USA).",
            "Parliamentary (India).",
          ],
        },
        {
          slno: 22,
          title: "Rule of Law",
          points: [
            "No one is above the law.",
            "Law applies equally to all.",
          ],
        },
        {
          slno: 23,
          title: "Separation of Powers",
          points: [
            "Montesquieu’s theory.",
            "Legislature: Makes laws.",
            "Executive: Enforces laws.",
            "Judiciary: Interprets laws.",
          ],
        },
        {
          slno: 24,
          title: "Welfare State",
          points: [
            "Ensures well-being of citizens.",
            "India is a Welfare State (Directive Principles).",
          ],
        },
        {
          slno: 25,
          title: "Citizenship",
          points: [
            "Legal membership of state.",
            "India allows Single citizenship.",
          ],
        },
        {
          slno: 26,
          title: "Rights vs Duties",
          points: [
            "Rights = What citizens get.",
            "Duties = What citizens must do.",
          ],
        },
        {
          slno: 27,
          title: "Secularism",
          points: [
            "State has no official religion.",
            "Equal treatment to all religions.",
          ],
        },
        {
          slno: 28,
          title: "Fundamental Rights (India)",
          points: [
            "Part III of Constitution (Art 12–35).",
            "Includes: Right to Equality, Freedom, Against Exploitation, Religion, Cultural & Educational Rights, Constitutional Remedies.",
          ],
        },
        {
          slno: 29,
          title: "Directive Principles of State Policy (DPSP)",
          points: [
            "Part IV (Art 36–51).",
            "Not enforceable but guidelines to govt.",
            "Aim: Welfare State.",
          ],
        },
        {
          slno: 30,
          title: "Fundamental Duties",
          points: [
            "Added by 42nd Amendment (1976).",
            "Total 11 duties.",
            "Not enforceable.",
          ],
        },
        {
          slno: 31,
          title: "Liberty vs Authority",
          points: [
            "Liberty without authority = chaos.",
            "Authority without liberty = oppression.",
            "Balance is essential.",
          ],
        },

      ],




        "fundamental-rights-duties": [
  {
    slno: 1,
    title: "Overview of Fundamental Rights",
    points: [
      "Enshrined in **Part III** of the Constitution (Articles **12 to 35**).",
      "Guarantees basic freedoms & protects citizens from arbitrary state action.",
      "Available to **both citizens and foreigners**, except certain rights restricted to citizens only.",
      "Can be enforced via **writ petitions** under Article 32 (SC) and 226 (HC)."
    ]
  },
  {
    slno: 2,
    title: "Right to Equality (Articles 14–18)",
    points: [
      "Art 14: Equality before law & equal protection of laws.",
      "Art 15: Prohibits discrimination on grounds of religion, race, caste, sex, or place of birth.",
      "Art 16: Equality of opportunity in public employment.",
      "Art 17: Abolishes **untouchability**; its practice is an offense.",
      "Art 18: Abolishes titles (except military & academic distinctions).",
      "CDS frequently asks direct articles-based MCQs."
    ]
  },
  {
    slno: 3,
    title: "Right to Freedom (Articles 19–22)",
    points: [
      "Art 19: 6 freedoms — Speech, Assembly, Association, Movement, Residence, Profession.",
      "Art 20: Protection in respect of conviction — **no double jeopardy**, **no ex post facto law**, **no self-incrimination**.",
      "Art 21: Right to life & personal liberty (interpreted broadly by SC).",
      "Art 21A: Right to free & compulsory education for children (6-14 years).",
      "Art 22: Protection in case of arrest & detention; preventive detention allowed up to **3 months** without advisory board approval."
    ]
  },
  {
    slno: 4,
    title: "Right Against Exploitation (Articles 23–24)",
    points: [
      "Art 23: Prohibits **human trafficking**, begar (forced labor) & bonded labor.",
      "Art 24: Prohibits child labor in hazardous industries below 14 years.",
      "CDS often asks direct article-based MCQs."
    ]
  },
  {
    slno: 5,
    title: "Right to Freedom of Religion (Articles 25–28)",
    points: [
      "Art 25: Freedom of conscience & free profession, practice, and propagation of religion.",
      "Art 26: Right to manage religious affairs.",
      "Art 27: Freedom from paying taxes for promotion of any religion.",
      "Art 28: Freedom from attending religious instruction in state-run institutions.",
      "Important for CDS as religion-based rights are often tested."
    ]
  },
  {
    slno: 6,
    title: "Cultural & Educational Rights (Articles 29–30)",
    points: [
      "Art 29: Protection of interests of minorities regarding language, script & culture.",
      "Art 30: Minority communities’ right to establish & administer educational institutions.",
      "These are **citizenship-neutral rights** — apply to both citizens & non-citizens."
    ]
  },
  {
    slno: 7,
    title: "Right to Constitutional Remedies (Article 32)",
    points: [
      "Allows citizens to move **Supreme Court** for enforcement of Fundamental Rights.",
      "Called the **“heart and soul”** of the Constitution (Dr. Ambedkar).",
      "SC can issue **5 writs**: Habeas Corpus, Mandamus, Prohibition, Certiorari, Quo Warranto.",
      "Art 226 gives similar power to High Courts with wider scope."
    ]
  },
  {
    slno: 8,
    title: "Suspension of Fundamental Rights",
    points: [
      "Art 352: During National Emergency, rights under **Art 19** are automatically suspended.",
      "Art 359: President can suspend right to move any court for enforcement of rights (except Art 20 & Art 21).",
      "CDS often tests emergency-related effects on rights."
    ]
  },
  {
    slno: 9,
    title: "Fundamental Duties (Article 51A)",
    points: [
      "Added by the **42nd Amendment Act, 1976** on recommendation of the Swaran Singh Committee.",
      "Total **11 duties** (initially 10, one added by the **86th Amendment, 2002**).",
      "Examples:",
      "• Respect Constitution, National Flag & National Anthem.",
      "• Protect sovereignty, unity & integrity of India.",
      "• Promote harmony & spirit of common brotherhood.",
      "• Preserve natural environment, forests, lakes & wildlife.",
      "• Provide education to children aged 6-14 years (added by 86th Amendment).",
      "Fundamental Duties are **non-enforceable but moral obligations**."
    ]
  },
  {
    slno: 10,
    title: "Directive Principles vs Fundamental Rights",
    points: [
      "FRs are **justiciable**, enforceable by courts; DPSPs are **non-justiciable**.",
      "However, courts interpret laws to **harmonize FRs & DPSPs** wherever possible.",
      "Important Supreme Court case: **Minerva Mills vs Union of India (1980)**."
    ]
  },
  {
    slno: 11,
    title: "CDS Exam Focus",
    points: [
      "Weightage: ~8-10 questions in GS paper.",
      "Most frequently asked topics:",
      "• Articles & amendments related to FRs & duties.",
      "• Match-the-following (Articles vs Rights).",
      "• Supreme Court judgments expanding FRs.",
      "• FR vs DPSP-related questions.",
      "**Strategy:** Memorize Articles + link to rights/duties + landmark amendments."
    ]
  }
],





      "directive-principles":[
        {
          slno: 1,
          title: "What is the Preamble of the Indian Constitution?",
          points: [
            "Introductory statement of the Constitution.",
            "Reflects aims, objectives, and philosophy of the Constitution.",
            "Based on Objective Resolution by Jawaharlal Nehru."
          ],
        },
        {
          slno: 2,
          title: "What are the key words in the Preamble?",
          points: [
            "Sovereign – Independent from foreign control.",
            "Socialist – Social and economic equality.",
            "Secular – Equal respect to all religions.",
            "Democratic – Govt by the people.",
            "Republic – Head of state is elected."
          ],
        },
        {
          slno: 3,
          title: "What ideals are mentioned in the Preamble?",
          points: [
            "Justice – Social, Economic, Political.",
            "Liberty – Thought, Expression, Belief, Faith, Worship.",
            "Equality – Status and opportunity.",
            "Fraternity – Brotherhood and unity."
          ],
        },
        {
          slno: 4,
          title: "Is the Preamble a part of the Constitution?",
          points: [
            "Yes, as held in Kesavananda Bharati case (1973).",
            "Can be amended but cannot alter basic structure."
          ],
        },
        {
          slno: 5,
          title: "What amendments were made to the Preamble?",
          points: [
            "42nd Amendment (1976) added Socialist, Secular, Integrity."
          ],
        },
        {
          slno: 6,
          title: "What are Directive Principles of State Policy (DPSP)?",
          points: [
            "Part IV (Art 36–51).",
            "Guidelines to central and state governments.",
            "Non-justiciable but fundamental in governance."
          ],
        },
        {
          slno: 7,
          title: "What is the aim of DPSP?",
          points: [
            "Achieve socio-economic democracy.",
            "Promote welfare state."
          ],
        },
        {
          slno: 8,
          title: "What are the categories of DPSP?",
          points: [
            "Socialist principles.",
            "Gandhian principles.",
            "Liberal-intellectual principles."
          ],
        },
        {
          slno: 9,
          title: "What are the Socialist principles in DPSP?",
          points: [
            "Minimize income inequalities.",
            "Secure right to adequate means of livelihood.",
            "Equal pay for equal work.",
            "Protection of children, youth, and workers."
          ],
        },
        {
          slno: 10,
          title: "What are the Gandhian principles in DPSP?",
          points: [
            "Promote cottage industries.",
            "Organize village panchayats.",
            "Prohibit intoxicating drinks and drugs.",
            "Promote rural self-sufficiency."
          ],
        },
        {
          slno: 11,
          title: "What are the Liberal-intellectual principles in DPSP?",
          points: [
            "Uniform civil code for all citizens.",
            "Promotion of international peace.",
            "Protection of monuments.",
            "Separation of judiciary from executive."
          ],
        },
        {
          slno: 12,
          title: "What is Article 36 in DPSP?",
          points: [
            "Defines 'State' same as in Part III (Fundamental Rights)."
          ],
        },
        {
          slno: 13,
          title: "What is Article 37 in DPSP?",
          points: [
            "DPSP not enforceable by court.",
            "But fundamental in governance."
          ],
        },
        {
          slno: 14,
          title: "What is Article 38 in DPSP?",
          points: [
            "Promote welfare of people.",
            "Minimize inequalities in income, status, opportunities."
          ],
        },
        {
          slno: 15,
          title: "What is Article 39 in DPSP?",
          points: [
            "Right to adequate means of livelihood.",
            "Equal pay for equal work.",
            "Avoid concentration of wealth."
          ],
        },
        {
          slno: 16,
          title: "What is Article 40 in DPSP?",
          points: [
            "Organization of village panchayats."
          ],
        },
        {
          slno: 17,
          title: "What is Article 41 in DPSP?",
          points: [
            "Right to work, education, public assistance in certain cases."
          ],
        },
        {
          slno: 18,
          title: "What is Article 42 in DPSP?",
          points: [
            "Just and humane conditions of work.",
            "Maternity relief."
          ],
        },
        {
          slno: 19,
          title: "What is Article 43 in DPSP?",
          points: [
            "Promote cottage industries.",
            "Living wage for workers."
          ],
        },
        {
          slno: 20,
          title: "What is Article 44 in DPSP?",
          points: [
            "Uniform Civil Code for all citizens."
          ],
        },
        {
          slno: 21,
          title: "What is Article 45 in DPSP?",
          points: [
            "Early childhood care and education for children below 6 years."
          ],
        },
        {
          slno: 22,
          title: "What is Article 46 in DPSP?",
          points: [
            "Promote educational and economic interests of SCs, STs, and other weaker sections."
          ],
        },
        {
          slno: 23,
          title: "What is Article 47 in DPSP?",
          points: [
            "Raise level of nutrition and public health.",
            "Prohibit intoxicating drinks and drugs."
          ],
        },
        {
          slno: 24,
          title: "What is Article 48 in DPSP?",
          points: [
            "Organize agriculture and animal husbandry.",
            "Prohibit slaughter of cows and milch cattle."
          ],
        },
        {
          slno: 25,
          title: "What is Article 49 in DPSP?",
          points: [
            "Protect monuments and places of artistic or historic interest."
          ],
        },
        {
          slno: 26,
          title: "What is Article 50 in DPSP?",
          points: [
            "Separate judiciary from executive."
          ],
        },
        {
          slno: 27,
          title: "What is Article 51 in DPSP?",
          points: [
            "Promote international peace and security.",
            "Maintain just and honourable relations between nations."
          ],
        },
        {
          slno: 28,
          title: "What are criticisms of DPSP?",
          points: [
            "Not legally enforceable.",
            "Vague and idealistic.",
            "Conflict with Fundamental Rights sometimes."
          ],
        },
        {
          slno: 29,
          title: "How are DPSP implemented?",
          points: [
            "Through laws, policies, and welfare schemes.",
            "Gradual and subject to resources."
          ],
        },
        {
          slno: 30,
          title: "What is the difference between DPSP and Fundamental Rights?",
          points: [
            "FRs are justiciable; DPSP are non-justiciable.",
            "FRs protect individual liberty; DPSP aim at welfare state."
          ],
        },

      ],



      "president-vice-president-and-judiciary":[
        {
          slno: 1,
          title: "Who is the President of India?",
          points: [
            "Constitutional head of the Union Executive.",
            "First citizen of India."
          ],
        },
        {
          slno: 2,
          title: "How is the President elected?",
          points: [
            "Indirect election by an electoral college.",
            "Includes elected MPs of both Houses and elected MLAs of states & UTs with legislatures."
          ],
        },
        {
          slno: 3,
          title: "What is the term of the President?",
          points: [
            "5 years from the date of entering office.",
            "Eligible for re-election."
          ],
        },
        {
          slno: 4,
          title: "What are the qualifications to be President?",
          points: [
            "Citizen of India.",
            "Minimum age: 35 years.",
            "Eligible to be elected as a member of Lok Sabha."
          ],
        },
        {
          slno: 5,
          title: "What are the powers of the President?",
          points: [
            "Executive powers – appointments, administration.",
            "Legislative powers – summoning, proroguing, dissolving Lok Sabha, assent to bills.",
            "Judicial powers – pardons, commutations.",
            "Emergency powers – national, state, financial."
          ],
        },
        {
          slno: 6,
          title: "What is the impeachment procedure for the President?",
          points: [
            "For violation of the Constitution.",
            "Requires special majority in both Houses."
          ],
        },
        {
          slno: 7,
          title: "Who is the Vice President of India?",
          points: [
            "Second-highest constitutional office.",
            "Ex-officio Chairman of Rajya Sabha."
          ],
        },
        {
          slno: 8,
          title: "How is the Vice President elected?",
          points: [
            "By members of both Houses of Parliament.",
            "Uses proportional representation by single transferable vote."
          ],
        },
        {
          slno: 9,
          title: "What is the term of the Vice President?",
          points: [
            "5 years from the date of entering office.",
            "Eligible for re-election."
          ],
        },
        {
          slno: 10,
          title: "What are the qualifications to be Vice President?",
          points: [
            "Citizen of India.",
            "Minimum age: 35 years.",
            "Eligible to be elected as a member of Rajya Sabha."
          ],
        },
        {
          slno: 11,
          title: "What are the functions of the Vice President?",
          points: [
            "Presides over Rajya Sabha.",
            "Acts as President in case of vacancy until a new President is elected."
          ],
        },
        {
          slno: 12,
          title: "Who is the Governor?",
          points: [
            "Nominal executive head of the state.",
            "Appointed by the President."
          ],
        },
        {
          slno: 13,
          title: "What is the term of the Governor?",
          points: [
            "5 years from date of appointment.",
            "Holds office at the pleasure of the President."
          ],
        },
        {
          slno: 14,
          title: "What are the qualifications to be Governor?",
          points: [
            "Citizen of India.",
            "Minimum age: 35 years."
          ],
        },
        {
          slno: 15,
          title: "What are the powers of the Governor?",
          points: [
            "Executive powers – appointments, administration.",
            "Legislative powers – summoning, proroguing, dissolving state assembly, assent to bills.",
            "Judicial powers – pardons, commutations for state laws.",
            "Emergency powers in state."
          ],
        },
        {
          slno: 16,
          title: "What is the role of the Judiciary in India?",
          points: [
            "Interprets and protects the Constitution.",
            "Ensures rule of law and justice."
          ],
        },
        {
          slno: 17,
          title: "What are the levels of Judiciary in India?",
          points: [
            "Supreme Court (apex court).",
            "High Courts.",
            "Subordinate courts."
          ],
        },
        {
          slno: 18,
          title: "What is the composition of the Supreme Court?",
          points: [
            "Chief Justice of India and other judges (sanctioned strength decided by Parliament)."
          ],
        },
        {
          slno: 19,
          title: "What are the qualifications to be a Supreme Court judge?",
          points: [
            "Citizen of India.",
            "Judge of High Court for 5 years or advocate in High Court for 10 years or distinguished jurist."
          ],
        },
        {
          slno: 20,
          title: "What is the tenure of a Supreme Court judge?",
          points: [
            "Holds office until age of 65 years.",
            "Can resign or be removed by impeachment."
          ],
        },
        {
          slno: 21,
          title: "What are the powers of the Supreme Court?",
          points: [
            "Original jurisdiction – disputes between Union & states.",
            "Appellate jurisdiction – civil, criminal, constitutional appeals.",
            "Advisory jurisdiction – advice to President."
          ],
        },
        {
          slno: 22,
          title: "What is judicial review?",
          points: [
            "Power of courts to declare laws or actions unconstitutional."
          ],
        },
        {
          slno: 23,
          title: "What is judicial activism?",
          points: [
            "Judiciary’s proactive role in protecting rights and ensuring justice.",
            "Often through Public Interest Litigations (PILs)."
          ],
        },
        {
          slno: 24,
          title: "What are High Courts?",
          points: [
            "Highest court at the state level.",
            "One in each state or group of states."
          ],
        },
        {
          slno: 25,
          title: "What are subordinate courts?",
          points: [
            "District and session courts at the district level.",
            "Handle civil and criminal cases."
          ],
        },


      ],




      "important-amendments-and-judgements":[
        



        {
          slno: 1,
          title: "What was the Kesavananda Bharati vs State of Kerala (1973) case?",
          points: [
            "Introduced the Basic Structure doctrine.",
            "Parliament can amend Constitution but cannot alter its basic structure."
          ],
        },
        {
          slno: 2,
          title: "What was the Golaknath vs State of Punjab (1967) case?",
          points: [
            "Held that Parliament cannot amend Fundamental Rights."
          ],
        },
        {
          slno: 3,
          title: "What was the Indira Nehru Gandhi vs Raj Narain (1975) case?",
          points: [
            "Struck down clause excluding judicial review of PM elections.",
            "Upheld judicial review as part of basic structure."
          ],
        },
        {
          slno: 4,
          title: "What was the Minerva Mills vs Union of India (1980) case?",
          points: [
            "Struck down part of 42nd Amendment.",
            "Balanced Fundamental Rights and DPSPs as part of basic structure."
          ],
        },
        {
          slno: 5,
          title: "What was the SR Bommai vs Union of India (1994) case?",
          points: [
            "Laid guidelines for imposition of President’s Rule.",
            "Secularism declared part of basic structure."
          ],
        },
        {
          slno: 6,
          title: "What was the Maneka Gandhi vs Union of India (1978) case?",
          points: [
            "Expanded Article 21 – Right to life includes right to live with dignity.",
            "Due process introduced in Indian context."
          ],
        },
        {
          slno: 7,
          title: "What was the Shreya Singhal vs Union of India (2015) case?",
          points: [
            "Struck down Section 66A of IT Act as unconstitutional.",
            "Upheld freedom of speech online."
          ],
        },
        {
          slno: 8,
          title: "What was the Navtej Singh Johar vs Union of India (2018) case?",
          points: [
            "Decriminalized consensual homosexuality.",
            "Struck down parts of Section 377 IPC."
          ],
        },
        {
          slno: 9,
          title: "What was the Justice K.S. Puttaswamy vs Union of India (2017) case?",
          points: [
            "Declared Right to Privacy as a Fundamental Right under Article 21."
          ],
        },
        {
          slno: 10,
          title: "What was the Vishaka vs State of Rajasthan (1997) case?",
          points: [
            "Laid guidelines to prevent sexual harassment at workplace."
          ],
        },
        {
          slno: 11,
          title: "What was the I.R. Coelho vs State of Tamil Nadu (2007) case?",
          points: [
            "Judicial review applies even to laws in Ninth Schedule if they violate basic structure."
          ],
        },
        {
          slno: 12,
          title: "What is the 1st Constitutional Amendment (1951)?",
          points: [
            "Added Ninth Schedule.",
            "Curbed freedom of speech, trade, and property rights."
          ],
        },
        {
          slno: 13,
          title: "What is the 24th Constitutional Amendment (1971)?",
          points: [
            "Parliament has power to amend any part of Constitution.",
            "President bound to give assent to Constitutional Amendment Bills."
          ],
        },
        {
          slno: 14,
          title: "What is the 25th Constitutional Amendment (1971)?",
          points: [
            "Curtailed right to property.",
            "Inserted Article 31C."
          ],
        },
        {
          slno: 15,
          title: "What is the 42nd Constitutional Amendment (1976)?",
          points: [
            "Known as ‘Mini Constitution’.",
            "Added Socialist, Secular, Integrity to Preamble.",
            "Strengthened central government powers."
          ],
        },
        {
          slno: 16,
          title: "What is the 44th Constitutional Amendment (1978)?",
          points: [
            "Reduced term of Lok Sabha and State Assemblies from 6 to 5 years.",
            "Restored powers of judiciary and FRs curtailed by 42nd Amendment."
          ],
        },
        {
          slno: 17,
          title: "What is the 52nd Constitutional Amendment (1985)?",
          points: [
            "Introduced anti-defection law (Tenth Schedule)."
          ],
        },
        {
          slno: 18,
          title: "What is the 61st Constitutional Amendment (1989)?",
          points: [
            "Reduced voting age from 21 to 18 years."
          ],
        },
        {
          slno: 19,
          title: "What is the 69th Constitutional Amendment (1991)?",
          points: [
            "Granted special status to Delhi as National Capital Territory."
          ],
        },
        {
          slno: 20,
          title: "What is the 73rd Constitutional Amendment (1992)?",
          points: [
            "Constitutional status to Panchayati Raj institutions.",
            "Added Part IX."
          ],
        },
        {
          slno: 21,
          title: "What is the 74th Constitutional Amendment (1992)?",
          points: [
            "Constitutional status to Urban Local Bodies.",
            "Added Part IXA."
          ],
        },
        {
          slno: 22,
          title: "What is the 86th Constitutional Amendment (2002)?",
          points: [
            "Made education a Fundamental Right for children 6–14 years (Art 21A)."
          ],
        },
        {
          slno: 23,
          title: "What is the 101st Constitutional Amendment (2016)?",
          points: [
            "Introduced Goods and Services Tax (GST)."
          ],
        },
        {
          slno: 24,
          title: "What is the 103rd Constitutional Amendment (2019)?",
          points: [
            "10% reservation for EWS in education and jobs."
          ],
        },
        {
          slno: 25,
          title: "What is the 104th Constitutional Amendment (2020)?",
          points: [
            "Removed Anglo-Indian reserved seats in Parliament and state legislatures."
          ],
        },

      ],




      "constitutional-and-non-constitutional-bodies":[

        
        {
          slno: 1,
          title: "What are Constitutional Bodies?",
          points: [
            "Established by the Constitution of India.",
            "Functions, powers, and structure defined in the Constitution."
          ],
        },
        {
          slno: 2,
          title: "What is the Election Commission of India (ECI)?",
          points: [
            "Constitutional body under Article 324.",
            "Conducts elections to Parliament, State Legislatures, and President/Vice President."
          ],
        },
        {
          slno: 3,
          title: "What is the Union Public Service Commission (UPSC)?",
          points: [
            "Constitutional body under Articles 315–323.",
            "Conducts exams for civil services and other central services."
          ],
        },
        {
          slno: 4,
          title: "What is the State Public Service Commission (SPSC)?",
          points: [
            "Constitutional body at the state level.",
            "Conducts exams for state civil services."
          ],
        },
        {
          slno: 5,
          title: "What is the Finance Commission?",
          points: [
            "Constitutional body under Article 280.",
            "Recommends distribution of tax revenue between Centre and states."
          ],
        },
        {
          slno: 6,
          title: "What is the National Commission for SCs?",
          points: [
            "Constitutional body under Article 338.",
            "Safeguards the interests of Scheduled Castes."
          ],
        },
        {
          slno: 7,
          title: "What is the National Commission for STs?",
          points: [
            "Constitutional body under Article 338A.",
            "Safeguards the interests of Scheduled Tribes."
          ],
        },
        {
          slno: 8,
          title: "What is the Comptroller and Auditor General (CAG) of India?",
          points: [
            "Constitutional body under Article 148.",
            "Audits accounts of Union, states, and public sector bodies."
          ],
        },
        {
          slno: 9,
          title: "What is the Attorney General of India?",
          points: [
            "Highest law officer of India.",
            "Appointed under Article 76.",
            "Advises Government of India on legal matters."
          ],
        },
        {
          slno: 10,
          title: "What are Non-Constitutional Bodies?",
          points: [
            "Created by executive orders or parliamentary laws.",
            "Not mentioned in the Constitution."
          ],
        },
        {
          slno: 11,
          title: "What is the NITI Aayog?",
          points: [
            "Policy think tank of the Government of India.",
            "Replaced Planning Commission in 2015."
          ],
        },
        {
          slno: 12,
          title: "What is the National Human Rights Commission (NHRC)?",
          points: [
            "Statutory body under the Protection of Human Rights Act, 1993.",
            "Protects and promotes human rights."
          ],
        },
        {
          slno: 13,
          title: "What is the Central Information Commission (CIC)?",
          points: [
            "Statutory body under RTI Act, 2005.",
            "Decides appeals and complaints regarding RTI."
          ],
        },
        {
          slno: 14,
          title: "What are Emergency Provisions in the Indian Constitution?",
          points: [
            "Part XVIII (Articles 352–360).",
            "Three types – National, State, and Financial."
          ],
        },
        {
          slno: 15,
          title: "What is National Emergency?",
          points: [
            "Proclaimed under Article 352.",
            "On grounds of war, external aggression, or armed rebellion.",
            "Effects: Centre gains more power, FRs restricted."
          ],
        },
        {
          slno: 16,
          title: "What is State Emergency (President’s Rule)?",
          points: [
            "Proclaimed under Article 356.",
            "When state government cannot function as per Constitution.",
            "Parliament takes over state legislature powers."
          ],
        },
        {
          slno: 17,
          title: "What is Financial Emergency?",
          points: [
            "Proclaimed under Article 360.",
            "When financial stability or credit of India is threatened.",
            "President can reduce salaries, control financial matters."
          ],
        },
        {
          slno: 18,
          title: "What are the effects of National Emergency on Fundamental Rights?",
          points: [
            "FRs under Article 19 automatically suspended.",
            "Other FRs can be suspended by President’s order except Articles 20 and 21."
          ],
        },
        {
          slno: 19,
          title: "What is the duration of National Emergency?",
          points: [
            "Initially 1 month (after 44th Amendment) – must be approved by both Houses within that period.",
            "Can be extended for 6 months at a time."
          ],
        },
        {
          slno: 20,
          title: "What is the maximum period of President’s Rule in a state?",
          points: [
            "6 months at a time.",
            "Maximum of 3 years with parliamentary approval and special conditions."
          ],
        }

      ],



      "parliament":[

        {
          slno: 1,
          title: "What is the Parliament of India?",
          points: [
            "Supreme legislative body of India.",
            "Consists of President, Lok Sabha, and Rajya Sabha."
          ],
        },
        {
          slno: 2,
          title: "What are the components of the Indian Parliament?",
          points: [
            "President of India.",
            "Lok Sabha (House of the People).",
            "Rajya Sabha (Council of States)."
          ],
        },
        {
          slno: 3,
          title: "What is the composition of Lok Sabha?",
          points: [
            "Maximum strength: 552 members.",
            "530 from states, 20 from UTs, 2 nominated by President (Anglo-Indians) – nomination provision now removed by 104th Amendment (2020)."
          ],
        },
        {
          slno: 4,
          title: "What is the composition of Rajya Sabha?",
          points: [
            "Maximum strength: 250 members.",
            "238 representatives of states & UTs, 12 nominated by President from literature, science, art, and social service."
          ],
        },
        {
          slno: 5,
          title: "What is the term of Lok Sabha members?",
          points: [
            "5 years from the date of its first sitting.",
            "Can be dissolved earlier by President."
          ],
        },
        {
          slno: 6,
          title: "What is the term of Rajya Sabha members?",
          points: [
            "6 years.",
            "One-third members retire every 2 years.",
            "It is a permanent house and cannot be dissolved."
          ],
        },
        {
          slno: 7,
          title: "What are the qualifications to be a Lok Sabha member?",
          points: [
            "Citizen of India.",
            "Minimum age: 25 years.",
            "Other qualifications prescribed by Parliament."
          ],
        },
        {
          slno: 8,
          title: "What are the qualifications to be a Rajya Sabha member?",
          points: [
            "Citizen of India.",
            "Minimum age: 30 years.",
            "Other qualifications prescribed by Parliament."
          ],
        },
        {
          slno: 9,
          title: "What are the powers and functions of Parliament?",
          points: [
            "Legislative powers – make laws on Union and Concurrent Lists.",
            "Financial powers – control over budget and taxation.",
            "Executive control – through questions, motions, and debates.",
            "Judicial powers – impeachment of President, removal of judges."
          ],
        },
        {
          slno: 10,
          title: "What are the special powers of Rajya Sabha?",
          points: [
            "Can authorize Parliament to make laws on State List subjects (Art 249).",
            "Can authorize creation of All-India Services (Art 312)."
          ],
        },
        {
          slno: 11,
          title: "What are the special powers of Lok Sabha?",
          points: [
            "Money bills can only be introduced in Lok Sabha.",
            "Confidence and no-confidence motions are passed only in Lok Sabha."
          ],
        },
        {
          slno: 12,
          title: "What is a Money Bill?",
          points: [
            "Deals only with taxation, borrowing, expenditure from Consolidated Fund.",
            "Can be introduced only in Lok Sabha with President's recommendation.",
            "Rajya Sabha can only recommend changes; Lok Sabha may accept or reject."
          ],
        },
        {
          slno: 13,
          title: "What is a Financial Bill?",
          points: [
            "Covers financial matters but not exclusively money matters.",
            "Requires approval of both houses."
          ],
        },
        {
          slno: 14,
          title: "What is the procedure for passing an ordinary bill?",
          points: [
            "Can be introduced in either house.",
            "Must be passed by both houses and get President’s assent."
          ],
        },
        {
          slno: 15,
          title: "What is the procedure for passing a constitutional amendment bill?",
          points: [
            "Can be introduced in either house.",
            "Requires special majority in both houses.",
            "Some amendments need ratification by half the state legislatures."
          ],
        },
        {
          slno: 16,
          title: "What is a Joint Sitting of Parliament?",
          points: [
            "Presided over by Lok Sabha Speaker.",
            "Summoned by President to resolve deadlock on a bill.",
            "Not applicable for Money Bills and Constitutional Amendments."
          ],
        },
        {
          slno: 17,
          title: "What are the privileges of Parliament and its members?",
          points: [
            "Freedom of speech in Parliament.",
            "Immunity from legal action for speeches/votes.",
            "Right to regulate internal proceedings."
          ],
        },
        {
          slno: 18,
          title: "What is the role of the President in Parliament?",
          points: [
            "Part of Parliament but does not sit in either house.",
            "Summons, prorogues sessions, and dissolves Lok Sabha.",
            "Assent to bills."
          ],
        },
        {
          slno: 19,
          title: "What is Question Hour in Parliament?",
          points: [
            "First hour of a sitting for asking questions to ministers.",
            "Types: Starred, Unstarred, Short Notice."
          ],
        },
        {
          slno: 20,
          title: "What is Zero Hour in Parliament?",
          points: [
            "Immediately after Question Hour.",
            "Members raise urgent matters without prior notice."
          ],
        },
        {
          slno: 21,
          title: "What is Adjournment Motion?",
          points: [
            "Introduced to discuss urgent matters of public importance.",
            "Needs support of 50 members to be admitted."
          ],
        },
        {
          slno: 22,
          title: "What is No-Confidence Motion?",
          points: [
            "Introduced in Lok Sabha to test government’s majority.",
            "If passed, council of ministers must resign."
          ],
        },
        {
          slno: 23,
          title: "What is a Censure Motion?",
          points: [
            "Expresses disapproval of specific policies/actions of the government.",
            "Does not require resignation if passed."
          ],
        },
        {
          slno: 24,
          title: "What are the types of parliamentary sessions?",
          points: [
            "Budget Session – Feb to May.",
            "Monsoon Session – Jul to Sep.",
            "Winter Session – Nov to Dec."
          ],
        },
        {
          slno: 25,
          title: "What is the role of the Speaker of Lok Sabha?",
          points: [
            "Presides over Lok Sabha meetings.",
            "Maintains order and decorum.",
            "Decides if a bill is a money bill."
          ],
        },
        {
          slno: 26,
          title: "What is the role of the Chairman of Rajya Sabha?",
          points: [
            "Vice-President of India acts as Chairman.",
            "Presides over Rajya Sabha meetings."
          ],
        },
        {
          slno: 27,
          title: "What is the role of Parliamentary Committees?",
          points: [
            "Small groups of MPs to examine bills, budgets, and policies.",
            "Types: Standing Committees, Ad hoc Committees."
          ],
        },
        {
          slno: 28,
          title: "What is the difference between Lok Sabha and Rajya Sabha?",
          points: [
            "Lok Sabha: Directly elected, 5-year term, can be dissolved.",
            "Rajya Sabha: Indirectly elected, 6-year term, permanent."
          ],
        },


      ],

    },





    biology: {
      "cell-structure":[
        {
          slno: 1,
          title: "Definition of Cell",
          points: [
            "Basic structural and functional unit of life.",
            "Coined by Robert Hooke in 1665 (in cork).",
            "First living cell seen by Anton van Leeuwenhoek."
          ]
        },
        {
          slno: 2,
          title: "Cell Theory",
          points: [
            "Proposed by Schleiden & Schwann.",
            "Modified by Rudolf Virchow → 'Omnis cellula e cellula' (all cells arise from pre-existing cells).",
            "All organisms are made of cells.",
            "Cell is the basic unit of structure and function.",
            "All cells come from pre-existing cells."
          ]
        },
        {
          slno: 3,
          title: "Prokaryotic vs Eukaryotic Cells",
          points: [
            "Nucleus: Absent (Prokaryotic) / Present (Eukaryotic).",
            "Membrane-bound organelles: Absent (Prokaryotic) / Present (Eukaryotic).",
            "Examples: Bacteria, Blue-green algae (Prokaryotic) / Plants, Animals, Fungi (Eukaryotic)."
          ]
        },
        {
          slno: 4,
          title: "Cell Shapes",
          points: [
            "Variable: Spherical, spindle-shaped, cuboidal, etc.",
            "Related to function.",
            "Examples: RBC – biconcave, nerve cell – long."
          ]
        },
        {
          slno: 5,
          title: "Cell Size",
          points: [
            "Smallest: Mycoplasma (~0.1 µm).",
            "Largest: Ostrich egg (15 cm).",
            "Longest: Nerve cell."
          ]
        },
        {
          slno: 6,
          title: "Cell Components",
          points: [
            "Cell membrane (Plasma membrane).",
            "Cytoplasm.",
            "Nucleus.",
            "Organelles (in eukaryotes)."
          ]
        },
        {
          slno: 7,
          title: "Plasma Membrane",
          points: [
            "Semi-permeable, controls entry/exit.",
            "Made of lipid bilayer + proteins.",
            "Davson-Danielli model: protein-lipid-protein.",
            "Fluid mosaic model: Singer and Nicolson."
          ]
        },
        {
          slno: 8,
          title: "Cell Wall",
          points: [
            "Found in plants, fungi, bacteria.",
            "Provides shape and protection.",
            "Plant cell wall is made of cellulose."
          ]
        },
        {
          slno: 9,
          title: "Cytoplasm",
          points: [
            "Jelly-like fluid inside cell.",
            "Contains organelles, enzymes, etc.",
            "Site for metabolic reactions."
          ]
        },
        {
          slno: 10,
          title: "Nucleus",
          points: [
            "Control center of cell.",
            "Contains nuclear membrane, nucleoplasm, nucleolus, and chromatin.",
            "Nucleolus makes rRNA.",
            "During division, chromatin condenses into chromosomes."
          ]
        },
        {
          slno: 11,
          title: "Chromosomes",
          points: [
            "Made of DNA + proteins.",
            "Carry genes (hereditary units)."
          ]
        },
        {
          slno: 12,
          title: "Cell Organelles (Eukaryotic)",
          points: [
            "Endoplasmic Reticulum (Rough ER: protein synthesis; Smooth ER: lipid synthesis, detoxification).",
            "Golgi Apparatus: Packaging, modifying, transporting materials, makes lysosomes.",
            "Lysosomes: 'Suicidal bags', digestive enzymes, breaks down waste.",
            "Mitochondria: 'Powerhouse of the cell', site of cellular respiration, double membrane, own DNA.",
            "Plastids (plants only): Chloroplasts (photosynthesis), Chromoplasts (pigments), Leucoplasts (storage).",
            "Vacuoles: Storage sac for water, waste, food (large in plants, small in animals).",
            "Ribosomes: Protein synthesis (70S in prokaryotes, 80S in eukaryotes).",
            "Centrosome/Centrioles: Found in animal cells, role in cell division."
          ]
        },
        {
          slno: 13,
          title: "Differences: Plant vs Animal Cells",
          points: [
            "Cell wall: Present (Plant) / Absent (Animal).",
            "Vacuole: Large, central (Plant) / Small, many (Animal).",
            "Plastids: Present (Plant) / Absent (Animal).",
            "Centrosome: Absent (Plant) / Present (Animal).",
            "Shape: Regular (Plant) / Irregular (Animal)."
          ]
        },
        {
          slno: 14,
          title: "Functions of Cell Organelles (One-liners)",
          points: [
            "Nucleus – Controls all activities.",
            "ER – Transport & synthesis (proteins/lipids).",
            "Golgi – Packaging and modification.",
            "Lysosome – Digestion.",
            "Mitochondria – Energy (ATP) production.",
            "Chloroplast – Photosynthesis.",
            "Vacuole – Storage.",
            "Ribosomes – Protein making.",
            "Centrioles – Cell division."
          ]
        },
        {
          slno: 15,
          title: "Microscopy and Cell Discovery Timeline",
          points: [
            "Robert Hooke (1665): Coined 'Cell'.",
            "Leeuwenhoek (1674): First living cell.",
            "Schleiden & Schwann: Cell theory.",
            "Virchow: All cells from cells."
          ]
        }        
      ],



      "tissues":[
        {
          slno: 1,
          title: "Definition of Tissue",
          points: [
            "Group of similar cells performing a specific function.",
            "Originates from the same source in the embryo."
          ],
        },
        {
          slno: 2,
          title: "Plant Tissues - Types",
          points: [
            "Meristematic tissue – actively dividing cells.",
            "Permanent tissue – cells lose division ability, perform specific functions."
          ],
        },
        {
          slno: 3,
          title: "Meristematic Tissue - Types",
          points: [
            "Apical meristem – at root/shoot tips; increases length.",
            "Intercalary meristem – at nodes; increases length of internodes.",
            "Lateral meristem (cambium) – increases girth."
          ],
        },
        {
          slno: 4,
          title: "Features of Meristematic Tissue",
          points: [
            "Small, thin-walled cells with dense cytoplasm.",
            "Large nucleus, no vacuoles."
          ],
        },
        {
          slno: 5,
          title: "Permanent Tissue - Types",
          points: [
            "Simple permanent tissue – only one type of cell.",
            "Complex permanent tissue – different types of cells working together."
          ],
        },
        {
          slno: 6,
          title: "Simple Permanent Tissue",
          points: [
            "Parenchyma – thin-walled, living, storage & photosynthesis.",
            "Collenchyma – living, irregular thickening, support.",
            "Sclerenchyma – dead, thick lignified walls, mechanical support."
          ],
        },
        {
          slno: 7,
          title: "Complex Permanent Tissue",
          points: [
            "Xylem – transport water & minerals (tracheids, vessels, xylem parenchyma, xylem fibres).",
            "Phloem – transport food (sieve tubes, companion cells, phloem parenchyma, phloem fibres)."
          ],
        },
        {
          slno: 8,
          title: "Protective Tissues",
          points: [
            "Epidermis – outer protective layer.",
            "Cork (phellem) – dead cells, prevents water loss."
          ],
        },
        {
          slno: 9,
          title: "Animal Tissues - Types",
          points: [
            "Epithelial tissue – covers surfaces & lines cavities.",
            "Connective tissue – connects/supports body parts.",
            "Muscular tissue – movement.",
            "Nervous tissue – conduction of impulses."
          ],
        },
        {
          slno: 10,
          title: "Epithelial Tissue - Types",
          points: [
            "Squamous – flat cells, diffusion.",
            "Cuboidal – cube-shaped, secretion/absorption.",
            "Columnar – tall cells, absorption/secretion.",
            "Ciliated – movement of particles.",
            "Glandular – secretion."
          ],
        },
        {
          slno: 11,
          title: "Connective Tissue - Types",
          points: [
            "Areolar – binds tissues.",
            "Adipose – fat storage.",
            "Bone – rigid support.",
            "Cartilage – flexible support.",
            "Blood – transport medium."
          ],
        },
        {
          slno: 12,
          title: "Muscular Tissue - Types",
          points: [
            "Striated (skeletal) – voluntary, multinucleated.",
            "Unstriated (smooth) – involuntary, single nucleus.",
            "Cardiac – involuntary, branched, intercalated discs."
          ],
        },
        {
          slno: 13,
          title: "Nervous Tissue",
          points: [
            "Neuron – structural and functional unit.",
            "Cell body, dendrites, axon.",
            "Transmits impulses."
          ],
        }        
      ],





      "life-processes":[
        {
          slno: 1,
          title: "Life Processes",
          points: [
            "Life processes are activities essential for maintaining life: nutrition, respiration, transportation, excretion.",
            "All living organisms perform these processes to survive and reproduce."
          ],
        },
        {
          slno: 2,
          title: "Nutrition",
          points: [
            "Process of obtaining and utilizing food for energy and growth.",
            "Two types: Autotrophic (self-making food, e.g., plants) & Heterotrophic (depend on others, e.g., animals)."
          ],
        },
        {
          slno: 3,
          title: "Autotrophic Nutrition",
          points: [
            "Photosynthesis: Process in plants converting CO₂ + H₂O to glucose using sunlight & chlorophyll.",
            "Equation: 6CO₂ + 6H₂O → C₆H₁₂O₆ + 6O₂.",
            "Steps: Light absorption → Conversion to chemical energy → Synthesis of glucose."
          ],
        },
        {
          slno: 4,
          title: "Heterotrophic Nutrition",
          points: [
            "Holozoic: Ingestion → Digestion → Absorption → Assimilation → Egestion (e.g., humans).",
            "Saprophytic: Feeding on dead matter (e.g., fungi).",
            "Parasitic: Feeding on host (e.g., tapeworm)."
          ],
        },
        {
          slno: 5,
          title: "Human Digestive System",
          points: [
            "Mouth: Mechanical digestion (teeth) + Salivary amylase (starch → maltose).",
            "Oesophagus: Transports food to stomach.",
            "Stomach: Gastric juice (HCl, pepsin) → proteins digestion; kills bacteria.",
            "Small Intestine: Bile (emulsifies fats), Pancreatic juice (enzymes for proteins, carbs, fats).",
            "Large Intestine: Water absorption.",
            "Anus: Egestion."
          ],
        },
        {
          slno: 6,
          title: "Respiration",
          points: [
            "Biological process releasing energy from food.",
            "Aerobic: With oxygen → complete oxidation → CO₂ + H₂O + Energy (ATP).",
            "Anaerobic: Without oxygen → partial breakdown → alcohol/lactic acid + less energy."
          ],
        },
        {
          slno: 7,
          title: "Human Respiratory System",
          points: [
            "Nostrils → Pharynx → Larynx → Trachea → Bronchi → Bronchioles → Alveoli.",
            "Alveoli: Site of gas exchange.",
            "O₂ diffuses into blood; CO₂ diffuses out.",
            "Breathing: Inhalation (diaphragm contracts), Exhalation (diaphragm relaxes)."
          ],
        },
        {
          slno: 8,
          title: "Transportation in Humans",
          points: [
            "Circulatory system: Heart, blood, blood vessels.",
            "Heart: 4 chambers – right atrium, right ventricle, left atrium, left ventricle.",
            "Double circulation: Blood passes heart twice per cycle.",
            "Blood vessels: Arteries (away from heart), Veins (to heart), Capillaries (exchange)."
          ],
        },
        {
          slno: 9,
          title: "Transportation in Plants",
          points: [
            "Xylem: Transports water & minerals (root → leaves) via transpiration pull.",
            "Phloem: Transports food (leaves → rest of plant) via translocation."
          ],
        },
        {
          slno: 10,
          title: "Excretion in Humans",
          points: [
            "Removal of nitrogenous wastes (urea, uric acid).",
            "Excretory system: Kidneys, ureters, urinary bladder, urethra.",
            "Nephron: Functional unit – filters blood & forms urine.",
            "Urine formation: Filtration → Reabsorption → Secretion."
          ],
        },
        {
          slno: 11,
          title: "Excretion in Plants",
          points: [
            "Waste products: O₂, CO₂, water, resins, gums.",
            "Removal via stomata, lenticels, old leaves."
          ],
        },
        {
          "slno": 12,
          "title": "Asexual Reproduction",
          "points": [
            "Single parent involved; no gamete formation.",
            "Rapid process; genetically identical offspring.",
            "Types: Fission, Fragmentation, Regeneration, Spore Formation, Budding, Vegetative Propagation."
          ]
        },
        {
          "slno": 13,
          "title": "Fission",
          "points": [
            "Binary fission: 2 daughter cells (e.g., Amoeba).",
            "Multiple fission: Multiple daughter cells (e.g., Plasmodium).",
            "Occurs in cyst walls during unfavorable conditions."
          ]
        },
        {
          "slno": 14,
          "title": "Fragmentation & Regeneration",
          "points": [
            "Fragmentation: Organism splits into pieces → new organisms (e.g., Planaria).",
            "Regeneration: Regrowth of lost body parts (e.g., Lizard)."
          ]
        },
        {
          "slno": 15,
          "title": "Spore Formation",
          "points": [
            "Spores produced in sporangium (e.g., Fungi).",
            "Hyphae release spores for reproduction."
          ]
        },
        {
          "slno": 16,
          "title": "Budding",
          "points": [
            "Bud forms on parent → detaches (e.g., Hydra, Yeast).",
            "Yeast: Cytoplasm divides; chain formation occurs."
          ]
        },
        {
          "slno": 17,
          "title": "Vegetative Propagation",
          "points": [
            "New plants from vegetative parts (leaves/stem/roots).",
            "Natural: Runners (strawberry), Bulbs (onion), Tubers (potato).",
            "Artificial: Cutting, Grafting (scion + stock), Layering."
          ]
        },
        {
          "slno": 18,
          "title": "Asexual Reproduction: Pros/Cons",
          "points": [
            "Advantages: Rapid, no mates needed, preserves positive traits.",
            "Disadvantages: No genetic diversity, species vulnerability to environmental changes."
          ]
        },
        {
          "slno": 19,
          "title": "Sexual Reproduction in Plants",
          "points": [
            "Flower structure: Stamen (male; anther/pollen), Pistil (female; stigma/style/ovary).",
            "Bisexual flowers: Contain both stamen and pistil (e.g., Hibiscus).",
            "Unisexual flowers: Only stamen or pistil (e.g., Papaya)."
          ]
        },
        {
          "slno": 20,
          "title": "Pollination",
          "points": [
            "Self-pollination: Pollen → stigma of same flower.",
            "Cross-pollination: Pollen → stigma of different plant via wind/water/animals.",
            "Agents: Anemophily (wind), Entomophily (insects), Hydrophily (water)."
          ]
        },
        {
          "slno": 21,
          "title": "Fertilization in Plants",
          "points": [
            "Double fertilization: One sperm fuses with egg → zygote (2n); other with polar nuclei → endosperm (3n).",
            "Post-fertilization: Ovule → seed, Ovary → fruit.",
            "Embryo sac: 7 cells; synergids guide pollen tube."
          ]
        },
        {
          "slno":22,
          "title": "Human Male Reproductive System",
          "points": [
            "Testes: Produce sperm/testosterone; contain seminiferous tubules.",
            "Accessory glands: Seminal vesicles (fructose fluid), Prostate gland (alkaline fluid).",
            "Ducts: Vas deferens (sperm transport), Urethra (common urine/semen passage)."
          ]
        },
        {
          "slno": 23,
          "title": "Human Female Reproductive System",
          "points": [
            "Ovaries: Produce ova/estrogen/progesterone.",
            "Accessory organs: Uterus (fetal development), Fallopian tubes (fertilization site), Vagina.",
            "Menstrual cycle: 28-day cycle regulated by FSH, LH, estrogen, progesterone."
          ]
        },
        {
          "slno": 24,
          "title": "Reproductive Health",
          "points": [
            "STDs: Gonorrhea, syphilis (bacterial); HIV, warts (viral).",
            "Birth control: Condoms, pills, IUDs (copper/hormonal), surgical (vasectomy/tubectomy).",
            "IVF: In vitro fertilization for infertility."
          ]
        },
          {
            "slno": 25,
            "title": "Blood Grouping",
            "points": [
              "ABO system: Based on A/B antigens on RBCs; plasma contains anti-A/anti-B antibodies.",
              "Rh system: Rh+ (antigen present), Rh- (antigen absent); mismatched transfusion causes antibody formation.",
              "Universal donor: O-; Universal recipient: AB+."
            ]
          },
          {
            "slno": 26,
            "title": "Cardiovascular System",
            "points": [
              "Heart attack: Blocked coronary artery → myocardial infarction.",
              "Cardiac arrest: Electrical malfunction → irregular heartbeat.",
              "Cholesterol: HDL (good), LDL/VLDL (bad)."
            ]
          },
          {
            "slno": 27,
            "title": "Excretory System",
            "points": [
              "Nitrogenous wastes: Ammonotelic (aquatic), Ureotelic (mammals), Uricotelic (birds/reptiles).",
              "Human kidneys: Bean-shaped, 10-12 cm; contain nephrons (functional units).",
              "Nephron components: Glomerulus (filtration), PCT (reabsorption), LoH (osmolarity), DCT (secretion), Collecting duct (water balance)."
            ]
          },
          {
            "slno": 28,
            "title": "Blood Pressure Regulation",
            "points": [
              "Renin-angiotensin: Increases BP via vasoconstriction & Na⁺ reabsorption.",
              "ANF (Atrial Natriuretic Factor): Decreases BP via vasodilation."
            ]
          },
          {
            "slno": 29,
            "title": "Nervous System",
            "points": [
              "CNS: Brain (fore/mid/hind) + Spinal cord.",
              "PNS: Somatic (voluntary), Autonomic (involuntary; sympathetic 'fight/flight', parasympathetic 'rest/digest').",
              "Neuron structure: Dendrites → Cell body → Axon → Synapse."
            ]
          },
          {
            "slno": 30,
            "title": "Brain Functions",
            "points": [
              "Cerebrum: Reasoning, speech, memory.",
              "Cerebellum: Balance, coordination.",
              "Medulla: Involuntary functions (breathing/heartbeat).",
              "Hypothalamus: Hunger/thirst, hormone regulation."
            ]
          },
          {
            "slno": 31,
            "title": "Reflex Action",
            "points": [
              "Arc: Receptor → Sensory neuron → Spinal cord → Motor neuron → Effector.",
              "Automatic response (e.g., knee jerk)."
            ]
          },
          {
            "slno": 32,
            "title": "Endocrine System",
            "points": [
              "Pituitary: Master gland; GH (growth), disorders: Dwarfism/Gigantism/Acromegaly.",
              "Thyroid: Thyroxine (metabolism); Goiter (iodine deficiency).",
              "Pancreas: Insulin (↓ glucose), Glucagon (↑ glucose); Diabetes.",
              "Adrenals: Adrenaline (fight/flight), Aldosterone (Na⁺/K⁺ balance).",
              "Gonads: Testosterone (male), Estrogen/Progesterone (female)."
            ]
          },
          {
            "slno": 33,
            "title": "Plant Hormones",
            "points": [
              "Auxins: Cell elongation, apical dominance, phototropism.",
              "Gibberellins: Stem growth, seed germination.",
              "Cytokinins: Cell division, shoot formation.",
              "Abscisic Acid (ABA): Stress hormone, dormancy.",
              "Ethylene: Fruit ripening, leaf abscission."
            ]
          },
          {
            "slno": 34,
            "title": "Plant Movements",
            "points": [
              "Tropic: Directional (Phototropism, Geotropism, Chemotropism).",
              "Nastic: Non-directional (Thigmonasty - touch, Seismonasty - shock).",
              "Examples: Roots show +ve geotropism; Mimosa folds leaves on touch."
            ]
          }
      ],




      "human-health-and-diseases":[
          {
            "slno": 1,
            "title": "Immunity Types",
            "points": [
              "Innate immunity: Non-specific, present at birth (skin, mucus, stomach acid).",
              "Acquired immunity: Specific, develops during lifetime (B/T cells, antibodies).",
              "Active immunity: Body produces antibodies (infection/vaccine).",
              "Passive immunity: Antibodies received externally (maternal/artificial)."
            ]
          },
          {
            "slno": 2,
            "title": "Defense Mechanisms",
            "points": [
              "First line: Physical barriers (skin, mucus), secretions (tears, saliva).",
              "Second line: Inflammation, fever, phagocytes (macrophages/neutrophils).",
              "Third line: Adaptive immunity (B cells: antibodies, T cells: cell-mediated)."
            ]
          },
          {
            "slno": 3,
            "title": "Vaccination",
            "points": [
              "Introduces weakened pathogen to trigger immune response.",
              "Edward Jenner: Smallpox vaccine (cowpox virus).",
              "Examples: BCG (TB), OPV (polio), DTP (diphtheria/pertussis/tetanus)."
            ]
          },
          {
            "slno": 4,
            "title": "Diseases by Pathogens",
            "points": [
              "Protozoan: Malaria (Plasmodium), Amoebiasis (Entamoeba), Kala-azar (Leishmania).",
              "Bacterial: Cholera (Vibrio), TB (Mycobacterium), Tetanus (Clostridium).",
              "Viral: AIDS (HIV), Dengue (Flavivirus), Chickenpox (Varicella).",
              "Fungal: Ringworm, Athlete's foot.",
              "Helminth: Filaria (Wuchereria → elephantiasis)."
            ]
          },
          {
            "slno": 5,
            "title": "Disease Classification",
            "points": [
              "Infectious: Transmissible (pathogens; e.g., COVID-19, TB).",
              "Non-infectious: Non-transmissible (genetics/lifestyle; e.g., diabetes, cancer).",
              "Communicable: Spread directly/indirectly (e.g., hepatitis, food-borne).",
              "Contagious: Highly transmissible by contact (e.g., flu, COVID-19)."
            ]
          },
          {
            "slno": 6,
            "title": "Nutrition & Deficiencies",
            "points": [
              "Macronutrients: Carbs (4kcal/g), Proteins (4kcal/g), Fats (9kcal/g).",
              "Vitamins: A (vision), D (bone), E (antioxidant), K (clotting), B-complex (metabolism).",
              "Minerals: Iron (anemia), Iodine (goiter), Calcium (osteoporosis).",
              "Deficiency disorders: Scurvy (Vit C), Beriberi (B1), Pellagra (B3)."
            ]
          },
          {
            "slno": 7,
            "title": "Transmission Types",
            "points": [
              "Water-borne: Cholera, Typhoid (contaminated water/food).",
              "Air-borne: TB, Influenza, COVID-19 (respiratory droplets).",
              "Vector-borne: Malaria (Anopheles), Dengue (Aedes), Filaria (Culex)."
            ]
          },
          {
            "slno": 8,
            "title": "Heavy Metal Poisoning",
            "points": [
              "Cadmium: Itai-itai disease (bone/kidney damage).",
              "Mercury: Minamata disease (neurological damage).",
              "Lead: Plumbism (developmental delays, anemia).",
              "Arsenic: Skin lesions, cancer."
            ]
          },
          {
            "slno": 9,
            "title": "Autoimmune & Other",
            "points": [
              "Autoimmune disorders: Body attacks own tissues (e.g., rheumatoid arthritis).",
              "Heavy metal sources: Industrial waste, contaminated water, lead paints.",
              "HIV progression: Destroys CD4 cells → AIDS without ART treatment."
            ]
          },
        ],




      "diversity":[
            {
              "slno": 1,
              "title": "Biodiversity & Classification",
              "points": [
                "Biodiversity: Variety of life forms (~10 million species) maintaining ecological balance.",
                "Classification systems: Aristotle (habitat/stem size), Whittaker (5 kingdoms), Woese (6 kingdoms).",
                "Taxonomy: Science of identification/nomenclature/classification; Linnaeus (binomial system).",
                "Hierarchy: Kingdom→Phylum→Class→Order→Family→Genus→Species."
              ]
            },
            {
              "slno": 2,
              "title": "Five Kingdoms",
              "points": [
                "Monera: Prokaryotic, unicellular (bacteria, cyanobacteria).",
                "Protista: Unicellular eukaryotes (Amoeba, Euglena); locomotion via pseudopodia/cilia/flagella.",
                "Fungi: Eukaryotic, heterotrophic, chitin cell walls (yeast, mushrooms); lichens (fungi-algae symbiosis).",
                "Plantae: Eukaryotic, multicellular, autotrophic, cellulose cell walls.",
                "Animalia: Eukaryotic, multicellular, heterotrophic, no cell walls."
              ]
            },
            {
              "slno": 3,
              "title": "Plant Kingdom Divisions",
              "points": [
                "Thallophyta: Undifferentiated body (algae); aquatic; primary producers (e.g., Spirogyra).",
                "Bryophyta: 'Amphibians'; no vascular tissues; rhizoids (mosses, liverworts); prevent soil erosion.",
                "Pteridophyta: Vascular tissues; roots/stems/leaves (ferns); cryptogams (hidden reproduction).",
                "Gymnosperms: Naked seeds, perennial (pines, cycas); largest ovule in Cycas.",
                "Angiosperms: Flowering plants; seeds in fruits; monocots (parallel venation) vs dicots (reticulate venation)."
              ]
            },
            {
              "slno": 4,
              "title": "Animal Kingdom Classification",
              "points": [
                "Basis: Symmetry (radial/bilateral), germ layers (diploblastic/triploblastic), coelom (acoelomate/pseudocoelomate/coelomate).",
                "Porifera: Porous, sessile (sponges); canal system.",
                "Cnidaria: Radial symmetry, cnidocytes (jellyfish, corals).",
                "Platyhelminthes: Flatworms, acoelomate (tapeworms); flame cells excretion.",
                "Nematoda: Pseudocoelomate (roundworms); cause elephantiasis."
              ]
            },
            {
              "slno": 5,
              "title": "Advanced Animal Phyla",
              "points": [
                "Annelida: Segmented, coelomate (earthworms); nephridia excretion.",
                "Arthropoda: Largest phylum; exoskeleton, jointed legs; open circulation (insects, spiders).",
                "Mollusca: Soft-bodied; muscular foot (octopus, snails); open circulation.",
                "Echinodermata: Spiny skin; radial symmetry (starfish); water vascular system.",
                "Chordata: Notochord, dorsal nerve cord; vertebrates (fish to mammals)."
              ]
            },
            {
              "slno": 6,
              "title": "Vertebrate Classes",
              "points": [
                "Pisces: Aquatic, gills, scales; 2-chambered heart; cold-blooded (fish).",
                "Amphibia: Dual life; mucus skin; 3-chambered heart (frogs).",
                "Reptilia: Scales; lungs; mostly 3-chambered heart; amniotic eggs (lizards, snakes).",
                "Aves: Feathers; wings; 4-chambered heart; warm-blooded (birds).",
                "Mammalia: Hair, mammary glands; viviparous (mostly); warm-blooded (humans, whales)."
              ]
            },
            {
              "slno": 7,
              "title": "Plant Modifications",
              "points": [
                "Roots: Storage (carrot, beetroot).",
                "Stems: Storage (potato tubers); support (tendrils).",
                "Leaves: Water/nutrient storage (aloe); insect-trapping (Venus flytrap).",
                "Seeds: Nutrient storage for germination (cotyledons)."
              ]
            }
      ],



      "genetics":[
        {
          slno: 1,
          title: "Introduction to Genetics",
          points: [
            "Branch of biology dealing with **heredity** and **variation** in organisms.",
            "Founded by **Gregor Johann Mendel** (Father of Genetics).",
            "Studies how traits are passed from **parents to offspring** via **genes**."
          ]
        },
        {
          slno: 2,
          title: "Mendel's Experiments",
          points: [
            "Conducted on **pea plants (Pisum sativum)**.",
            "Introduced concept of **dominant** and **recessive traits**.",
            "Proposed **3 Laws of Inheritance** based on monohybrid & dihybrid crosses."
          ]
        },
        {
          slno: 3,
          title: "Mendel's Laws",
          points: [
            "**Law of Segregation**: Allele pairs separate during gamete formation, ensuring purity of gametes.",
            "**Law of Dominance**: One allele dominates over the other in heterozygous conditions.",
            "**Law of Independent Assortment**: Genes for different traits assort independently."
          ]
        },
        {
          slno: 4,
          title: "Gene & Allele",
          points: [
            "Gene: Functional unit of inheritance, made of **DNA**.",
            "Allele: Alternate forms of a gene controlling a trait.",
            "Homozygous: Same alleles (AA/aa); Heterozygous: Different alleles (Aa)."
          ]
        },
        {
          slno: 5,
          title: "Chromosomes",
          points: [
            "Structures made of **DNA and proteins** found in the nucleus.",
            "Humans have **46 chromosomes (23 pairs)**: 22 pairs autosomes + 1 pair sex chromosomes.",
            "Sex chromosomes: **XX** in females, **XY** in males."
          ]
        },
        {
          slno: 6,
          title: "DNA & RNA",
          points: [
            "**DNA**: Double-helical molecule discovered by **Watson & Crick** in 1953.",
            "Stores genetic information; composed of sugar, phosphate, and nitrogen bases (A, T, G, C).",
            "**RNA**: Single-stranded; involved in protein synthesis; bases: A, U, G, C."
          ]
        },
        {
          slno: 7,
          title: "Central Dogma of Genetics",
          points: [
            "Proposed by **Francis Crick**.",
            "Flow of genetic information: **DNA → RNA → Protein**.",
            "Includes transcription (DNA to RNA) and translation (RNA to protein)."
          ]
        },
        {
          slno: 8,
          title: "Genetic Code",
          points: [
            "Set of rules defining how nucleotide sequences code for amino acids.",
            "Triplet code: Each set of 3 bases = 1 amino acid.",
            "Universal, non-overlapping, and degenerate."
          ]
        },
        {
          slno: 9,
          title: "Mutation",
          points: [
            "Sudden, heritable change in **DNA sequence**.",
            "Types: Point mutation, chromosomal mutation, frameshift mutation.",
            "Causes: Radiation, chemicals, errors during replication.",
            "Example: Sickle-cell anemia caused by substitution mutation."
          ]
        },
        {
          slno: 10,
          title: "Genetic Disorders",
          points: [
            "Two main types: **Single-gene disorders** & **Chromosomal disorders**.",
            "Single-gene examples: Cystic fibrosis, Huntington’s disease, Sickle-cell anemia.",
            "Chromosomal examples: Down’s syndrome (Trisomy 21), Turner’s syndrome (XO), Klinefelter’s syndrome (XXY)."
          ]
        },
        {
          slno: 11,
          title: "Sex Determination in Humans",
          points: [
            "Controlled by **XY system**.",
            "Male gamete (sperm) decides the sex: contributes either **X** or **Y** chromosome.",
            "XX → Female; XY → Male."
          ]
        },
        {
          slno: 12,
          title: "Blood Groups & Genetics",
          points: [
            "Discovered by **Karl Landsteiner**.",
            "ABO blood group system controlled by multiple alleles (**IA, IB, i**).",
            "Inheritance shows **co-dominance** (IA and IB expressed together in AB group)."
          ]
        },
        {
          slno: 13,
          title: "DNA Fingerprinting",
          points: [
            "Technique developed by **Alec Jeffreys**.",
            "Used for identification, paternity tests, and forensic analysis.",
            "Based on variations in DNA sequences."
          ]
        },
        {
          slno: 14,
          title: "Genetic Engineering",
          points: [
            "Artificial modification of genes to obtain desired traits.",
            "Applications: Recombinant DNA technology, cloning, gene therapy.",
            "Example: Production of insulin using genetically modified bacteria."
          ]
        },
        {
          slno: 15,
          title: "CDS Exam Focus",
          points: [
            "Weightage: ~5–7 questions in GS Biology.",
            "Most frequently asked topics:",
            "• Mendelian laws and crosses.",
            "• Chromosome numbers & sex determination.",
            "• Blood groups & co-dominance.",
            "• Genetic disorders & examples.",
            "• Central dogma and mutations.",
            "**Strategy:** Focus on laws, examples, disorders & DNA concepts."
          ]
        }

      ]
    },






    history:{
"harappan-civilisation-and-vedic-period": [
  {
    slno: 1,
    title: "Harappan Civilisation (Indus Valley)",
    points: [
      "Period: 2500–1750 BCE (Bronze Age).",
      "Urban features: grid pattern, drainage system, baked bricks.",
      "Major sites: Harappa, Mohenjo-daro, Lothal, Dholavira.",
      "Economy: agriculture (wheat, barley, cotton), trade (Mesopotamia), seals.",
      "Religion: Mother Goddess, Pashupati seal, no temples.",
      "Decline: flood, invasion, decline in trade."
    ]
  },
  {
    slno: 2,
    title: "Vedic Period",
    points: [
      "Early Vedic (1500–1000 BCE): Rigveda (oldest text). Pastoral, cows wealth symbol.",
      "Political: family → tribe → jana; assemblies sabha, samiti.",
      "Later Vedic (1000–600 BCE): agriculture, iron, kingdoms (janapadas).",
      "Religion: many gods (Indra, Agni, Varuna → later Vishnu, Shiva, Prajapati).",
      "Society: varna system, patriarchal.",
      "Texts: Samaveda, Yajurveda, Atharvaveda, Upanishads."
    ]
  }
],

"mahajanpadas-to-maurya-period": [
  {
    slno: 1,
    title: "Mahajanapadas",
    points: [
      "6th century BCE: 16 mahajanapadas.",
      "Magadha strongest (Bimbisara, Ajatashatru).",
      "Rise of Buddhism (Gautama Buddha) and Jainism (Mahavira).",
      "Republics like Vajji confederacy."
    ]
  },
  {
    slno: 2,
    title: "Maurya Empire",
    points: [
      "Founded by Chandragupta Maurya (321 BCE) with Chanakya’s help.",
      "Capital: Pataliputra.",
      "Megasthenes: Greek ambassador (Indica).",
      "Ashoka (273–232 BCE): Kalinga war → Dhamma & spread of Buddhism.",
      "Arthashastra by Chanakya: statecraft, economy.",
      "Decline after Ashoka (weak successors, Sungas replaced)."
    ]
  }
],

"post-mauryan-to-gupta-phase": [
  {
    slno: 1,
    title: "Post-Mauryan Kingdoms",
    points: [
      "Shungas, Kanvas, Satavahanas, Indo-Greeks, Kushanas.",
      "Kanishka (Kushana ruler): 4th Buddhist Council at Kashmir, patron of Gandhara art, spread of Mahayana Buddhism.",
      "Satavahanas: Gautamiputra Satakarni, promoted trade."
    ]
  },
  {
    slno: 2,
    title: "Gupta Empire (320–550 CE)",
    points: [
      "Chandragupta I (founder), Samudragupta (military campaigns).",
      "Chandragupta II (Vikramaditya): Ujjain capital, patron of Kalidasa.",
      "Economy: flourishing trade, gold coins (dinars).",
      "Science: Aryabhatta (zero, pi), Kalidasa (literature).",
      "Known as Golden Age of India.",
      "Decline: Hun invasions, feudal lords."
    ]
  }
],

"sangam-age-and-post-gupta-phase": [
  {
    slno: 1,
    title: "Sangam Age",
    points: [
      "Tamil Sangams (literary assemblies).",
      "Major kingdoms: Cholas, Cheras, Pandyas.",
      "Economy: trade with Romans, agriculture.",
      "Literature: Sangam poems, Silappadikaram, Manimekalai."
    ]
  },
  {
    slno: 2,
    title: "Post-Gupta Period",
    points: [
      "Harshavardhana (606–647 CE): capital Kannauj, patron of Nalanda, wrote plays.",
      "Chinese pilgrim Xuanzang visited during Harsha.",
      "Decline of centralized power, rise of regional kingdoms."
    ]
  }
],

"tripartite-struggle-and-south-indian-kingdom": [
  {
    slno: 1,
    title: "Tripartite Struggle",
    points: [
      "Rashtrakutas (Dantidurga, Krishna I), Palas (Dharmapala), Pratiharas (Nagabhata).",
      "Struggle for control of Kannauj (8th–10th century CE).",
      "Rashtrakutas: patronized Kailash Temple (Ellora)."
    ]
  },
  {
    slno: 2,
    title: "South Indian Kingdoms",
    points: [
      "Cholas: Rajaraja I, Rajendra I (naval power, conquest of Sri Lanka, SE Asia).",
      "Chola administration: village self-government, Brihadeshwara temple.",
      "Later Cheras and Pandyas flourished."
    ]
  }
],

"rise-of-rajput-kingdoms-and-arab-invasion": [
  {
    slno: 1,
    title: "Rajput Kingdoms",
    points: [
      "Period: 7th–12th century CE.",
      "Prithviraj Chauhan defeated by Muhammad Ghori (1192, Second Battle of Tarain).",
      "Rajputs known for valor and chivalry but disunity."
    ]
  },
  {
    slno: 2,
    title: "Arab Invasions",
    points: [
      "Muhammad bin Qasim conquered Sindh (712 CE).",
      "Arabs brought Islam, science, mathematics to India.",
      "Limited success due to strong Rajput resistance."
    ]
  }
],

"delhi-sultanate-vijaynagae-empire-and-bhakti": [
  {
    slno: 1,
    title: "Delhi Sultanate (1206–1526)",
    points: [
      "Founded by Qutbuddin Aibak (Slave Dynasty).",
      "Major dynasties: Slave, Khalji, Tughlaq, Sayyid, Lodi.",
      "Alauddin Khalji: market control, south expansion.",
      "Muhammad bin Tughlaq: failed experiments (token currency, capital shift).",
      "Architecture: Qutub Minar, Alai Darwaza."
    ]
  },
  {
    slno: 2,
    title: "Vijayanagara Empire (1336–1565)",
    points: [
      "Founded by Harihara & Bukka.",
      "Krishnadevaraya (greatest ruler, patron of Telugu literature).",
      "Hampi: capital, rich architecture.",
      "Defeated in Battle of Talikota (1565)."
    ]
  },
  {
    slno: 3,
    title: "Bhakti & Sufi Movements",
    points: [
      "Bhakti saints: Kabir, Mirabai, Tulsidas.",
      "Sufi saints: Khwaja Moinuddin Chishti.",
      "Promoted religious harmony, devotion over rituals."
    ]
  }
],

"mughal-empire-maratha": [
  {
    slno: 1,
    title: "Mughal Empire (1526–1857)",
    points: [
      "Founded by Babur (1526, First Battle of Panipat vs Ibrahim Lodi).",
      "Akbar (1556–1605): Din-i-Ilahi, mansabdari system, religious tolerance.",
      "Shah Jahan: Taj Mahal, Red Fort.",
      "Aurangzeb: expanded empire but religious orthodoxy weakened Mughals.",
      "Decline due to weak successors, invasions (Nadir Shah, Abdali)."
    ]
  },
  {
    slno: 2,
    title: "Marathas",
    points: [
      "Shivaji (1627–1680): guerrilla warfare, Ashta Pradhan council.",
      "Successors: Peshwas expanded influence.",
      "Defeat in Third Battle of Panipat (1761) weakened Marathas.",
      "Later fought British till Anglo-Maratha wars (ended 1818)."
    ]
  }
],

"arrival-of-europeans-and-establishment-of-british-rule": [
  {
    slno: 1,
    title: "Arrival of Europeans",
    points: [
      "Portuguese (Vasco da Gama, 1498, Calicut).",
      "Dutch, French, English followed.",
      "Portuguese decline; English East India Company dominant."
    ]
  },
  {
    slno: 2,
    title: "British Expansion",
    points: [
      "Battle of Plassey (1757): British defeated Siraj-ud-Daulah.",
      "Battle of Buxar (1764): secured Diwani rights in Bengal, Bihar, Orissa.",
      "Subsidiary Alliance (Wellesley), Doctrine of Lapse (Dalhousie).",
      "1857 Revolt: First War of Independence, led to Crown Rule (1858)."
    ]
  }
]



    },





    geography:{
      "geomorphology":[
        {
          "slno": 1,
          "title": "Universe Fundamentals",
          "points": [
            "Universe: All-encompassing space containing matter, energy, time; includes celestial bodies.",
            "Distance units: Astronomical Unit (AU=150M km), Light year (9.46×10¹² km), Parsec (3.26 light years).",
            "Cosmological theories: Monistic (single origin) vs Dualistic (dual principles)."
          ]
        },
        {
          "slno": 2,
          "title": "Planetary Formation Theories",
          "points": [
            "Gaseous Hypothesis (Kant): Cold gas particles → collisions → nebula → planets.",
            "Nebular Hypothesis (Laplace): Rotating hot nebula → rings → planets.",
            "Interstellar Dust Hypothesis (Schmidt): Sun captured interstellar matter → planets.",
            "Planetesimal Hypothesis: Star passed near Sun → pulled matter → planetesimals."
          ]
        },
        {
          "slno": 3,
          "title": "Universe Evolution Models",
          "points": [
            "Big Bang Theory: Singularity explosion 13.7B yrs ago → ongoing expansion → atom formation in 3 mins.",
            "Pulsating Theory: Alternating expansion/contraction cycles (Allen Sundes).",
            "Steady-State Theory: Continuous matter creation during expansion (Bond/Gold/Hoyle).",
            "Composition: Dark energy (68.3%), dark matter (26.8%), atoms (4.9%)."
          ]
        },
        {
          "slno": 4,
          "title": "Celestial Bodies",
          "points": [
            "Stars: Formed from H/He gas collapse; life cycle: protostar → giant → dwarf/black hole.",
            "Brightest star: Sirius A; Twinkling caused by atmospheric refraction.",
            "Galaxies: Gravity-bound star systems; Milky Way (spiral), Andromeda (nearest spiral).",
            "Types: Spiral (M101), Elliptical (ESO 325-G004), Irregular (NGC 1569)."
          ]
        },
        {
          "slno": 5,
          "title": "Solar System",
          "points": [
            "Age: 4.6B years; Diameter: 100+ AU; Sun: 99.8% system mass (H/He composition).",
            "Asteroid Belt: Rocky bodies between Mars/Jupiter orbits.",
            "Meteoroids: Space rocks → Meteors (atmospheric entry) → Meteorites (ground impact).",
            "Comets: Frozen gas/dust bodies that glow near Sun."
          ]
        },
        {
          "slno": 6,
          "title": "Planets - Terrestrial",
          "points": [
            "Mercury: Smallest; closest to Sun; thin O₂/Na atmosphere.",
            "Venus: Earth's twin; brightest; CO₂ clouds with sulfuric acid.",
            "Earth: Habitable; 1 AU from Sun; 78% N₂, 21% O₂ atmosphere; 1 moon.",
            "Mars: Red planet; Olympus Mons (tallest volcano); moons: Phobos/Deimos."
          ]
        },
        {
          "slno": 7,
          "title": "Planets - Gas Giants",
          "points": [
            "Jupiter: Largest; fastest rotation (10hr day); 95 moons; Ganymede (largest moon).",
            "Saturn: Prominent ice/dust rings; 145 moons.",
            "Uranus: Ice giant; sideways rotation.",
            "Neptune: Farthest (4.5B km); similar to Uranus."
          ]
        },
        {
          "slno": 8,
          "title": "Latitude & Climate",
          "points": [
            "Definition: Angular distance from equator (0°→90°N/S); 181 parallels.",
            "Key parallels: Equator, Tropic of Cancer (23.5°N), Tropic of Capricorn (23.5°S).",
            "Heat zones: Torrid (equator), Temperate (mid-latitudes), Frigid (poles).",
            "Equator countries: Congo, Brazil, Indonesia, Maldives, Kenya."
          ]
        },
        {
          "slno": 9,
          "title": "Longitude & Time",
          "points": [
            "Definition: Angular distance from Prime Meridian (0°→180°E/W); 360 meridians.",
            "Time calculation: 15° = 1 hour; 1° = 4 minutes.",
            "Prime Meridian countries: UK, France, Spain, Ghana, Algeria.",
            "India's STD: 82°30'E; IDL: ~180° longitude (calendar day separator)."
          ]
        },
        {
          "slno": 10,
          "title": "Rocks & Earth Structure",
          "points": [
            "Rocks: Aggregates of minerals; form Earth's crust.",
            "Types: Igneous (solidified lava), Sedimentary (layered deposits), Metamorphic (transformed under pressure).",
            "Pedogenesis: Rock weathering → soil formation."
          ]
        },
        {
          "slno": 11,
          "title": "Earth's Interior Structure",
          "points": [
            "Sources: Direct (mining, meteorites) & indirect (seismology, gravitation).",
            "Layers: Crust (5-70km), Mantle (35-2900km), Core (2900-6378km).",
            "Core composition: NIFE layer (nickel-iron); outer liquid, inner solid.",
            "Densities: Crust (2.7-3.0 g/cm³), Mantle (5.0 g/cm³), Core (11-15 g/cm³).",
            "Discontinuities: Moho (crust-mantle), Gutenberg (mantle-core), Lehmann (inner/outer core)."
          ]
        },
        {
          "slno": 12,
          "title": "Earthquake Dynamics",
          "points": [
            "Focus/hypocenter: Origin point; epicenter: Surface projection.",
            "Waves: P-waves (fastest, travel solids/liquids), S-waves (slower, only solids), Surface waves (most destructive).",
            "Shadow zones: S-wave absence (103°-143°) proves liquid outer core.",
            "Measurement: Richter scale (magnitude), Mercalli scale (intensity).",
            "Depth types: Shallow (0-70km), Intermediate (70-300km), Deep (300-700km)."
          ]
        },
        {
          "slno": 13,
          "title": "Continental Drift Theory",
          "points": [
            "Proposed by Alfred Wegener; supercontinent Pangaea existed 250M years ago.",
            "Evidence: Continental jigsaw fit, matching fossils (Mesosaurus), similar rock ages.",
            "Additional proofs: Coal in Antarctica, placer gold deposits (Ghana/Brazil).",
            "Rejected due to inadequate mechanism explanation.",
            "Forces: Tidal (moon/sun) and polar-fleeing (centrifugal)."
          ]
        },
        {
          "slno": 14,
          "title": "Plate Tectonics",
          "points": [
            "Proposed by McKenzie/Parker/Morgan (1967); plates = continental + oceanic lithosphere.",
            "Plate types: Major (Pacific, Eurasian) & minor (Nazca, Scotia).",
            "Boundaries: Divergent (ridges), Convergent (trenches/folds), Transform (sliding).",
            "Convection currents: Radioactive heat in mantle drives plate movement.",
            "Seafloor spreading: Mid-ocean ridges create new crust (youngest at center)."
          ]
        },
        {
          "slno": 15,
          "title": "Geomorphic Processes",
          "points": [
            "Endogenic: Internal forces (radioactive heat); cause diastrophism (slow) or sudden events (quakes).",
            "Exogenic: External forces (solar energy); cause weathering/erosion.",
            "Diastrophism: Epeirogenic (vertical), Orogenic (horizontal → folds/faults).",
            "Exogenic agents: Water, ice, wind, waves → landform leveling."
          ]
        },
        {
          "slno": 16,
          "title": "Weathering Types",
          "points": [
            "Physical: Frost wedging (ice expansion), thermal stress, pressure release.",
            "Chemical: Carbonation (H₂O+CO₂→H₂CO₃), hydration (mineral expansion), oxidation (rusting).",
            "Biological: Root growth, burrowing organisms (earthworms).",
            "Dominant in hot/humid regions; affects shallow rock layers."
          ]
        },
        {
          "slno": 17,
          "title": "Erosional Agents & Landforms",
          "points": [
            "Fluvial (water): V-shaped valleys, waterfalls, potholes, meanders (mature stage).",
            "Glacial: Horns, arêtes, U-shaped valleys (troughs), tarns.",
            "Aeolian (wind): Mushroom rocks, zeugen, sand dunes, inselbergs.",
            "Marine: Cliffs, beaches, sandbars (tsunami buffers).",
            "Groundwater: Karst topography (caves, sinkholes, stalactites)."
          ]
        },
        {
          "slno": 18,
          "title": "Depositional Landforms",
          "points": [
            "Fluvial: Floodplains, natural levees, alluvial fans, deltas (e.g., Ganges).",
            "Glacial: Moraines, drumlins, eskers.",
            "Aeolian: Loess plains, sand dunes (barchan/seif).",
            "Marine: Beaches, bars, spits, tombolos.",
            "Karst: Stalagmites, pillars (cave deposits)."
          ]
        },
        {
          "slno": 19,
          "title": "Mass Movements",
          "points": [
            "Downslope rock/debris transfer under gravity.",
            "Slow: Soil creep, solifluction.",
            "Rapid: Landslides, mudflows, avalanches.",
            "Factors: Slope angle, water content, vegetation absence."
          ]
        },
        {
          "slno": 20,
          "title": "Natural Disasters",
          "points": [
            "Earthquakes: Seismic waves cause surface shaking; focus depth classifies shallow/deep quakes.",
            "Tsunamis: Triggered by undersea quakes/volcanoes; wavelength >100km.",
            "Volcanism: Magma eruption; types: shield, composite, cinder cones.",
            "Disaster impact: Human/material loss; India faces 30+ disaster types."
          ]
        }

      ],



      "climatology":[
        {
          "slno": 1,
          "title": "Earthquake Causes & Distribution",
          "points": [
            "Causes: Volcanic activity, Tectonism (plate boundaries), Elastic Rebound (sudden energy release), Anthropogenic factors.",
            "Distribution: Pacific Ring of Fire (90% quakes), Mid-Atlantic Ridge, Alpine-Himalayan belt.",
            "India's zones: 5 seismic zones (Zone V highest risk)."
          ]
        },
        {
          "slno": 2,
          "title": "Volcanism Fundamentals",
          "points": [
            "Lava types: Basic (fluid, dark, Deccan Traps) vs Acidic (viscous, light, Mt. Pelee).",
            "Volcano classification: Active (Stromboli), Dormant (Fuji), Extinct (Koh Sultan).",
            "Eruption types: Central (cones), Fissure (flood basalts)."
          ]
        },
        {
          "slno": 3,
          "title": "Volcanic Landforms",
          "points": [
            "Intrusive: Batholith (massive), Laccolith (domed), Sill/Dyke (horizontal/vertical sheets).",
            "Extrusive: Cinder cones (ash), Composite cones (stratovolcanoes), Parasitic cones (side vents).",
            "Global distribution: Circum-Pacific belt (75% volcanoes), Mid-Atlantic Ridge."
          ]
        },
        {
          "slno": 4,
          "title": "Tsunami & Atmosphere",
          "points": [
            "Tsunami causes: Undersea quakes (90%), landslides, volcanic eruptions; wavelength >100km.",
            "Atmosphere origin: Volcanic outgassing → H₂O condensation → CO₂ washout → O₂ from cyanobacteria.",
            "Composition: N₂ (78%), O₂ (21%), CO₂ (0.04%), H₂O vapor (0-5%)."
          ]
        },
        {
          "slno": 5,
          "title": "Atmospheric Structure & Insolation",
          "points": [
            "Layers: Troposphere (weather, -6.4°C/km), Stratosphere (ozone), Mesosphere (-90°C), Thermosphere (auroras).",
            "Greenhouse gases: H₂O vapor, CO₂, CH₄, O₃ (blocks UV; measured in Dobson units).",
            "Insolation: Shortwave solar radiation (0.39-0.76µm); uneven distribution due to curvature."
          ]
        },
        {
          "slno": 6,
          "title": "Temperature Dynamics",
          "points": [
            "Heat transfer: Conduction (contact), Convection (fluids), Radiation (terrestrial longwave).",
            "Distribution factors: Latitude, Altitude, Distance from sea, Ocean currents, Albedo.",
            "Inversion: Temp ↑ with height; requires clear skies, long nights, stable air (e.g., valleys)."
          ]
        },
        {
          "slno": 7,
          "title": "Atmospheric Pressure Systems",
          "points": [
            "Measurement: Barometer; sea-level pressure = 1013 mb; isobars = equal pressure lines.",
            "Pressure belts: Equatorial Low (doldrums), Subtropical High (horse latitudes), Subpolar Low, Polar High.",
            "Controls: Thermal factors (heating → Low P), Dynamic factors (descending air → High P)."
          ]
        },
        {
          "slno": 8,
          "title": "Wind Systems",
          "points": [
            "Planetary winds: Trade winds (0-30°), Westerlies (30-60°), Polar Easterlies (60-90°).",
            "Coriolis effect: NH deflection → right, SH → left; strengthens with latitude.",
            "Roaring Forties: Powerful SH westerlies (40-50°S) due to minimal land barriers."
          ]
        },
        {
          "slno": 9,
          "title": "Local Winds",
          "points": [
            "Warm/dry: Chinook (Rockies), Foehn (Alps), Sirocco (Sahara→Med; 'blood rain').",
            "Cold/dry: Mistral (France), Bora (Adriatic), Blizzard (Siberia).",
            "Regional: Harmattan (Africa; 'doctor wind'), Loo (India), Zonda (Argentina)."
          ]
        },
        {
          "slno": 10,
          "title": "Diurnal Winds & Key Concepts",
          "points": [
            "Diurnal systems: Sea breeze (day), Land breeze (night), Valley breeze (day), Mountain breeze (night).",
            "Critical processes: Evaporation (liquid→vapor), Condensation (cloud formation).",
            "Pressure-altitude: ↓100mb/km (e.g., 1000mb at surface → 900mb at 1km)."
          ]
        },
        {
          "slno": 11,
          "title": "Wind Systems & Coriolis Effect",
          "points": [
            "Coriolis force: NH deflection → right, SH → left; strength ↑ with latitude.",
            "Planetary winds: Trade winds (0-30°), Westerlies (30-60°), Polar easterlies (60-90°).",
            "Roaring Forties: Strong SH westerlies (40-50°S) with minimal land barriers.",
            "Monsoon: Seasonal reversal; SW summer monsoon (rain-bearing), NE winter monsoon (dry)."
          ]
        },
        {
          "slno": 12,
          "title": "Local Winds",
          "points": [
            "Warm/dry: Chinook (Rockies), Foehn (Alps), Sirocco (Sahara→Med; 'blood rain').",
            "Cold/dry: Mistral (France/Spain), Bora (Adriatic), Blizzard (Siberia/Canada).",
            "Regional: Harmattan (W Africa; 'doctor wind'), Loo (India), Zonda (Argentina).",
            "Mediterranean winds: Sirocco, Khamsin, Mistral (Harmattan not Mediterranean)."
          ]
        },
        {
          "slno": 13,
          "title": "Diurnal Wind Cycles",
          "points": [
            "Sea breeze: Daytime (cool sea → warm land).",
            "Land breeze: Nighttime (cool land → warm sea).",
            "Valley breeze: Day (warm air ↑ slopes).",
            "Mountain breeze: Night (cool air ↓ valleys)."
          ]
        },
        {
          "slno": 14,
          "title": "Tropical Cyclones",
          "points": [
            "Formation: Warm oceans (>26°C), Coriolis force, pre-existing low pressure, moist air.",
            "Direction: E→W in tropics; NH anticlockwise, SH clockwise.",
            "Names: Cyclones (Indian Ocean), Hurricanes (Atlantic), Typhoons (Pacific).",
            "Dissipation: Over land (moisture cutoff); absent at equator (zero Coriolis)."
          ]
        },
        {
          "slno": 15,
          "title": "Temperate Cyclones",
          "points": [
            "Formation: 35-65° latitude; cold/warm air mass collision (frontogenesis).",
            "Movement: W→E with westerlies; diameter 1,900-2,500 km.",
            "Fronts: Cold (rapid uplift), Warm (gentle rain), Occluded (merged fronts).",
            "Weather: Continuous rain/snow over large areas."
          ]
        },
        {
          "slno": 16,
          "title": "Humidity & Condensation",
          "points": [
            "Humidity types: Absolute (g/m³), Specific (g/kg; temp-invariant), Relative (%).",
            "Dew point: Temp where RH=100%; condensation begins.",
            "Condensation nuclei: Dust/particles enabling fog/cloud formation.",
            "Evaporation: Liquid → vapor; driven by solar energy."
          ]
        },
        {
          "slno": 17,
          "title": "Fog & Clouds",
          "points": [
            "Fog types: Radiation (cold nights), Advection (moist air over cold surface), Evaporation (water bodies).",
            "High clouds (6-13km): Cirrus (wispy), Cirrostratus (halos), Cirrocumulus ('mackerel sky').",
            "Rain clouds: Nimbostratus (continuous rain), Cumulonimbus (thunderstorms).",
            "Cloud classification: By height (cirro-, alto-) and form (strato-, cumulo-)."
          ]
        },
        {
          "slno": 18,
          "title": "Precipitation Types",
          "points": [
            "Rain: Liquid drops >0.5mm diameter.",
            "Snow: Ice crystals at <0°C.",
            "Sleet: Rain/snow mix.",
            "Hail: Layered ice balls from strong updrafts.",
            "Virga: Evaporates before ground contact."
          ]
        },
        {
          "slno": 19,
          "title": "World Climatic Regions",
          "points": [
            "Equatorial: High rainfall (>200cm), uniform temps (27°C), rainforests (Amazon/Congo).",
            "Savanna: Seasonal rain (80-160cm), grasslands (Serengeti), acacia trees.",
            "Monsoon: Heavy summer rain, teak/sal forests (India/SE Asia).",
            "Desert: <25cm rain, xerophytes (cacti), nomadic tribes (Sahara/Kalahari).",
            "Mediterranean: Winter rain, citrus fruits, vineyards (olives/grapes)."
          ]
        },
        {
          "slno": 20,
          "title": "Koeppen Climate Classification",
          "points": [
            "A (Tropical): Avg cold month >18°C (Af, Am, Aw).",
            "B (Dry): Evaporation > precipitation (BWh, BSh).",
            "C (Temperate): Cold month -3°C to 18°C (Cfa, Cs, Cfb).",
            "D (Continental): Cold month ≤ -3°C (Df, Dw).",
            "E (Polar): Avg temp <10°C (ET, EF).",
            "H (Highland): Elevation-driven cold."
          ]
        }

      ],





      "oceanography":[
        {
          "slno": 1,
          "title": "Tropical Monsoon Climate",
          "points": [
            "Location: 5°-30° N/S equator (India, SE Asia, N. Australia)",
            "Rainfall: 200-250 cm/year (highest in Cherrapunji/Mawsynram)",
            "Vegetation: Deciduous forests (Teak, Sal, Eucalyptus)",
            "Agriculture: Wet paddy, wheat, cash crops (jute, tea, coffee)",
            "Tribes: Gond, Santhal, Munda, Kuki, Tharu"
          ]
        },
        {
          "slno": 2,
          "title": "Tropical Desert Climate",
          "points": [
            "Location: 15°-30° N/S on western coasts (Sahara, Arabian, Kalahari)",
            "Vegetation: Xerophytic (cacti, thorny bushes, wiry grasses)",
            "Tribes: Bushmen (Kalahari), Bindibu (Australia)"
          ]
        },
        {
          "slno": 3,
          "title": "Mediterranean Climate",
          "points": [
            "Location: 30°-45° N/S western coasts (Mediterranean, Cape Town, S. Australia)",
            "Vegetation: Oak, Eucalyptus, Pine, Cedar (small broad leaves)",
            "Economy: Citrus fruits, viticulture (world's orchard lands)"
          ]
        },
        {
          "slno": 4,
          "title": "China Type Climate",
          "points": [
            "Location: 20°-35° N/S eastern coasts",
            "Alternate names: Gulf type (N. America), Natal type (S. America)"
          ]
        },
        {
          "slno": 5,
          "title": "Arctic/Polar Climate",
          "points": [
            "Location: North of Arctic Circle/South of Antarctic Circle",
            "Vegetation: Tundra (mosses, lichens, no trees)",
            "Human Activity: Semi-nomadic (Eskimos), fishing/seal hunting"
          ]
        },
        {
          "slno": 6,
          "title": "Siberian Climate",
          "points": [
            "Location: 50°-70°N (Canada, Scandinavia, Russia)",
            "Precipitation: Snow in winter",
            "Vegetation: Taiga (coniferous forests)"
          ]
        },
        {
          "slno": 7,
          "title": "Laurentian Climate",
          "points": [
            "Location: NE North America (Canada, NE USA)",
            "Economy: Lumbering, fishing (leading exports)"
          ]
        },
        {
          "slno": 8,
          "title": "Koeppen Climate Classification",
          "points": [
            "A: Tropical (avg. coldest month >18°C)",
            "B: Dry (evaporation > precipitation)",
            "C: Warm temperate (coldest month -3°C to 18°C)",
            "D: Cold forest (coldest month ≤ -3°C)",
            "E: Polar (all months <10°C)",
            "Examples: Aw = Savannah, EF = Ice cap"
          ]
        },
        {
          "slno": 9,
          "title": "Ocean Relief Features",
          "points": [
            "Continental Shelf: Shallow, gently sloping",
            "Continental Slope: Steep drop-off",
            "Abyssal Plain: Deep flat ocean floor (75% of ocean)",
            "Ocean Ridges: Underwater mountain chains",
            "Trenches: Deepest parts (e.g., Mariana)"
          ]
        },
        {
          "slno": 10,
          "title": "Coral Reefs",
          "points": [
            "Formation: Coral polyps + zooxanthellae algae symbiosis",
            "Types: Fringing (coastal), Barrier (parallel to coast), Atoll (circular)",
            "Indian Reefs: Gulf of Mannar, Andamans, Lakshadweep, Gulf of Kutch",
            "Conditions: 20°-22°C water, <60m depth, salinity 27-30‰"
          ]
        },
        {
          "slno": 11,
          "title": "Ocean Salinity",
          "points": [
            "Definition: Dissolved salts in seawater (avg. 35‰)",
            "Composition: NaCl (77.8%), MgCl₂ (10.9%), MgSO₄ (4.7%)",
            "Sources: Volcanic eruptions, river inputs, mid-ocean ridges",
            "Distribution: Highest in tropics (20°-40° N/S), lowest at poles",
            "Factors: ↑Evaporation ↑Salinity, ↑Precipitation ↓Salinity"
          ]
        },
        {
          "slno": 12,
          "title": "Ocean Currents",
          "points": [
            "Types: Warm (equator → poles), Cold (poles → equator)",
            "Causes: Wind patterns, Earth's rotation, salinity/temperature gradients",
            "Major Currents: Gulf Stream (warm), Labrador (cold), Kuroshio (warm)",
            "Gyres: Circular systems (e.g., N. Pacific Gyre)"
          ]
        },
        {
          "slno": 13,
          "title": "Key Exam Concepts",
          "points": [
            "Coriolis Force: Deflects right in NH, left in SH (absent at equator)",
            "Ozone Layer: In stratosphere (absorbs UV radiation)",
            "Hadley Cells: Equator-driven wind circulation",
            "Barrier Islands: Sand formations parallel to coast (e.g., Padre Island)",
            "Hydrological Cycle: 84% ocean evaporation → 77% ocean precipitation"
          ]
        }

      ],



      "indian-geography":[












        {
          "slno": 1,
          "title": "Indian Drainage Systems",
          "points": [
            "Dendritic pattern: Tree-like branching (e.g., Ganga river system)",
            "Parallel pattern: Rivers flow parallel (e.g., Godavari, Krishna)",
            "Radial pattern: Rivers flow outward from central point (e.g., Narmada from Amarkantak)",
            "Centripetal pattern: Rivers converge into depression/lake",
            "Himalayan rivers: Perennial (Indus, Ganga, Brahmaputra)",
            "Peninsular rivers: Seasonal (east/west flowing)"
          ]
        },
        {
          "slno": 2,
          "title": "Major River Systems",
          "points": [
            "Indus: Originates Tibet, flows through India/Pakistan (3180 km)",
            "Indus Treaty (1960): India gets Ravi/Sutlej/Beas; Pakistan gets Indus/Jhelum/Chenab",
            "Ganga: Formed at Devprayag (Bhagirathi+Alaknanda), major tributaries: Yamuna, Ghaghra, Kosi",
            "Brahmaputra: Tsangpo in Tibet, enters India at Namcha Barwa, forms Majuli Island (world's largest river island)",
            "Peninsular rivers: Mahanadi (Odisha), Godavari (longest peninsula), Krishna, Kaveri, Narmada (west-flowing)"
          ]
        },
        {
          "slno": 3,
          "title": "River Projects & Dams",
          "points": [
            "Bhakra-Nangal: On Sutlej (Himachal/Punjab)",
            "Hirakud: Longest dam on Mahanadi (Odisha)",
            "Kaleshwaram Lift: On Godavari (Telangana)",
            "Sardar Sarovar: On Narmada (Gujarat)",
            "Tehri Dam: On Bhagirathi (Uttarakhand)"
          ]
        },
        {
          "slno": 4,
          "title": "Natural Vegetation Types",
          "points": [
            "Tropical Evergreen: High rainfall (NE India, Western Ghats, Andamans) - Ebony, Mahogany",
            "Tropical Deciduous: 100-200 cm rainfall (Teak, Sal) - Most widespread",
            "Thorn Forests: <50 cm rainfall (Rajasthan) - Cactus, Babool",
            "Montane Forests: Himalayan slopes (Deodar, Oak) - Kashmir stag habitat",
            "Mangroves: Coastal deltas (Sundarbans) - Sundari trees, protect coastlines"
          ]
        },
        {
          "slno": 5,
          "title": "Conservation Initiatives",
          "points": [
            "Forest Cover: 21.71% of India's area (MP has largest area)",
            "Biosphere Reserves: 18 UNESCO-recognized (e.g., Sundarbans, Gulf of Mannar)",
            "Tiger Reserves: 53 in India (e.g., Ranthambore, Bandipur)",
            "National Forest Policy (1988): Target 33% forest cover"
          ]
        },
        {
          "slno": 6,
          "title": "Soil Classification & Types",
          "points": [
            "Alluvial: 43% area (Indo-Gangetic plains) - Wheat/Rice cultivation",
            "Black Soil: Cotton-growing (Deccan Plateau), high water retention",
            "Laterite: High leaching (Kerala/Karnataka) - Brick-like when dry",
            "Arid: Sandy (Rajasthan), low organic matter",
            "Saline: High salt (Gujarat coast, Sundarbans) - Halophytes grow"
          ]
        },
        {
          "slno": 7,
          "title": "Soil Formation & Conservation",
          "points": [
            "Factors: Parent rock, climate, topography, vegetation",
            "Horizons: O (organic), A (topsoil), B (subsoil), C (weathered rock)",
            "Erosion types: Splash, rill, gully (e.g., Chambal ravines)",
            "Conservation: Contour ploughing, shelter belts, afforestation"
          ]
        },
        {
          "slno": 8,
          "title": "Land Use Categories",
          "points": [
            "Current Fallow: Left uncultivated <1 year",
            "Fallow Other: Uncultivated 1-5 years",
            "Culturable Wasteland: Uncultivated >5 years (reclaimable)",
            "Barren Land: Non-cultivable (hills/deserts)"
          ]
        },
        {
          "slno": 9,
          "title": "Key Geographical Facts",
          "points": [
            "Standard Meridian: 82°30'E (Mirzapur, UP)",
            "Underwater Metro Tunnel: On Hooghly river (Kolkata)",
            "Ten Degree Channel: Separates Andaman-Nicobar islands",
            "Largest Barrier Reef: Great Barrier Reef (Australia)"
          ]
        },
        {
          "slno": 10,
          "title": "Climate & Agriculture Links",
          "points": [
            "Alluvial Soil: Rice-wheat rotation (Punjab/Haryana)",
            "Black Soil: Cotton, sugarcane (Maharashtra)",
            "Laterite Soil: Cashew, tapioca (Kerala)",
            "Mountain Soil: Tea, fruits (Himalayan foothills)"
          ]
        }

      ],




      "world-geography":[

      ]

    },






    economics:{
      "basics-and-national-income-banking-and-finance": [
        {
          slno: 1,
          title: "Economics – Definition & Types",
          points: [
            "Economics: Study of production, distribution, and consumption of goods/services.",
            "Microeconomics – Individual units (households, firms).",
            "Macroeconomics – Aggregate economy (GDP, inflation, employment)."
          ]
        },
        {
          slno: 2,
          title: "Basic Economic Problems",
          points: [
            "What to produce – choice of goods/services.",
            "How to produce – method (labour-intensive/capital-intensive).",
            "For whom to produce – distribution among population.",
            "Efficient use of resources and economic growth."
          ]
        },
        {
          slno: 3,
          title: "National Income – Concepts",
          points: [
            "GDP – Gross Domestic Product (value of goods/services within country).",
            "GNP – GDP + Net income from abroad.",
            "NNP – GNP – Depreciation.",
            "National Income (at factor cost) = NNP – Indirect taxes + Subsidies.",
            "Per Capita Income = NI ÷ Population."
          ]
        },
        {
          slno: 4,
          title: "Methods of Measuring National Income",
          points: [
            "Production Method – Sum of value added in all sectors.",
            "Income Method – Sum of all factor incomes (wages, rent, interest, profit).",
            "Expenditure Method – Sum of consumption, investment, government expenditure, net exports."
          ]
        },
        {
          slno: 5,
          title: "Banking – Functions of Central Bank (RBI)",
          points: [
            "Issues currency.",
            "Controls credit & money supply.",
            "Acts as lender of last resort.",
            "Regulates commercial banks."
          ]
        },
        {
          slno: 6,
          title: "Commercial Banks – Functions",
          points: [
            "Accept deposits (savings, current, fixed).",
            "Provide loans/advances.",
            "Facilitate payments & remittances.",
            "Agency functions – collection of cheques, bills."
          ]
        },
        {
          slno: 7,
          title: "Inflation – Meaning & Types",
          points: [
            "Inflation – Continuous rise in general price level.",
            "Demand-pull inflation – Excess demand over supply.",
            "Cost-push inflation – Increased cost of production.",
            "Creeping, walking, running, hyperinflation – based on rate."
          ]
        },
        {
          slno: 8,
          title: "Effects & Control of Inflation",
          points: [
            "Reduces purchasing power of money.",
            "Hurts fixed income groups, benefits debtors.",
            "Control – Monetary policy (RBI) & Fiscal policy (Govt).",
            "Tools – CRR, SLR, repo rate, taxation, subsidies."
          ]
        }
      ],









      
      "money-policy": [
        {
          slno: 1,
          title: "Meaning of Utility",
          points: [
            "Utility is the satisfaction derived from consuming a good or service.",
            "It is subjective—varies from person to person and time to time.",
            "Measured in 'utils' (hypothetical units)."
          ],
        },
        {
          slno: 2,
          title: "Total Utility (TU)",
          points: [
            "Total satisfaction from consuming a given quantity of a good.",
            "TU increases as consumption increases—up to a point.",
            "Formula: TU = Sum of marginal utilities of all units consumed."
          ],
        },
        {
          slno: 3,
          title: "Marginal Utility (MU)",
          points: [
            "Extra satisfaction from consuming one more unit of a good.",
            "Formula: MU = Change in TU / Change in Quantity.",
            "MU decreases as more units are consumed (Law of Diminishing MU)."
          ],
        },
        {
          slno: 4,
          title: "Law of Diminishing Marginal Utility",
          points: [
            "As more units of a good are consumed, MU from each additional unit decreases.",
            "Example: First glass of water gives more satisfaction than the fifth.",
            "Key Assumptions: Consumer rationality, constant income, no change in tastes."
          ],
        },
        {
          slno: 5,
          title: "Relationship Between TU and MU",
          points: [
            "When MU is positive, TU increases.",
            "When MU is zero, TU is at maximum.",
            "When MU is negative, TU decreases."
          ],
        },
        {
          slno: 6,
          title: "Consumer Equilibrium (Cardinal Utility Approach)",
          points: [
            "Occurs when MU per unit of money spent is equal for all goods.",
            "Condition: MUx/Px = MUy/Py = MU of money.",
            "Ensures maximum total satisfaction given budget constraint."
          ],
        },
        {
          slno: 7,
          title: "Law of Equi-Marginal Utility",
          points: [
            "Consumers allocate expenditure so that MU per rupee is equal across goods.",
            "Helps in optimum resource allocation.",
            "Also called the Law of Substitution."
          ],
        },
        {
          slno: 8,
          title: "Indifference Curve (IC)",
          points: [
            "Shows different combinations of two goods giving equal satisfaction.",
            "Slope = Marginal Rate of Substitution (MRS).",
            "Properties: Downward sloping, convex to origin, do not intersect."
          ],
        },
        {
          slno: 9,
          title: "Marginal Rate of Substitution (MRS)",
          points: [
            "Rate at which a consumer is willing to give up one good for more of another while maintaining same satisfaction.",
            "MRS diminishes along an IC."
          ],
        },
        {
          slno: 10,
          title: "Budget Line",
          points: [
            "Represents all possible combinations of two goods that a consumer can buy given income and prices.",
            "Slope = Ratio of prices (Px/Py).",
            "Shifts occur with changes in income or prices."
          ],
        },
        {
          slno: 11,
          title: "Consumer Equilibrium (Ordinal Utility Approach)",
          points: [
            "Occurs at point of tangency between budget line and highest attainable IC.",
            "Condition: MRSxy = Px/Py."
          ],
        }        
      ],







      "fiscal-policy-and-budget":[
{
  slno: 1,
  title: "Fiscal Policy",
  points: [
    "Government policy related to revenue collection (taxation) and expenditure to influence the economy.",
    "Main instruments: Taxes, public expenditure, public borrowing, subsidies.",
    "Objectives: Economic growth, price stability, employment generation, equitable income distribution, reducing poverty.",
    "Acts as a tool for demand management during inflation/deflation."
  ],
},
{
  slno: 2,
  title: "Components of Fiscal Policy",
  points: [
    "Revenue Policy: Taxation (direct & indirect taxes), non-tax revenue measures (fees, dividends, PSU profits).",
    "Expenditure Policy: Development expenditure (infrastructure, education, health) and non-development expenditure (defence, subsidies, interest payments)."
  ],
},
{
  slno: 3,
  title: "Budget",
  points: [
    "Annual financial statement showing estimated revenue & expenditure of the government for a year.",
    "Mandated under Article 112 of Indian Constitution.",
    "Classified into Union Budget (Central Govt.) and State Budgets.",
    "Divided into Revenue Budget & Capital Budget."
  ],
},
{
  slno: 4,
  title: "Types of Budget",
  points: [
    "Balanced Budget: Revenue = Expenditure (rare in practice).",
    "Surplus Budget: Revenue > Expenditure (helps control inflation).",
    "Deficit Budget: Revenue < Expenditure (used for growth during slowdown).",
    "Gender Budgeting: Allocating resources for gender equality & women empowerment.",
    "Performance Budget: Shows output/results of expenditure."
  ],
},
{
  slno: 5,
  title: "Deficit Types",
  points: [
    "Revenue Deficit: Revenue Expenditure > Revenue Receipts.",
    "Fiscal Deficit: Total Expenditure > Total Receipts (excluding borrowings).",
    "Primary Deficit: Fiscal Deficit – Interest Payments.",
    "Effective Revenue Deficit: Revenue Deficit – Grants for creation of capital assets."
  ],
},
{
  slno: 6,
  title: "Budgetary Procedure in India",
  points: [
    "Stages: Preparation → Presentation → Parliamentary Approval → Implementation → Audit.",
    "Prepared by Ministry of Finance in consultation with NITI Aayog & ministries.",
    "Presented by Finance Minister in Lok Sabha (usually Feb 1).",
    "Passed as Money Bill; Rajya Sabha can only make recommendations."
  ],
},
{
  slno: 7,
  title: "Finance Commission",
  points: [
    "Constitutional body under Article 280; appointed every 5 years.",
    "Recommends distribution of tax revenues between Centre & States and among States.",
    "Suggests principles for grants-in-aid."
  ],
},
{
  slno: 8,
  title: "FRBM Act",
  points: [
    "Fiscal Responsibility and Budget Management Act (2003).",
    "Aims to reduce fiscal deficit, eliminate revenue deficit, and ensure long-term macroeconomic stability.",
    "Mandates government to set targets for fiscal indicators."
  ],
},
{
  slno: 9,
  title: "Public Debt",
  points: [
    "Borrowings by government to finance expenditure when revenue is insufficient.",
    "Internal Debt: Market loans, treasury bills, borrowings from RBI/public.",
    "External Debt: Loans from foreign countries, institutions (World Bank, IMF).",
    "Excessive debt can lead to debt trap."
  ],
},
{
  slno: 10,
  title: "Role of Fiscal Policy in India",
  points: [
    "Promotes economic growth by financing infrastructure & development projects.",
    "Controls inflation via surplus budget or reducing expenditure.",
    "Reduces unemployment by funding job-creation schemes.",
    "Ensures social justice via subsidies, welfare programs, poverty alleviation.",
    "Stabilizes economy during business cycle fluctuations."
  ],
}
      
      ]

    },







    physics:{
      "unit-and-measurement-and-laws-of-motion":[
        {
          slno: 1,
          title: "Physical Quantities & Units",
          points: [
            "Physical quantity: Property measurable in terms of magnitude and unit.",
            "Fundamental quantities: Mass, length, time, temperature, current, luminous intensity, amount of substance.",
            "Derived quantities: Obtained from fundamental quantities (e.g., velocity, force).",
            "SI system: Standardized international system of units (meter, kilogram, second, ampere, kelvin, mole, candela)."
          ]
        },
        {
          slno: 2,
          title: "Dimensions & Dimensional Analysis",
          points: [
            "Dimensions represent physical quantity in terms of fundamental units.",
            "Dimensional formula: Expression showing dependency on fundamental units.",
            "Applications: Deriving formulas, checking dimensional correctness, converting units."
          ]
        },
        {
          slno: 3,
          title: "Errors in Measurement",
          points: [
            "Absolute error: Difference between measured and true value.",
            "Relative error: Absolute error / true value.",
            "Types: Systematic error, random error, gross error.",
            "Minimizing errors improves precision."
          ]
        },
        {
          slno: 4,
          title: "Significant Figures",
          points: [
            "Represent precision of measurement.",
            "Rules: All non-zero digits are significant, zeros between non-zero digits are significant, trailing zeros significant only if decimal present."
          ]
        },
        {
          slno: 5,
          title: "Motion in One Dimension",
          points: [
            "Displacement: Change in position in a specific direction.",
            "Speed: Distance/time; Velocity: Displacement/time.",
            "Acceleration: Change in velocity/time.",
            "Equations of motion: v = u + at, s = ut + ½at², v² = u² + 2as."
          ]
        },
        {
          slno: 6,
          title: "Motion in Two Dimensions",
          points: [
            "Projectile motion: Horizontal and vertical components are independent.",
            "Range = (u² sin 2θ)/g, Maximum height = (u² sin² θ)/(2g).",
            "Circular motion: Acceleration = v²/r, Angular velocity = θ/t."
          ]
        },
        {
          slno: 7,
          title: "Newton’s Laws of Motion",
          points: [
            "First Law (Law of Inertia): Body remains at rest or uniform motion unless acted by external force.",
            "Second Law: Force = mass × acceleration (F = ma).",
            "Third Law: For every action, equal and opposite reaction."
          ]
        },
        {
          slno: 8,
          title: "Friction",
          points: [
            "Opposes relative motion between surfaces.",
            "Types: Static friction > kinetic friction.",
            "Friction = μN, where μ = coefficient of friction, N = normal force.",
            "Applications: Walking, driving, machines."
          ]
        },
        {
          slno: 9,
          title: "Circular Motion & Centripetal Force",
          points: [
            "Centripetal force keeps body in circular path: F = mv²/r.",
            "Examples: Motion of planets, cars on curves, rotating bodies.",
            "Banking of roads reduces frictional dependence in curves."
          ]
        },
        {
          slno: 10,
          title: "Conservation of Momentum",
          points: [
            "Total momentum remains constant when no external force acts.",
            "Applications: Recoil of gun, rocket propulsion, collisions."
          ]
        }

      ],



      "kinematics-wpe-gravitation":[
        {
          slno: 1,
          title: "Kinematics – Basics",
          points: [
            "Kinematics deals with the motion of objects without considering the forces.",
            "Types of motion: Rectilinear, Circular, Oscillatory, Random.",
            "Scalars: Have magnitude only (distance, speed, mass).",
            "Vectors: Have magnitude & direction (displacement, velocity, acceleration).",
            "Speed = Distance/Time; Velocity = Displacement/Time.",
            "Acceleration = (Final velocity − Initial velocity) / Time."
          ]
        },
        {
          slno: 2,
          title: "Equations of Motion",
          points: [
            "v = u + at",
            "s = ut + ½at²",
            "v² = u² + 2as",
            "Where: u = initial velocity, v = final velocity, a = acceleration, s = displacement, t = time."
          ]
        },
        {
          slno: 3,
          title: "Projectile Motion",
          points: [
            "Horizontal Range: R = (u² sin 2θ) / g.",
            "Time of Flight: T = (2u sin θ) / g.",
            "Maximum Height: H = (u² sin² θ) / (2g).",
            "Projectile path: Parabolic; horizontal & vertical motions are independent."
          ]
        },
        {
          slno: 4,
          title: "Relative Velocity",
          points: [
            "Used when two objects move with respect to each other.",
            "Relative velocity formula: Vab = Va − Vb.",
            "Applications: River-boat problems, rain-man problems."
          ]
        },
        {
          slno: 5,
          title: "Work",
          points: [
            "Work = Force × Displacement × cosθ.",
            "Positive Work: Force and displacement in same direction.",
            "Negative Work: Force and displacement in opposite direction.",
            "Work done by gravity over a closed path = 0 (conservative force)."
          ]
        },
        {
          slno: 6,
          title: "Energy",
          points: [
            "Kinetic Energy (KE) = ½mv².",
            "Potential Energy (PE) = mgh.",
            "Work-Energy Theorem: Work done = ΔKE.",
            "Power = Work / Time; SI unit = Watt.",
            "Conservation of Energy: Total energy remains constant in an isolated system."
          ]
        },
        {
          slno: 7,
          title: "Gravitation Basics",
          points: [
            "Newton’s Law: F = Gm₁m₂ / r².",
            "G = 6.67 × 10⁻¹¹ Nm²/kg².",
            "Weight = mg; varies with g.",
            "g on Earth = 9.8 m/s²; g decreases with height & depth.",
            "g at depth d: g' = g(1 − d/R).",
            "g at height h: g' = g(R / (R + h))²."
          ]
        },
        {
          slno: 8,
          title: "Satellite Motion",
          points: [
            "Orbital velocity: v = √(GM/R).",
            "Time period: T = 2π√(R³/GM).",
            "Escape velocity (Earth): ve = √(2gR) ≈ 11.2 km/s.",
            "Geostationary satellite: Period = 24 hrs; remains fixed over same point."
          ]
        },
        {
          slno: 9,
          title: "Important Points for CDS",
          points: [
            "Always memorize kinematic equations, projectile formulas, and gravitational relations.",
            "CDS mostly asks formula-based, one-step numerical & conceptual questions.",
            "Practice previous year CDS papers; ~3-4 questions from these topics come every year."
          ]
        }

      ],




      "sound-and-wave":[
        {
          slno: 1,
          title: "Types of Waves",
          points: [
            "Mechanical waves: Require a medium (sound, water, seismic waves).",
            "Electromagnetic waves: Do not require a medium (light, radio, X-rays).",
            "Mechanical waves classified as:",
            "• Longitudinal waves → Particles vibrate parallel to wave propagation (sound waves).",
            "• Transverse waves → Particles vibrate perpendicular to propagation (water waves, light)."
          ]
        },
        {
          slno: 2,
          title: "Wave Parameters",
          points: [
            "Wavelength (λ): Distance between two consecutive crests or compressions.",
            "Frequency (f): Number of vibrations per second; unit: Hz.",
            "Time Period (T): Time for one complete oscillation; T = 1/f.",
            "Wave Velocity (v): v = f × λ.",
            "Amplitude (A): Maximum displacement from mean position; relates to energy."
          ]
        },
        {
          slno: 3,
          title: "Sound Waves",
          points: [
            "Sound is a longitudinal mechanical wave.",
            "Speed of sound in air ≈ 343 m/s at 20°C.",
            "Speed increases with temperature & density of medium.",
            "Sound cannot travel in a vacuum."
          ]
        },
        {
          slno: 4,
          title: "Speed of Sound in Different Media",
          points: [
            "Air ≈ 343 m/s (20°C).",
            "Water ≈ 1482 m/s.",
            "Steel ≈ 5960 m/s.",
            "Order: Solids > Liquids > Gases."
          ]
        },
        {
          slno: 5,
          title: "Doppler Effect",
          points: [
            "Apparent change in frequency when source or observer moves.",
            "Approaching source → frequency increases.",
            "Receding source → frequency decreases.",
            "Formula: f' = f × [(v ± vo) / (v ∓ vs)]."
          ]
        },
        {
          slno: 6,
          title: "Resonance",
          points: [
            "Phenomenon of large amplitude oscillations when frequency of external force = natural frequency.",
            "Examples: Tuning fork, glass breaking with sound, bridge vibrations."
          ]
        },
        {
          slno: 7,
          title: "Beats",
          points: [
            "Interference of two waves of slightly different frequencies.",
            "Beat frequency = |f1 − f2|.",
            "Used in tuning musical instruments."
          ]
        },
        {
          slno: 8,
          title: "Standing Waves",
          points: [
            "Formed by superposition of two waves of same frequency & amplitude travelling in opposite directions.",
            "Nodes: Points of zero displacement.",
            "Antinodes: Points of maximum displacement.",
            "Applications: Organ pipes, strings of musical instruments."
          ]
        },
        {
          slno: 9,
          title: "Intensity & Loudness",
          points: [
            "Intensity ∝ Amplitude²; SI unit: W/m².",
            "Loudness is a logarithmic perception of intensity.",
            "Unit of loudness: Decibel (dB).",
            "Threshold of hearing ≈ 0 dB; Pain threshold ≈ 120 dB."
          ]
        },
        {
          slno: 10,
          title: "Important CDS Tips",
          points: [
            "Revise formulas: v = fλ, beat frequency, Doppler effect equation.",
            "Focus on properties of sound, resonance, beats, and speed in different media.",
            "3-4 questions are consistently asked from sound & waves in CDS."
          ]
        }
      

      ],




      "electricity-and-magnetism":[
        {
          slno: 1,
          title: "Electric Charge & Properties",
          points: [
            "Two types: Positive (+) and Negative (−).",
            "Like charges repel; unlike charges attract.",
            "Charge is quantized: q = ±ne (e = 1.6 × 10⁻¹⁹ C).",
            "Charge is conserved in an isolated system."
          ]
        },
        {
          slno: 2,
          title: "Coulomb’s Law",
          points: [
            "Force between two point charges: F = k × (q₁q₂)/r².",
            "k = 9 × 10⁹ N·m²/C² (in vacuum).",
            "Force is attractive/repulsive depending on sign of charges."
          ]
        },
        {
          slno: 3,
          title: "Electric Field & Potential",
          points: [
            "Electric Field (E): Force per unit positive charge → E = F/q; unit: N/C.",
            "Electric Potential (V): Work done per unit charge → V = W/q; unit: Volt.",
            "Relation: E = −dV/dr (rate of change of potential)."
          ]
        },
        {
          slno: 4,
          title: "Capacitance & Capacitors",
          points: [
            "Capacitance (C): Ability to store charge → C = Q/V; unit: Farad (F).",
            "Parallel Plate Capacitor: C = ε₀A/d (ε₀ = permittivity, A = area, d = distance).",
            "Energy stored: U = ½CV²."
          ]
        },
        {
          slno: 5,
          title: "Current Electricity",
          points: [
            "Electric Current (I) = Q/t; unit: Ampere (A).",
            "Ohm’s Law: V = IR, where R = resistance.",
            "Resistance: R = ρL/A (ρ = resistivity, L = length, A = area).",
            "Factors affecting resistance: length ↑, area ↓, material & temperature."
          ]
        },
        {
          slno: 6,
          title: "Electric Power & Energy",
          points: [
            "Power: P = VI = I²R = V²/R; unit: Watt.",
            "Electrical Energy = P × t = VIt; measured in kilowatt-hour (kWh).",
            "1 kWh = 3.6 × 10⁶ Joules."
          ]
        },
        {
          slno: 7,
          title: "Magnetism Basics",
          points: [
            "Magnetic poles always exist in pairs (no monopoles).",
            "Like poles repel, unlike poles attract.",
            "Magnetic field lines emerge from North → South pole externally."
          ]
        },
        {
          slno: 8,
          title: "Earth’s Magnetism",
          points: [
            "Earth behaves like a giant bar magnet tilted ≈ 11° from rotational axis.",
            "Key elements: Magnetic Declination, Inclination, Horizontal Intensity.",
            "Magnetic poles ≠ Geographic poles."
          ]
        },
        {
          slno: 9,
          title: "Electromagnetism (Oersted & Faraday)",
          points: [
            "Oersted: Electric current produces a magnetic field around conductor.",
            "Faraday’s Law: Changing magnetic flux induces EMF (Electromagnetic Induction).",
            "Lenz’s Law: Induced current opposes the change causing it."
          ]
        },
        {
          slno: 10,
          title: "Electromagnetic Induction",
          points: [
            "Induced EMF: ε = −dΦ/dt (Φ = magnetic flux).",
            "Applications: Generators, transformers, induction cookers, wireless charging."
          ]
        },
        {
          slno: 11,
          title: "Magnetic Effects of Current",
          points: [
            "Biot-Savart Law: Magnetic field ∝ I/r².",
            "Right-hand thumb rule: Curl fingers along current, thumb points field direction.",
            "Force on current-carrying conductor: F = BIL sinθ."
          ]
        },
        {
          slno: 12,
          title: "Electromagnets & Devices",
          points: [
            "Electromagnet: Temporary magnet formed by current in coil; strong & controllable.",
            "Applications: Motors, generators, speakers, MRI machines.",
            "Transformers: Step-up/Step-down AC voltage; works on electromagnetic induction."
          ]
        },
        {
          slno: 13,
          title: "Important CDS Formulas",
          points: [
            "Coulomb’s Law: F = k(q₁q₂)/r².",
            "Ohm’s Law: V = IR.",
            "Power: P = VI = I²R.",
            "Energy: E = VIt = P × t.",
            "Capacitance: C = Q/V.",
            "Magnetic Force: F = BIL sinθ.",
            "Induced EMF: ε = −dΦ/dt."
          ]
        },
        {
          slno: 14,
          title: "CDS Exam Focus",
          points: [
            "Numericals on Ohm’s Law, Power, Energy & Coulomb’s Law.",
            "Conceptual questions on Faraday’s & Lenz’s laws are common.",
            "Know values: e = 1.6 × 10⁻¹⁹ C, ε₀ = 8.85 × 10⁻¹² C²/N·m².",
            "Expect 4–5 direct questions from electricity & magnetism."
          ]
        }

      ],




      "light":[
        {
          slno: 1,
          title: "Nature of Light",
          points: [
            "Light shows dual nature: wave (interference, diffraction) + particle (photoelectric effect).",
            "Speed of light in vacuum (c) = 3 × 10⁸ m/s.",
            "Medium change causes refraction, not speed constancy."
          ]
        },
        {
          slno: 2,
          title: "Reflection of Light",
          points: [
            "Law 1: Angle of incidence = Angle of reflection.",
            "Law 2: Incident ray, reflected ray, and normal lie in the same plane.",
            "Mirror formula: 1/f = 1/u + 1/v.",
            "Image by plane mirror: Virtual, erect, same size, laterally inverted."
          ]
        },
        {
          slno: 3,
          title: "Spherical Mirrors",
          points: [
            "Concave mirror: Converging mirror, used in telescopes, headlights, shaving mirrors.",
            "Convex mirror: Diverging mirror, used in vehicles for wider view.",
            "Magnification formula: M = −v/u."
          ]
        },
        {
          slno: 4,
          title: "Refraction of Light",
          points: [
            "Bending of light when it passes from one medium to another.",
            "Snell’s Law: n₁ sin i = n₂ sin r.",
            "Absolute refractive index: n = c/v (c = speed in vacuum, v = speed in medium)."
          ]
        },
        {
          slno: 5,
          title: "Total Internal Reflection (TIR)",
          points: [
            "Occurs when light moves from denser → rarer medium at an angle > critical angle.",
            "Applications: Optical fibers, diamond sparkle, mirage formation."
          ]
        },
        {
          slno: 6,
          title: "Lenses",
          points: [
            "Convex lens: Converging, forms real or virtual images depending on object distance.",
            "Concave lens: Diverging, always forms virtual, erect, diminished images.",
            "Lens formula: 1/f = 1/v − 1/u.",
            "Power of lens (D) = 100/f(cm)."
          ]
        },
        {
          slno: 7,
          title: "Prisms & Dispersion",
          points: [
            "Prism splits white light into 7 colors (VIBGYOR).",
            "Cause: Different refractive indices for different wavelengths.",
            "Red deviates least, violet deviates most."
          ]
        },
        {
          slno: 8,
          title: "Scattering of Light",
          points: [
            "Shorter wavelengths scatter more (Rayleigh scattering).",
            "Blue sky → shorter wavelengths scatter more.",
            "Red sunsets → red scatters least, reaches observer during sunset/sunrise."
          ]
        },
        {
          slno: 9,
          title: "Optical Instruments",
          points: [
            "Microscope: Uses two convex lenses for magnification.",
            "Telescope: Uses mirrors or lenses to view distant objects.",
            "Periscope: Uses total internal reflection via prisms.",
            "Human eye: Lens forms real, inverted image on retina."
          ]
        },
        {
          slno: 10,
          title: "Human Eye & Vision Defects",
          points: [
            "Myopia (nearsightedness): Corrected by concave lens.",
            "Hypermetropia (farsightedness): Corrected by convex lens.",
            "Presbyopia: Age-related, needs bifocal lenses.",
            "Astigmatism: Irregular cornea curvature; corrected by cylindrical lens."
          ]
        },
        {
          slno: 11,
          title: "Wave Properties of Light",
          points: [
            "Interference: Superposition of waves → constructive/destructive patterns.",
            "Diffraction: Bending of light around edges.",
            "Polarization: Restriction of vibration of light in one plane."
          ]
        },
        {
          slno: 12,
          title: "Photoelectric Effect",
          points: [
            "Emission of electrons when light strikes a metal surface.",
            "Explained by Einstein using particle nature of light (photons).",
            "Applications: Solar cells, photodiodes, automatic doors."
          ]
        },
        {
          slno: 13,
          title: "Important Formulas",
          points: [
            "Mirror formula: 1/f = 1/u + 1/v.",
            "Lens formula: 1/f = 1/v − 1/u.",
            "Magnification: M = v/u or M = h'/h.",
            "Snell’s Law: n₁ sin i = n₂ sin r.",
            "Power of lens: P = 100/f(cm)."
          ]
        },
        {
          slno: 14,
          title: "CDS Exam Focus",
          points: [
            "1–2 direct numericals expected from mirrors and lenses.",
            "Conceptual questions on TIR, dispersion, scattering, and human eye defects are common.",
            "Know key formulas and critical applications like optical fibers, mirage, microscopes.",
            "Expect 3–4 marks from this topic in CDS."
          ]
        }

      ],

    },







    chemistry:{

      "states-of-matter-and-atomic-structure":[
        {
          slno: 1,
          title: "States of Matter",
          points: [
            "Matter exists in 3 main states: Solid, Liquid, Gas + Plasma (ionized gas).",
            "Solids: Definite shape & volume, strong intermolecular forces.",
            "Liquids: Definite volume, no definite shape, weaker intermolecular forces.",
            "Gases: Neither definite shape nor volume, weak intermolecular forces.",
            "Plasma: Highly ionized gas, found in sun, stars, neon signs."
          ]
        },
        {
          slno: 2,
          title: "Gas Laws",
          points: [
            "Boyle’s Law: P ∝ 1/V at constant T → PV = constant.",
            "Charles’ Law: V ∝ T at constant P → V/T = constant.",
            "Gay-Lussac’s Law: P ∝ T at constant V → P/T = constant.",
            "Avogadro’s Law: V ∝ n (moles) at constant P & T.",
            "Ideal Gas Equation: PV = nRT (R = 8.314 J/mol·K)."
          ]
        },
        {
          slno: 3,
          title: "Kinetic Theory of Gases",
          points: [
            "Explains gas properties using molecular motion.",
            "Assumes molecules are in continuous, random motion.",
            "Temperature ∝ average kinetic energy of molecules.",
            "Root Mean Square Velocity: Vrms = √(3RT/M)."
          ]
        },
        {
          slno: 4,
          title: "Dalton’s Atomic Theory",
          points: [
            "Proposed by John Dalton (1803).",
            "Atoms are indivisible, identical for an element, combine in fixed ratios.",
            "Limitations: Failed to explain isotopes, subatomic particles, etc."
          ]
        },
        {
          slno: 5,
          title: "Discovery of Subatomic Particles",
          points: [
            "Electron: Discovered by J.J. Thomson (Cathode Ray Experiment).",
            "Proton: Discovered by Goldstein (Canal Ray Experiment).",
            "Neutron: Discovered by Chadwick (1932)."
          ]
        },
        {
          slno: 6,
          title: "Atomic Models",
          points: [
            "Thomson’s Model: 'Plum pudding model'; electrons embedded in positive sphere.",
            "Rutherford’s Model: Nucleus discovered; electrons revolve around nucleus; failed to explain stability.",
            "Bohr’s Model: Electrons revolve in quantized orbits; energy absorbed/emitted during transitions.",
            "Quantum Model: Developed by Schrödinger; electrons as probability clouds."
          ]
        },
        {
          slno: 7,
          title: "Quantum Numbers",
          points: [
            "Principal (n): Energy level/shell → n = 1, 2, 3…",
            "Azimuthal (l): Subshell shape → l = 0(s), 1(p), 2(d), 3(f).",
            "Magnetic (m): Orientation of orbital in space.",
            "Spin (s): Electron spin → +1/2 or −1/2."
          ]
        },
        {
          slno: 8,
          title: "Electronic Configuration",
          points: [
            "Arrangement of electrons into shells and subshells.",
            "Aufbau Principle: Electrons fill lower energy orbitals first.",
            "Pauli Exclusion Principle: No two electrons can have all four quantum numbers same.",
            "Hund’s Rule: Electron pairing occurs after all orbitals are singly filled."
          ]
        },
        {
          slno: 9,
          title: "Periodic Table Basics",
          points: [
            "Modern periodic table based on increasing atomic number (Moseley).",
            "Periods: Horizontal rows (7 total). Groups: Vertical columns (18 total).",
            "Classification: s, p, d, f-block elements.",
            "Trends: Atomic size ↓ across period, ↑ down group; Ionization energy ↑ across, ↓ down."
          ]
        },
        {
          slno: 10,
          title: "Chemical Bonding Overview",
          points: [
            "Ionic Bond: Transfer of electrons; strong electrostatic force; e.g., NaCl.",
            "Covalent Bond: Sharing of electrons; e.g., H₂, CH₄.",
            "Metallic Bond: Delocalized electron cloud around positive ions; e.g., metals.",
            "Hydrogen Bonding: Weak interaction, responsible for water’s high boiling point."
          ]
        },
        {
          slno: 11,
          title: "Important Constants & Values",
          points: [
            "Avogadro’s Number: 6.022 × 10²³ mol⁻¹.",
            "Gas Constant R: 8.314 J/mol·K.",
            "Speed of electron: ~2.2 × 10⁶ m/s (Bohr’s model).",
            "1 mole ideal gas occupies 22.4 L at STP."
          ]
        },
        {
          slno: 12,
          title: "CDS Exam Focus",
          points: [
            "Frequent MCQs on gas laws, atomic models, subatomic discoveries.",
            "Quantum numbers and periodic trends are common topics.",
            "Expect 2–3 numericals from ideal gas equations & Vrms formulas.",
            "Weightage: ~3–4 questions in CDS exams from this chapter."
          ]
        }

      ],




      "electronic-configuration-and-metal-and-non-metal":[
        {
          slno: 1,
          title: "Electronic Configuration",
          points: [
            "Arrangement of electrons in shells, subshells, and orbitals around nucleus.",
            "Follows three main rules:",
            "• Aufbau Principle → Electrons fill orbitals in order of increasing energy (1s → 2s → 2p → 3s …).",
            "• Pauli Exclusion Principle → No two electrons in an atom have the same set of all four quantum numbers.",
            "• Hund’s Rule → Electrons occupy degenerate orbitals singly before pairing.",
            "Notation Example: Oxygen (Z=8) → 1s² 2s² 2p⁴."
          ]
        },
        {
          slno: 2,
          title: "Shells & Subshells",
          points: [
            "Shells are represented by principal quantum number 'n' (1,2,3...).",
            "Subshells → s, p, d, f; maximum electrons:",
            "• s → 2, p → 6, d → 10, f → 14.",
            "Maximum electrons in a shell: 2n².",
            "CDS Tip: Frequently asked about max electron capacity of shells & subshells."
          ]
        },
        {
          slno: 3,
          title: "Valency & Octet Rule",
          points: [
            "Valency = combining capacity of an element based on electrons in outermost shell.",
            "Octet Rule → Atoms tend to attain 8 electrons in outer shell for stability.",
            "Metals → lose electrons to complete octet; Non-metals → gain/share electrons."
          ]
        },
        {
          slno: 4,
          title: "Metals: Properties",
          points: [
            "Metals are electropositive → readily lose electrons.",
            "Physical Properties: Lustrous, malleable, ductile, good conductors of heat/electricity.",
            "Chemical Properties:",
            "• Form basic oxides (e.g., Na₂O, CaO).",
            "• React with acids to release hydrogen gas.",
            "• Form positive ions (cations) in reactions.",
            "Examples: Na, K, Ca, Al, Fe."
          ]
        },
        {
          slno: 5,
          title: "Non-Metals: Properties",
          points: [
            "Non-metals are electronegative → tend to gain/share electrons.",
            "Physical Properties: Generally brittle, non-lustrous, poor conductors.",
            "Chemical Properties:",
            "• Form acidic oxides (e.g., SO₂, CO₂).",
            "• React with metals to form salts.",
            "• Exist as diatomic or polyatomic molecules (e.g., O₂, S₈).",
            "Examples: O, N, S, Cl, P."
          ]
        },
        {
          slno: 6,
          title: "Metalloids",
          points: [
            "Elements showing properties of both metals & non-metals.",
            "Examples: B, Si, Ge, As, Sb, Te.",
            "Important in semiconductors → CDS often asks examples."
          ]
        },
        {
          slno: 7,
          title: "Periodic Trends",
          points: [
            "Across Period (L → R):",
            "• Atomic radius decreases.",
            "• Metallic character decreases, non-metallic character increases.",
            "• Ionization energy & electronegativity increase.",
            "Down Group:",
            "• Atomic radius increases.",
            "• Metallic character increases, non-metallic character decreases.",
            "CDS Tip: Trend-based MCQs are common."
          ]
        },
        {
          slno: 8,
          title: "Reactivity Trends",
          points: [
            "Metals: Reactivity increases down the group (e.g., alkali metals).",
            "Non-Metals: Reactivity decreases down the group (e.g., halogens).",
            "Noble Gases: Chemically inert due to stable octet (He has 2)."
          ]
        },
        {
          slno: 9,
          title: "Important Points for CDS",
          points: [
            "Know complete configuration of first 30 elements (H → Zn).",
            "Questions often on:",
            "• Maximum electrons in shells/subshells.",
            "• Trends in metallic & non-metallic character.",
            "• Examples of metalloids.",
            "• Valency patterns of s-, p-, and d-block elements.",
            "Weightage: ~3-4 questions from this chapter in CDS."
          ]
        }

      ],





      "acid-bases-and-salts":[
        {
          slno: 1,
          title: "Acids",
          points: [
            "Substances that produce H⁺ ions in aqueous solution.",
            "Taste sour, turn blue litmus → red, pH < 7.",
            "Types of Acids:",
            "• Strong Acids → Completely ionize (e.g., HCl, H₂SO₄, HNO₃).",
            "• Weak Acids → Partially ionize (e.g., CH₃COOH, H₂CO₃).",
            "• Organic Acids → Derived from living organisms (e.g., citric acid, lactic acid).",
            "• Mineral Acids → Industrially prepared (e.g., HCl, H₂SO₄).",
            "CDS Tip: Mostly asks examples, strong vs. weak, mineral vs. organic."
          ]
        },
        {
          slno: 2,
          title: "Bases",
          points: [
            "Substances that produce OH⁻ ions in aqueous solution.",
            "Taste bitter, soapy touch, turn red litmus → blue, pH > 7.",
            "Types of Bases:",
            "• Strong Bases → Completely ionize (e.g., NaOH, KOH, Ca(OH)₂).",
            "• Weak Bases → Partially ionize (e.g., NH₄OH, Mg(OH)₂).",
            "Alkalis: Water-soluble bases (e.g., NaOH, KOH).",
            "CDS Tip: Know common examples and properties."
          ]
        },
        {
          slno: 3,
          title: "Salts",
          points: [
            "Formed by neutralization reaction between acid and base.",
            "Types of Salts:",
            "• Normal Salts → Complete neutralization (e.g., NaCl, K₂SO₄).",
            "• Acidic Salts → Partial neutralization, contain replaceable H⁺ (e.g., NaHSO₄, NaHCO₃).",
            "• Basic Salts → Partial neutralization, contain OH⁻ (e.g., Mg(OH)Cl, Zn(OH)Cl).",
            "• Double Salts → Two different salts crystallized together (e.g., Mohr’s salt, alum).",
            "• Complex Salts → Contain complex ions (e.g., K₄[Fe(CN)₆])."
          ]
        },
        {
          slno: 4,
          title: "pH Scale",
          points: [
            "Measures hydrogen ion concentration.",
            "Scale: 0 → 14; Neutral = 7.",
            "Acidic Solution: pH < 7; Basic Solution: pH > 7.",
            "Important pH values:",
            "• Gastric juice ≈ 1.5–3.5.",
            "• Blood ≈ 7.4.",
            "• Soap solution ≈ 9–10.",
            "CDS Tip: pH-related application-based MCQs are common."
          ]
        },
        {
          slno: 5,
          title: "Neutralization Reaction",
          points: [
            "Acid + Base → Salt + Water.",
            "Exothermic reaction, widely used in industries.",
            "Examples:",
            "• HCl + NaOH → NaCl + H₂O.",
            "• H₂SO₄ + 2KOH → K₂SO₄ + 2H₂O."
          ]
        },
        {
          slno: 6,
          title: "Common Industrial Acids & Bases",
          points: [
            "Acids:",
            "• HCl → Cleaning metals, PVC production.",
            "• H₂SO₄ → Fertilizers, batteries, petroleum refining.",
            "• HNO₃ → Explosives, fertilizers.",
            "Bases:",
            "• NaOH → Soap, paper, textiles.",
            "• Ca(OH)₂ → Cement, bleaching powder.",
            "• NH₄OH → Fertilizers, rayon manufacturing."
          ]
        },
        {
          slno: 7,
          title: "Hydrochloric Acid (HCl)",
          points: [
            "Secreted in stomach; aids digestion.",
            "Industrial uses: steel cleaning, food processing.",
            "CDS Tip: Often asks its role in digestion."
          ]
        },
        {
          slno: 8,
          title: "Sodium Hydroxide (NaOH)",
          points: [
            "Strong alkali; used in soap, detergents, paper, and textiles.",
            "Prepared by electrolysis of brine (Chlor-alkali process).",
            "Byproducts: Cl₂ and H₂ gases."
          ]
        },
        {
          slno: 9,
          title: "Plaster of Paris (POP)",
          points: [
            "Chemical name: CaSO₄·½H₂O.",
            "Prepared by heating gypsum (CaSO₄·2H₂O).",
            "Uses: Surgical bandages, false ceilings, sculptures.",
            "Important for CDS: Chemical formula + preparation process."
          ]
        },
        {
          slno: 10,
          title: "Baking Soda & Washing Soda",
          points: [
            "Baking Soda: NaHCO₃ → Used in cooking, antacids, fire extinguishers.",
            "Washing Soda: Na₂CO₃·10H₂O → Used in detergents, glass, and paper industries.",
            "CDS Tip: Chemical formulas are frequently asked."
          ]
        },
        {
          slno: 11,
          title: "Indicators",
          points: [
            "Used to identify acidic/basic nature of solutions.",
            "Common indicators:",
            "• Litmus → Red in acid, blue in base.",
            "• Phenolphthalein → Colorless in acid, pink in base.",
            "• Methyl Orange → Red in acid, yellow in base.",
            "MCQs often test correct indicator usage."
          ]
        },
        {
          slno: 12,
          title: "Important CDS Tips",
          points: [
            "Learn chemical names + formulas of everyday salts (NaCl, NaHCO₃, CaO, etc.).",
            "pH values of body fluids, household items, and industrial solutions are frequently asked.",
            "Understand neutralization, bleaching powder prep, POP formation.",
            "Expect ~4–5 direct questions from this chapter."
          ]
        }

      ],




      "chemistry-in-everyday-life":[
        {
          slno: 1,
          title: "Drugs and Their Classification",
          points: [
            "Drugs are chemicals used for therapeutic, diagnostic, or preventive purposes.",
            "Classification based on action:",
            "• Antacids → Neutralize excess stomach acid (e.g., Mg(OH)₂, NaHCO₃).",
            "• Antihistamines → Treat allergy (e.g., Cetrizine, Loratadine).",
            "• Analgesics → Pain relievers (e.g., Aspirin, Paracetamol).",
            "• Tranquilizers → Reduce stress/anxiety (e.g., Diazepam, Alprazolam).",
            "• Antibiotics → Kill/inhibit bacteria (e.g., Penicillin, Streptomycin).",
            "• Antimicrobials → Destroy microbes (e.g., Dettol, Hexachlorophene).",
            "• Antipyretics → Reduce fever (e.g., Paracetamol).",
            "• Antidepressants → Elevate mood (e.g., Fluoxetine, Sertraline).",
            "• Anti-cancer drugs → Inhibit uncontrolled cell growth (e.g., Cisplatin, Taxol)."
          ]
        },
        {
          slno: 2,
          title: "Antibiotics",
          points: [
            "Discovered by Alexander Fleming (Penicillin).",
            "Inhibit growth of or kill microorganisms.",
            "Examples:",
            "• Broad-spectrum → Act on many bacteria (e.g., Tetracycline, Chloramphenicol).",
            "• Narrow-spectrum → Act on specific bacteria (e.g., Penicillin G).",
            "CDS Tip: Fleming + Penicillin + examples are frequently asked."
          ]
        },
        {
          slno: 3,
          title: "Antacids",
          points: [
            "Relieve acidity by neutralizing excess gastric acid.",
            "Examples: Sodium bicarbonate, Magnesium hydroxide, Aluminium hydroxide.",
            "CDS Tip: Often asked formula of NaHCO₃ + its role."
          ]
        },
        {
          slno: 4,
          title: "Antihistamines",
          points: [
            "Used to control allergic reactions.",
            "Block histamine action in the body.",
            "Examples: Diphenhydramine, Cetirizine, Loratadine."
          ]
        },
        {
          slno: 5,
          title: "Analgesics",
          points: [
            "Relieve pain without causing unconsciousness.",
            "Types:",
            "• Non-narcotic → Aspirin, Paracetamol.",
            "• Narcotic → Morphine, Codeine (used in severe pain).",
            "Excessive narcotics can lead to addiction."
          ]
        },
        {
          slno: 6,
          title: "Tranquilizers and Antidepressants",
          points: [
            "Tranquilizers → Reduce stress and anxiety (e.g., Diazepam, Alprazolam).",
            "Antidepressants → Elevate mood in depression (e.g., Fluoxetine, Sertraline).",
            "CDS Tip: Questions often revolve around examples."
          ]
        },
        {
          slno: 7,
          title: "Antimicrobials and Disinfectants",
          points: [
            "Antimicrobials → Inhibit/destroy growth of microorganisms (e.g., Dettol, Savlon).",
            "Disinfectants → Kill microbes on non-living surfaces (e.g., Phenol, Lysol).",
            "Antiseptics → Kill microbes on living tissues (e.g., Iodine tincture, Boric acid).",
            "CDS Tip: Difference between disinfectant vs antiseptic is important."
          ]
        },
        {
          slno: 8,
          title: "Food Additives",
          points: [
            "Chemicals added to enhance taste, color, preservation, etc.",
            "• Preservatives → Prevent spoilage (e.g., Sodium benzoate, KMS).",
            "• Artificial Sweeteners → Saccharin, Aspartame, Sucralose.",
            "• Antioxidants → Prevent rancidity (e.g., BHA, BHT).",
            "• Flavouring agents → Enhance taste and aroma (e.g., Esters, Vanillin)."
          ]
        },
        {
          slno: 9,
          title: "Cleansing Agents (Soaps & Detergents)",
          points: [
            "Soaps → Sodium/potassium salts of long-chain fatty acids.",
            "Prepared by saponification: Fat + NaOH → Soap + Glycerol.",
            "Detergents → Synthetic cleansing agents; work in hard water.",
            "CDS Tip: Chemical nature + difference between soaps and detergents is common."
          ]
        },
        {
          slno: 10,
          title: "Dyes",
          points: [
            "Used to impart color to fabrics, leather, etc.",
            "Types:",
            "• Acid dyes → Wool, silk (e.g., Congo red).",
            "• Basic dyes → Cotton (e.g., Methylene blue).",
            "• Mordant dyes → Use mordants for fixation (e.g., Alizarin)."
          ]
        },
        {
          slno: 11,
          title: "Polymers in Daily Life",
          points: [
            "Polythene → Packaging material.",
            "PVC → Pipes, cables, shoes.",
            "Teflon → Non-stick cookware.",
            "Nylon → Fabrics, ropes.",
            "Bakelite → Electrical insulators, switches.",
            "CDS Tip: Know names + applications."
          ]
        },
        {
          slno: 12,
          title: "Chemicals in Cosmetics",
          points: [
            "Shampoos → Contain detergents, conditioners.",
            "Sunscreens → Zinc oxide, Titanium dioxide block UV rays.",
            "Lipsticks → Waxes, pigments, oils.",
            "Perfumes → Aldehydes, esters, alcohols."
          ]
        },
        {
          slno: 13,
          title: "Important CDS Tips",
          points: [
            "Focus on everyday chemicals: NaHCO₃, NaCl, detergents, soaps, dyes.",
            "Memorize examples of antibiotics, analgesics, and antiseptics.",
            "Know artificial sweeteners, preservatives, antioxidants by name.",
            "Expect 3–5 direct MCQs from this chapter."
          ]
        }

      ],




      "carbon-and-its-compount":[
        {
          slno: 1,
          title: "Catenation Property of Carbon",
          points: [
            "Carbon forms long straight chains, branched chains, and rings by bonding with itself.",
            "Reason: Small atomic size and strong C–C covalent bonds.",
            "Foundation of organic chemistry; millions of compounds exist."
          ]
        },
        {
          slno: 2,
          title: "Covalent Bonding in Carbon",
          points: [
            "Carbon shares electrons to complete its octet.",
            "Forms single, double, and triple bonds (e.g., CH₄, C₂H₄, C₂H₂).",
            "Carbon compounds are generally poor conductors and have low melting/boiling points."
          ]
        },
        {
          slno: 3,
          title: "Allotropes of Carbon",
          points: [
            "Different forms of carbon with distinct structures and properties:",
            "• Diamond → Hardest natural substance, insulator, tetrahedral structure.",
            "• Graphite → Good conductor, lubricant, layered structure.",
            "• Fullerene (C₆₀) → Spherical molecules, used in nanotech.",
            "• Amorphous Carbon → Coal, charcoal, coke, soot."
          ]
        },
        {
          slno: 4,
          title: "Hydrocarbons",
          points: [
            "Compounds of carbon and hydrogen only; classified into:",
            "• Alkanes → Saturated hydrocarbons with single bonds (e.g., CH₄, C₂H₆).",
            "• Alkenes → Unsaturated hydrocarbons with double bonds (e.g., C₂H₄).",
            "• Alkynes → Unsaturated hydrocarbons with triple bonds (e.g., C₂H₂).",
            "• Aromatic hydrocarbons → Cyclic structures with delocalized π-electrons (e.g., Benzene)."
          ]
        },
        {
          slno: 5,
          title: "Functional Groups",
          points: [
            "Specific groups of atoms give compounds distinct properties.",
            "Examples:",
            "• Alcohols (–OH): Ethanol, methanol.",
            "• Aldehydes (–CHO): Formaldehyde.",
            "• Ketones (>C=O): Acetone.",
            "• Carboxylic Acids (–COOH): Acetic acid.",
            "• Amines (–NH₂): Methylamine."
          ]
        },
        {
          slno: 6,
          title: "Important Carbon Compounds & Uses",
          points: [
            "• Methane (CH₄): Fuel, greenhouse gas.",
            "• Ethanol (C₂H₅OH): Alcoholic beverages, sanitizer, biofuel.",
            "• Ethanoic Acid (CH₃COOH): Vinegar, preservative.",
            "• Soap: Sodium/potassium salts of fatty acids, prepared by saponification.",
            "• Detergents: Synthetic surfactants, effective even in hard water."
          ]
        },
        {
          slno: 7,
          title: "Chemical Reactions of Carbon Compounds",
          points: [
            "• Combustion → Produces CO₂ + energy (CH₄ + O₂ → CO₂ + H₂O).",
            "• Oxidation → Alcohols → Aldehydes/Acids.",
            "• Addition Reaction → Unsaturated hydrocarbons add hydrogen (C₂H₄ + H₂ → C₂H₆).",
            "• Substitution Reaction → Replaces atoms in saturated hydrocarbons (CH₄ + Cl₂ → CH₃Cl)."
          ]
        },
        {
          slno: 8,
          title: "Soaps and Detergents",
          points: [
            "Soaps: Sodium/potassium salts of fatty acids; ineffective in hard water.",
            "Detergents: Synthetic compounds; effective in both hard and soft water.",
            "CDS Tip: Know preparation process + differences."
          ]
        },
        {
          slno: 9,
          title: "Environmental Impact",
          points: [
            "Excessive CO₂ causes global warming.",
            "Incomplete combustion produces toxic CO gas.",
            "CFCs damage the ozone layer → now regulated globally.",
            "Encourages use of biofuels and renewable sources."
          ]
        },
        {
          slno: 10,
          title: "CDS High-Yield Facts",
          points: [
            "Know allotropes + their properties thoroughly.",
            "Remember formulas and uses of methane, ethanol, acetic acid, detergents, soaps.",
            "Understand functional groups and common examples.",
            "Combustion, oxidation, addition, and substitution reactions are frequently tested.",
            "3–4 direct MCQs expected from this chapter in CDS exams."
          ]
        }

      ],




      "periodic-table":[
        {
          slno: 1,
          title: "Introduction to Periodic Table",
          points: [
            "Arrangement of elements based on increasing atomic number and recurring chemical properties.",
            "Proposed by Dmitri Mendeleev (1869) based on atomic mass; modern table by Moseley (1913) based on atomic number.",
            "Foundation for understanding chemical behavior and trends."
          ]
        },
        {
          slno: 2,
          title: "Modern Periodic Law",
          points: [
            "Properties of elements are periodic functions of their atomic numbers.",
            "Elements arranged in rows (periods) and columns (groups) to show recurring properties."
          ]
        },
        {
          slno: 3,
          title: "Structure of Periodic Table",
          points: [
            "7 Periods → Horizontal rows arranged by increasing atomic number.",
            "18 Groups → Vertical columns; elements in a group have similar valence electrons and properties.",
            "Blocks → s-block, p-block, d-block, and f-block elements based on electron configurations."
          ]
        },
        {
          slno: 4,
          title: "Classification of Elements",
          points: [
            "Metals: Good conductors, malleable, form positive ions; mostly on the left.",
            "Non-metals: Poor conductors, form negative ions; found on the right.",
            "Metalloids: Show properties of both metals and non-metals (e.g., B, Si, As)."
          ]
        },
        {
          slno: 5,
          title: "Important Groups and Their Features",
          points: [
            "Group 1 (Alkali Metals): Li, Na, K, Rb, Cs, Fr → Highly reactive, soft, form strong bases.",
            "Group 2 (Alkaline Earth Metals): Be, Mg, Ca, Sr, Ba, Ra → Moderately reactive, used in alloys.",
            "Group 17 (Halogens): F, Cl, Br, I, At → Highly reactive non-metals, form salts.",
            "Group 18 (Noble Gases): He, Ne, Ar, Kr, Xe, Rn → Chemically inert, used in lighting and industry.",
            "Transition Metals (d-block): Good conductors, catalysts, form colored compounds."
          ]
        },
        {
          slno: 6,
          title: "Periodic Trends",
          points: [
            "Atomic Radius: Decreases across a period, increases down a group.",
            "Ionization Energy: Increases across a period, decreases down a group.",
            "Electronegativity: Increases across a period, decreases down a group.",
            "Metallic Character: Decreases across a period, increases down a group.",
            "Reactivity: For metals, increases down a group; for non-metals, decreases down a group."
          ]
        },
        {
          slno: 7,
          title: "Anomalies and Special Elements",
          points: [
            "Hydrogen behaves uniquely → resembles both Group 1 and Group 17.",
            "Lanthanides (f-block): Rare earth elements, used in electronics.",
            "Actinides: Mostly radioactive, include Uranium and Thorium."
          ]
        },
        {
          slno: 8,
          title: "Applications of Periodic Table",
          points: [
            "Predicting chemical properties and reactivity of elements.",
            "Understanding bonding and compound formation.",
            "Used in industries, medicine, agriculture, and environmental studies."
          ]
        },
        {
          slno: 9,
          title: "CDS High-Yield Facts",
          points: [
            "Know Group 1, 2, 17, and 18 properties thoroughly.",
            "Focus on periodic trends: atomic radius, ionization energy, electronegativity.",
            "Understand block classification and typical uses of d-block and f-block elements.",
            "2–3 direct MCQs expected from this topic in CDS exams."
          ]
        }
        

      ],



    },





    maths:{
      "number-system":[
        {
          slno: 1,
          title: "Introduction to Number System",
          points: [
            "Number system represents numbers in a standardized format.",
            "Types: Natural numbers, Whole numbers, Integers, Rational numbers, Irrational numbers, Real numbers, Imaginary numbers.",
            "Understanding types and properties is crucial for solving CDS aptitude problems."
          ]
        },
        {
          slno: 2,
          title: "Types of Numbers",
          points: [
            "Natural Numbers: Counting numbers → 1, 2, 3, ...",
            "Whole Numbers: Natural numbers + zero → 0, 1, 2, ...",
            "Integers: Positive, negative numbers, and zero.",
            "Rational Numbers: Expressed as p/q where q ≠ 0 (e.g., 3/4, -5/2).",
            "Irrational Numbers: Cannot be expressed as p/q (e.g., √2, π).",
            "Real Numbers: Combination of rational and irrational numbers.",
            "Imaginary Numbers: Square root of negative numbers (e.g., i = √-1)."
          ]
        },
        {
          slno: 3,
          title: "Properties of Numbers",
          points: [
            "Commutative Property: a + b = b + a and ab = ba.",
            "Associative Property: (a + b) + c = a + (b + c).",
            "Distributive Property: a(b + c) = ab + ac.",
            "Identity Elements: Additive identity = 0, Multiplicative identity = 1."
          ]
        },
        {
          slno: 4,
          title: "Prime and Composite Numbers",
          points: [
            "Prime Numbers: Numbers greater than 1 having only two factors → 1 and itself (e.g., 2, 3, 5, 7).",
            "Composite Numbers: Numbers having more than two factors (e.g., 4, 6, 8, 9).",
            "Prime Factorization: Expressing a number as a product of its prime factors."
          ]
        },
        {
          slno: 5,
          title: "Divisibility Rules",
          points: [
            "2 → Last digit even.",
            "3 → Sum of digits divisible by 3.",
            "4 → Last two digits divisible by 4.",
            "5 → Last digit 0 or 5.",
            "6 → Divisible by both 2 and 3.",
            "8 → Last three digits divisible by 8.",
            "9 → Sum of digits divisible by 9.",
            "11 → Difference between sum of odd and even place digits divisible by 11."
          ]
        },
        {
          slno: 6,
          title: "LCM and HCF",
          points: [
            "HCF (Highest Common Factor): Greatest number dividing all given numbers.",
            "LCM (Lowest Common Multiple): Smallest number divisible by all given numbers.",
            "Relation: LCM × HCF = Product of the numbers."
          ]
        },
        {
          slno: 7,
          title: "Remainder and Modular Arithmetic",
          points: [
            "Used when numbers are divided to find remainders quickly.",
            "Key for CDS problems involving large number simplifications.",
            "Fermat's Little Theorem and Chinese Remainder Theorem may appear in advanced cases."
          ]
        },
        {
          slno: 8,
          title: "Important Shortcuts for CDS",
          points: [
            "Sum of first n natural numbers = n(n + 1)/2.",
            "Sum of squares of first n natural numbers = n(n + 1)(2n + 1)/6.",
            "Sum of cubes of first n natural numbers = [n(n + 1)/2]^2.",
            "For finding last digit or remainder, use cyclicity of powers."
          ]
        },
        {
          slno: 9,
          title: "CDS High-Yield Facts",
          points: [
            "2–3 direct questions on divisibility, HCF, LCM, and remainder-based problems.",
            "Practice problems on simplifications involving large numbers.",
            "Memorize divisibility rules thoroughly.",
            "Be confident with prime factorization and cyclicity tricks."
          ]
        }

      ],



      "set-statistics-lagorithm":[
        {
          slno: 1,
          title: "Sets - Basics",
          points: [
            "A set is a well-defined collection of objects.",
            "Representation: Roster form {1,2,3} or Set-builder form {x | x > 0}.",
            "Types: Finite, Infinite, Null (∅), Singleton, Equal, Subset, Universal set.",
            "Power Set: Set of all subsets, n elements → 2^n subsets.",
            "Venn Diagrams used for visual representation."
          ]
        },
        {
          slno: 2,
          title: "Set Operations",
          points: [
            "Union (A ∪ B): Elements in A or B or both.",
            "Intersection (A ∩ B): Elements common to both.",
            "Difference (A − B): Elements in A but not in B.",
            "Complement (A'): Elements not in A.",
            "De Morgan’s Laws: (A ∪ B)' = A' ∩ B', (A ∩ B)' = A' ∪ B'."
          ]
        },
        {
          slno: 3,
          title: "Applications of Sets",
          points: [
            "Used in solving problems involving 2 or 3 overlapping sets.",
            "Formula for two sets: n(A ∪ B) = n(A) + n(B) − n(A ∩ B).",
            "Formula for three sets: n(A ∪ B ∪ C) = n(A) + n(B) + n(C) − n(A ∩ B) − n(B ∩ C) − n(C ∩ A) + n(A ∩ B ∩ C)."
          ]
        },
        {
          slno: 4,
          title: "Statistics - Basics",
          points: [
            "Statistics deals with collection, analysis, and interpretation of data.",
            "Types of data: Primary (collected first-hand), Secondary (from other sources).",
            "Frequency Distribution: Organizing data into classes and frequencies."
          ]
        },
        {
          slno: 5,
          title: "Measures of Central Tendency",
          points: [
            "Mean (x̄) = Sum of observations ÷ Number of observations.",
            "Median: Middle value when data is arranged in order.",
            "Mode: Most frequent value in the dataset.",
            "For grouped data: Use formulas involving class intervals."
          ]
        },
        {
          slno: 6,
          title: "Measures of Dispersion",
          points: [
            "Range = Highest value − Lowest value.",
            "Mean Deviation: Average of absolute deviations from mean/median.",
            "Variance: Average squared deviations from mean.",
            "Standard Deviation (SD): Square root of variance."
          ]
        },
        {
          slno: 7,
          title: "Probability Basics",
          points: [
            "Probability (P) = Favourable outcomes ÷ Total outcomes.",
            "P(E) lies between 0 and 1.",
            "Complementary Probability: P(E') = 1 − P(E).",
            "Useful for CDS-level questions involving cards, dice, and coins."
          ]
        },
        {
          slno: 8,
          title: "Logarithms - Basics",
          points: [
            "Definition: If a^x = b → log_a(b) = x.",
            "Common logarithms: Base 10 (log), Natural logarithms: Base e (ln).",
            "log_10(10) = 1, log_10(1) = 0."
          ]
        },
        {
          slno: 9,
          title: "Logarithm Rules",
          points: [
            "Product Rule: log_a(M × N) = log_a(M) + log_a(N).",
            "Quotient Rule: log_a(M/N) = log_a(M) − log_a(N).",
            "Power Rule: log_a(M^k) = k × log_a(M).",
            "Change of Base: log_a(b) = log_c(b) / log_c(a)."
          ]
        },
        {
          slno: 10,
          title: "CDS High-Yield Facts",
          points: [
            "1–2 direct questions from sets, especially Venn diagrams.",
            "2–3 questions from statistics: mean, median, mode, SD.",
            "1–2 questions from logarithms: simplifications and properties.",
            "Memorize logarithmic identities and set formulas for speed."
          ]
        }

      ],



      "mensuration":[
        {
          slno: 1,
          title: "Mensuration Basics",
          points: [
            "Deals with measurement of areas, volumes, and perimeters of 2D & 3D figures.",
            "CDS exam focuses on direct formula-based questions & quick calculations."
          ]
        },
        {
          slno: 2,
          title: "2D Figures - Perimeter & Area",
          points: [
            "Square → Perimeter = 4a, Area = a², Diagonal = a√2.",
            "Rectangle → Perimeter = 2(l + b), Area = l × b, Diagonal = √(l² + b²).",
            "Triangle → Area = ½ × base × height; Heron’s Formula = √[s(s−a)(s−b)(s−c)], where s = (a+b+c)/2.",
            "Equilateral Triangle → Area = (√3/4)a², Height = (√3/2)a.",
            "Circle → Circumference = 2πr, Area = πr², Sector Area = (θ/360)×πr², Segment Area = Sector Area − Triangle Area.",
            "Rhombus → Area = ½ × d₁ × d₂; Perimeter = 4a.",
            "Parallelogram → Area = base × height; Perimeter = 2(a+b).",
            "Trapezium → Area = ½ × (sum of parallel sides) × height."
          ]
        },
        {
          slno: 3,
          title: "3D Figures - Surface Area & Volume",
          points: [
            "Cube → TSA = 6a², LSA = 4a², Volume = a³, Diagonal = a√3.",
            "Cuboid → TSA = 2(lb + bh + hl), LSA = 2h(l + b), Volume = l × b × h, Diagonal = √(l² + b² + h²).",
            "Cylinder → CSA = 2πrh, TSA = 2πr(h + r), Volume = πr²h.",
            "Cone → Slant height = √(r² + h²), CSA = πrl, TSA = πr(l + r), Volume = (1/3)πr²h.",
            "Sphere → TSA = 4πr², Volume = (4/3)πr³.",
            "Hemisphere → CSA = 2πr², TSA = 3πr², Volume = (2/3)πr³.",
            "Frustum of Cone → TSA = π(R + r)l + π(R² + r²), Volume = (1/3)πh(R² + r² + Rr)."
          ]
        },
        {
          slno: 4,
          title: "Important Relationships",
          points: [
            "Diagonal of square = a√2; Relation between side & radius of incircle = r = a/2.",
            "For equilateral triangle → r = a√3/6, R (circumradius) = a√3/3.",
            "For a circle → θ (radians) = Arc Length / Radius.",
            "Frustum height formula: h = √(l² − (R − r)²)."
          ]
        },
        {
          slno: 5,
          title: "Mensuration Shortcuts",
          points: [
            "Memorize all basic 2D & 3D formulas; most CDS questions are direct formula-based.",
            "Remember π ≈ 22/7 for quick calculations.",
            "Use symmetry properties to save time in triangles & circles.",
            "In volume ratio problems, remember Volume ∝ r³; Surface Area ∝ r²."
          ]
        },
        {
          slno: 6,
          title: "CDS High-Yield Facts",
          points: [
            "3–5 questions are directly from mensuration in CDS.",
            "Most common figures: cube, cuboid, cylinder, cone, and sphere.",
            "Focus on LSA, TSA, and Volume formulas thoroughly.",
            "Practice mixed problems involving combination of solids."
          ]
        }

      ],



      "geometry":[
        {
          slno: 1,
          title: "Geometry Basics",
          points: [
            "Study of shapes, sizes, angles, and properties of figures.",
            "CDS focuses mainly on triangles, circles, quadrilaterals, and polygons.",
            "Understand basic terms: point, line, ray, plane, angle, etc."
          ]
        },
        {
          slno: 2,
          title: "Angles and Lines",
          points: [
            "Sum of angles on a straight line = 180°.",
            "Sum of angles around a point = 360°.",
            "Vertically opposite angles are equal.",
            "Alternate interior angles are equal when lines are parallel.",
            "Corresponding angles are equal when a transversal cuts parallel lines."
          ]
        },
        {
          slno: 3,
          title: "Triangles - Properties & Theorems",
          points: [
            "Sum of interior angles of a triangle = 180°.",
            "Exterior angle = Sum of opposite two interior angles.",
            "Pythagoras Theorem → In right-angled triangle: hyp² = base² + perp².",
            "Area = ½ × base × height or Heron’s Formula = √[s(s−a)(s−b)(s−c)].",
            "Equilateral Triangle: Area = (√3/4)a²; Height = (√3/2)a.",
            "Isosceles Triangle: Two equal sides, equal base angles.",
            "Similarity Theorems: AA, SAS, SSS.",
            "Congruency Rules: SSS, SAS, ASA, RHS."
          ]
        },
        {
          slno: 4,
          title: "Circle - Properties & Theorems",
          points: [
            "Angle subtended by an arc at the centre = 2 × angle at the circumference.",
            "Angles in the same segment are equal.",
            "Tangent to a circle is perpendicular to radius at the point of contact.",
            "Two tangents drawn from an external point are equal.",
            "Power of a point: PA × PB = PC × PD (for intersecting chords).",
            "Cyclic Quadrilateral: Opposite angles sum = 180°."
          ]
        },
        {
          slno: 5,
          title: "Polygons & Quadrilaterals",
          points: [
            "Sum of interior angles of n-sided polygon = (n−2) × 180°.",
            "Each interior angle of regular polygon = [(n−2)×180]/n.",
            "Square: All sides equal; diagonals equal & perpendicular.",
            "Rectangle: Opposite sides equal; diagonals equal.",
            "Rhombus: All sides equal; diagonals perpendicular but unequal.",
            "Parallelogram: Opposite sides parallel & equal; diagonals bisect each other.",
            "Trapezium: One pair of parallel sides; mid-segment = ½(sum of parallel sides)."
          ]
        },
        {
          slno: 6,
          title: "Coordinate Geometry",
          points: [
            "Distance Formula: d = √[(x₂ − x₁)² + (y₂ − y₁)²].",
            "Slope Formula: m = (y₂ − y₁)/(x₂ − x₁).",
            "Midpoint Formula: M = [(x₁ + x₂)/2, (y₁ + y₂)/2].",
            "Equation of Line: y − y₁ = m(x − x₁).",
            "Circle Equation: (x − h)² + (y − k)² = r²."
          ]
        },
        {
          slno: 7,
          title: "Important Geometry Shortcuts",
          points: [
            "Remember all triangle similarity properties; often used indirectly.",
            "Circle tangent properties are highly tested in CDS.",
            "For polygons, memorize formulas for interior/exterior angles.",
            "Use symmetry tricks for quick solving in exam."
          ]
        },
        {
          slno: 8,
          title: "CDS High-Yield Topics",
          points: [
            "Triangle similarity & area-based problems.",
            "Circle tangent & chord theorems.",
            "Cyclic quadrilateral properties.",
            "Distance & coordinate geometry formulas.",
            "Regular polygons angle-based problems."
          ]
        }

      ],




      "arithmetic":[
        {
          slno: 1,
          title: "Number System Basics",
          points: [
            "Divisibility Rules: Memorize for 2,3,4,5,6,8,9,11 (frequent in CDS).",
            "HCF & LCM: LCM × HCF = Product of Numbers.",
            "Even, Odd, Prime, Composite properties important.",
            "Remainder Theorems: Use for large powers & modular arithmetic."
          ]
        },
        {
          slno: 2,
          title: "Simplification & Approximation",
          points: [
            "BODMAS rule: Bracket → Order → Division → Multiplication → Addition → Subtraction.",
            "Surds & Indices: a^(m/n) = n√(a^m).",
            "CDS often gives speed-based simplification problems.",
            "Shortcut: Memorize square values (1-30) and cubes (1-20)."
          ]
        },
        {
          slno: 3,
          title: "Percentage",
          points: [
            "Percentage = (Value / Total) × 100.",
            "x% increase followed by y% decrease = x − y − (xy/100)%.",
            "Successive percentage problems are frequent in CDS.",
            "Memorize fraction-to-percentage conversions for 1/2,1/3,1/4,...1/20."
          ]
        },
        {
          slno: 4,
          title: "Profit, Loss & Discount",
          points: [
            "Profit% = (Profit / CP) × 100; Loss% = (Loss / CP) × 100.",
            "Selling Price (SP) = CP × (1 + Profit%) / 100.",
            "Discount% = (Discount / Marked Price) × 100.",
            "Multiple discounts formula: Net Discount = A + B − (A×B)/100."
          ]
        },
        {
          slno: 5,
          title: "Simple Interest (SI) & Compound Interest (CI)",
          points: [
            "SI = (P × R × T)/100.",
            "CI = P(1 + R/100)^T − P.",
            "Difference between CI & SI for 2 years: P(R/100)^2.",
            "CDS often gives tricky CI-SI combined problems."
          ]
        },
        {
          slno: 6,
          title: "Ratio & Proportion",
          points: [
            "Ratio: a:b = a/b; Proportion: a/b = c/d.",
            "If a:b = c:d, then (a+c):(b+d) is the compound ratio.",
            "Direct Proportion → x ∝ y; Inverse Proportion → x ∝ 1/y.",
            "Partnership: Profit share = Investment × Time."
          ]
        },
        {
          slno: 7,
          title: "Time, Speed & Distance",
          points: [
            "Speed = Distance / Time; Distance = Speed × Time.",
            "Relative Speed: If moving in same direction = |v1 − v2|; opposite = v1 + v2.",
            "Conversions: 1 km/hr = 5/18 m/s; 1 m/s = 18/5 km/hr.",
            "Boat & Stream: Effective speed = (u+v) downstream, (u−v) upstream."
          ]
        },
        {
          slno: 8,
          title: "Time & Work / Pipes & Cisterns",
          points: [
            "Work = Rate × Time.",
            "If A completes work in x days, A’s 1-day work = 1/x.",
            "Combined work = (A×B)/(A+B) days when A & B work together.",
            "Pipes problems are solved similarly using 1/day work concepts."
          ]
        },
        {
          slno: 9,
          title: "Average",
          points: [
            "Average = Sum of Observations / Total Number of Observations.",
            "For equal weights: Avg = (x+y)/2.",
            "Weighted Avg formula: (Σwx)/(Σw).",
            "Shortcut: If a new number x is added, new avg = old avg + (x − old avg)/n+1."
          ]
        },
        {
          slno: 10,
          title: "Mixture & Alligation",
          points: [
            "Rule of Alligation: Difference between concentration & mean used for ratio.",
            "Mean = (Quantity₁×%₁ + Quantity₂×%₂) / (Quantity₁ + Quantity₂).",
            "Used for milk-water, price, and concentration-based problems."
          ]
        },
        {
          slno: 11,
          title: "Partnership & Ages",
          points: [
            "Profit Sharing = Investment × Time.",
            "If A invests for t₁ months and B for t₂, A:B = (I₁×t₁):(I₂×t₂).",
            "Age Problems: Use difference constancy concept.",
            "CDS often gives reverse-age based word problems."
          ]
        },
        {
          slno: 12,
          title: "Important Shortcuts for CDS",
          points: [
            "Memorize squares (1-30) and cubes (1-20).",
            "Learn fraction-to-percentage conversion up to 1/20.",
            "Remember CI-SI formula differences to save time.",
            "Use ratio tricks to solve partnership and alligation faster.",
            "For speed-time-distance, practice relative speed problems thoroughly."
          ]
        },
        {
          slno: 13,
          title: "CDS High-Yield Topics",
          points: [
            "Percentage & Profit-Loss (5-6 questions).",
            "Time-Speed-Distance & Time-Work (4-5 questions).",
            "Simple & Compound Interest (3-4 questions).",
            "Mixture-Alligation & Averages (3-4 questions).",
            "Simplification & Ratio-Proportion (4-5 questions)."
          ]
        }

      ],




      "algebra":[
        {
          slno: 1,
          title: "Basic Identities",
          points: [
            "(a + b)² = a² + 2ab + b²",
            "(a - b)² = a² - 2ab + b²",
            "(a + b)(a - b) = a² - b²",
            "(x + a)(x + b) = x² + (a + b)x + ab",
            "(x - a)(x - b) = x² - (a + b)x + ab",
            "CDS frequently tests identities for simplification-based problems."
          ]
        },
        {
          slno: 2,
          title: "Cubes & Factorizations",
          points: [
            "(a + b)³ = a³ + b³ + 3ab(a + b)",
            "(a - b)³ = a³ - b³ - 3ab(a - b)",
            "a³ + b³ = (a + b)(a² - ab + b²)",
            "a³ - b³ = (a - b)(a² + ab + b²)",
            "Factorization patterns are directly asked in CDS exams."
          ]
        },
        {
          slno: 3,
          title: "Special Identities",
          points: [
            "(x + y + z)² = x² + y² + z² + 2(xy + yz + zx)",
            "(x³ + y³ + z³ - 3xyz) = (x + y + z)(x² + y² + z² - xy - yz - zx)",
            "Important for higher-order simplifications in CDS."
          ]
        },
        {
          slno: 4,
          title: "Linear Equations",
          points: [
            "General form: ax + b = 0 → x = -b/a.",
            "Two-variable system: a₁x + b₁y = c₁; a₂x + b₂y = c₂.",
            "Solve using substitution, elimination, or cross-multiplication.",
            "CDS often asks word problems converted into linear equations."
          ]
        },
        {
          slno: 5,
          title: "Quadratic Equations",
          points: [
            "General form: ax² + bx + c = 0.",
            "Roots formula: x = [-b ± √(b² - 4ac)] / 2a.",
            "Sum of roots (α + β) = -b/a.",
            "Product of roots (αβ) = c/a.",
            "Nature of roots: b² - 4ac > 0 → real & distinct, =0 → equal, <0 → imaginary.",
            "Shortcut: Factorization if discriminant is a perfect square."
          ]
        },
        {
          slno: 6,
          title: "Inequalities",
          points: [
            "If a > b and b > c ⇒ a > c (Transitive Property).",
            "Important for range-based problems in CDS.",
            "For quadratic inequalities: Solve equation → Check sign regions."
          ]
        },
        {
          slno: 7,
          title: "Rational Expressions & Surds",
          points: [
            "Simplify expressions using conjugate multiplication.",
            "Example: (√a - √b)/(√a + √b) → [(√a - √b)²]/(a - b).",
            "Important for CDS simplification-based questions."
          ]
        },
        {
          slno: 8,
          title: "Indices & Exponents",
          points: [
            "a⁰ = 1, a⁻ⁿ = 1/aⁿ, aᵐ × aⁿ = aᵐ⁺ⁿ.",
            "(aᵐ)ⁿ = aᵐⁿ.",
            "CDS commonly tests simplifications using exponent rules."
          ]
        },
        {
          slno: 9,
          title: "Logarithms",
          points: [
            "Definition: logₐ(M) = N ⇔ aᴺ = M.",
            "logₐ(MN) = logₐM + logₐN.",
            "logₐ(M/N) = logₐM - logₐN.",
            "logₐ(Mᵏ) = k × logₐM.",
            "Common logs (base 10) and natural logs (base e ≈ 2.718) appear in CDS."
          ]
        },
        {
          slno: 10,
          title: "Binomial Theorem Basics",
          points: [
            "(x + y)ⁿ = Σ [nCr × xⁿ⁻ʳ × yʳ], r = 0 to n.",
            "Use for coefficient and middle term-based CDS questions.",
            "Shortcut: For (1 + x)ⁿ, nth term = nCr × xʳ."
          ]
        },
        {
          slno: 11,
          title: "Word Problems in Algebra",
          points: [
            "CDS asks algebra-based age, ratio, and number problems.",
            "Convert statements into equations and solve stepwise.",
            "Practice speed-based simplifications for time efficiency."
          ]
        },
        {
          slno: 12,
          title: "CDS High-Yield Algebra Topics",
          points: [
            "Identities simplification (4-5 questions).",
            "Quadratic equations & roots (3-4 questions).",
            "Logarithms & indices (2-3 questions).",
            "Linear equations word problems (3-4 questions).",
            "Factorization and surds simplification (2-3 questions)."
          ]
        },
        {
          slno: 13,
          title: "Tips for CDS Algebra",
          points: [
            "Memorize all standard identities up to cubes.",
            "Focus on quadratic and linear equations.",
            "Practice at least 200 CDS previous-year algebra problems.",
            "Use elimination techniques for option-based simplification.",
            "Speed matters: target <2 mins per question."
          ]
        }

      ],




      "height-and-distance":[
        {
          slno: 1,
          title: "Basic Trigonometric Ratios",
          points: [
            "sin θ = Opposite / Hypotenuse",
            "cos θ = Adjacent / Hypotenuse",
            "tan θ = Opposite / Adjacent",
            "cot θ = 1 / tan θ",
            "sec θ = 1 / cos θ",
            "csc θ = 1 / sin θ",
            "In CDS, mostly **tan θ** and **cot θ** are used in height & distance questions."
          ]
        },
        {
          slno: 2,
          title: "Angle of Elevation",
          points: [
            "Angle formed between the **horizontal line** and the **line of sight** when looking **up** at an object.",
            "Used to calculate heights of towers, trees, buildings, etc.",
            "Formula: tan θ = Height / Distance."
          ]
        },
        {
          slno: 3,
          title: "Angle of Depression",
          points: [
            "Angle formed between the **horizontal line** and the **line of sight** when looking **down** from a height.",
            "Important for cliffs, bridges, hills, and downhill problems.",
            "Formula: tan θ = Height / Distance."
          ]
        },
        {
          slno: 4,
          title: "Key Formulas",
          points: [
            "Height (h) = Distance (d) × tan θ.",
            "Distance (d) = Height (h) / tan θ.",
            "If two angles of elevation θ₁ and θ₂ are given:",
            "→ Height = (d × tan θ₁ × tan θ₂) / (tan θ₂ - tan θ₁).",
            "For depression problems, formula remains the same."
          ]
        },
        {
          slno: 5,
          title: "Two Observers, One Object",
          points: [
            "When two observers at distances d₁ and d₂ view the same object at angles θ₁ and θ₂:",
            "Height = (d₁ × tan θ₁ - d₂ × tan θ₂) / (1 ± tan θ₁ × tan θ₂).",
            "Sign depends on whether object lies **between** or **beyond** observers."
          ]
        },
        {
          slno: 6,
          title: "Object Between Observer and Point",
          points: [
            "For a tower seen at two angles of elevation θ₁ and θ₂ from two points separated by distance D:",
            "Use simultaneous equations with tan θ₁ = h / x and tan θ₂ = h / (x + D).",
            "Common CDS pattern for two-point observation."
          ]
        },
        {
          slno: 7,
          title: "Reflection-Based Problems",
          points: [
            "If an object is reflected in water, **total vertical height = h + h'**.",
            "Formula: tan θ = (2h) / distance.",
            "Frequently asked in CDS for tower-water reflection questions."
          ]
        },
        {
          slno: 8,
          title: "Common Trigonometric Values",
          points: [
            "sin 30° = 1/2, cos 30° = √3/2, tan 30° = 1/√3.",
            "sin 45° = 1/√2, cos 45° = 1/√2, tan 45° = 1.",
            "sin 60° = √3/2, cos 60° = 1/2, tan 60° = √3.",
            "Memorize these values as CDS questions often use them directly."
          ]
        },
        {
          slno: 9,
          title: "Shortcut Tricks for CDS",
          points: [
            "Draw a right-angled triangle for every problem.",
            "Use tan θ = height / distance in single-angle questions.",
            "When two angles are given, apply:",
            "Height = (d × tan θ₁ × tan θ₂) / (tan θ₂ - tan θ₁).",
            "Memorize trigonometric values for 30°, 45°, 60° for fast solving."
          ]
        },
        {
          slno: 10,
          title: "CDS Exam Focus",
          points: [
            "Weightage: 2-4 questions (~8 marks).",
            "Frequently asked patterns:",
            "• Finding height using one/two angles of elevation.",
            "• Calculating distance using depression angles.",
            "• Reflection-based problems involving water/lakes.",
            "• Two observers viewing same object with known separation.",
            "Practice **previous 10 years CDS papers** for better speed and accuracy."
          ]
        }

      ],





      "trigonometry":[
        {
          slno: 1,
          title: "Basic Trigonometric Ratios",
          points: [
            "sin θ = Opposite / Hypotenuse",
            "cos θ = Adjacent / Hypotenuse",
            "tan θ = Opposite / Adjacent",
            "cot θ = 1 / tan θ",
            "sec θ = 1 / cos θ",
            "csc θ = 1 / sin θ",
            "CDS mostly tests **tan θ** and **cot θ** based applications."
          ]
        },
        {
          slno: 2,
          title: "Trigonometric Values (Must Memorize)",
          points: [
            "θ = 0° → sin 0 = 0, cos 0 = 1, tan 0 = 0",
            "θ = 30° → sin = 1/2, cos = √3/2, tan = 1/√3",
            "θ = 45° → sin = 1/√2, cos = 1/√2, tan = 1",
            "θ = 60° → sin = √3/2, cos = 1/2, tan = √3",
            "θ = 90° → sin = 1, cos = 0, tan = ∞",
            "Most CDS questions directly use these values."
          ]
        },
        {
          slno: 3,
          title: "Trigonometric Identities",
          points: [
            "sin²θ + cos²θ = 1",
            "1 + tan²θ = sec²θ",
            "1 + cot²θ = csc²θ",
            "sin 2θ = 2 sin θ cos θ",
            "cos 2θ = cos²θ − sin²θ = 2cos²θ − 1 = 1 − 2sin²θ",
            "tan 2θ = 2tanθ / (1 − tan²θ)",
            "CDS often asks direct identity-based questions."
          ]
        },
        {
          slno: 4,
          title: "Trigonometric Ratios of Complementary Angles",
          points: [
            "sin (90° − θ) = cos θ",
            "cos (90° − θ) = sin θ",
            "tan (90° − θ) = cot θ",
            "cot (90° − θ) = tan θ",
            "sec (90° − θ) = csc θ",
            "csc (90° − θ) = sec θ",
            "CDS often uses these in simplification problems."
          ]
        },
        {
          slno: 5,
          title: "Sum & Difference Formulas",
          points: [
            "sin(A ± B) = sinA cosB ± cosA sinB",
            "cos(A ± B) = cosA cosB ∓ sinA sinB",
            "tan(A ± B) = (tanA ± tanB) / (1 ∓ tanA tanB)",
            "Very useful in CDS simplification and problem-solving."
          ]
        },
        {
          slno: 6,
          title: "Product-to-Sum & Sum-to-Product",
          points: [
            "sinA sinB = ½[cos(A − B) − cos(A + B)]",
            "cosA cosB = ½[cos(A − B) + cos(A + B)]",
            "sinA cosB = ½[sin(A + B) + sin(A − B)]",
            "These formulas occasionally appear in CDS tricky simplifications."
          ]
        },
        {
          slno: 7,
          title: "Heights & Distances Formulas",
          points: [
            "tan θ = Height / Distance",
            "Height = Distance × tan θ",
            "Distance = Height / tan θ",
            "Two-angle formula: h = (d × tan θ₁ × tan θ₂) / (tan θ₂ − tan θ₁)",
            "CDS always asks 2-3 questions from this."
          ]
        },
        {
          slno: 8,
          title: "Trigonometric Equations",
          points: [
            "sin θ = 0 → θ = nπ",
            "cos θ = 0 → θ = (2n+1)π/2",
            "tan θ = 0 → θ = nπ",
            "For CDS, only basic solutions within 0°−360° are asked."
          ]
        },
        {
          slno: 9,
          title: "Trigonometric Values for Special Angles",
          points: [
            "sin 15° = (√6 − √2) / 4",
            "cos 15° = (√6 + √2) / 4",
            "sin 75° = cos 15° = (√6 + √2) / 4",
            "cos 75° = sin 15° = (√6 − √2) / 4",
            "tan 15° = 2 − √3, tan 75° = 2 + √3",
            "CDS sometimes asks these directly."
          ]
        },
        {
          slno: 10,
          title: "Shortcut Tricks for CDS",
          points: [
            "Always draw a triangle for height-distance problems.",
            "Memorize values of sin, cos, tan for 0°, 30°, 45°, 60°, 90°.",
            "Use Pythagoras theorem wherever needed.",
            "Focus on simplification tricks using identities.",
            "In CDS, 80% questions are direct formula-based."
          ]
        },
        {
          slno: 11,
          title: "CDS Exam Focus",
          points: [
            "Weightage: 8-12 marks (~4-6 questions).",
            "Most common types:",
            "• Direct value-based questions.",
            "• Trigonometric identity simplifications.",
            "• Height and distance problems.",
            "• Angle-based formula applications.",
            "Solving **previous 10 years CDS papers** is enough."
          ]
        }

      ]

    },





    english:{
      "spotting-errors":[
        {
          slno: 1,
          title: "Subject-Verb Agreement",
          points: [
            "Singular subjects take singular verbs; plural subjects take plural verbs.",
            "When two subjects are joined by 'and' → plural verb (e.g., 'Ram and Shyam are friends').",
            "When two subjects are joined by 'either/or' or 'neither/nor' → verb agrees with the nearest subject.",
            "Uncountable nouns (advice, furniture, information) → singular verb."
          ]
        },
        {
          slno: 2,
          title: "Pronoun Usage",
          points: [
            "Pronoun must agree with its antecedent in number, gender, and person.",
            "'Each', 'Every', 'Either', 'Neither' take singular pronouns.",
            "Avoid 'he/she' repetition → use 'they' for gender neutrality in modern usage."
          ]
        },
        {
          slno: 3,
          title: "Tenses Consistency",
          points: [
            "Maintain the same tense in a sentence unless a time change is indicated.",
            "For universal truths, use present tense even if reported in past (e.g., 'He said the earth is round').",
            "Avoid mixing past perfect with simple past without cause."
          ]
        },
        {
          slno: 4,
          title: "Articles (A, An, The)",
          points: [
            "Use 'a' before consonant sounds, 'an' before vowel sounds (e.g., 'a university', 'an honest man').",
            "Use 'the' for something specific, unique, or already mentioned.",
            "No article before plural or uncountable nouns when talking generally."
          ]
        },
        {
          slno: 5,
          title: "Prepositions",
          points: [
            "Common fixed prepositions: 'capable of', 'interested in', 'good at', 'different from'.",
            "Avoid unnecessary prepositions: 'Where are you going?' (not 'Where are you going to?').",
            "In/At/On usage: 'in' for months/years, 'on' for days/dates, 'at' for specific times."
          ]
        },
        {
          slno: 6,
          title: "Modifiers Placement",
          points: [
            "Place adjectives/adverbs close to the word they modify.",
            "Avoid misplaced modifiers: 'She almost drove her kids to school every day' ≠ 'She drove her kids to school almost every day'."
          ]
        },
        {
          slno: 7,
          title: "Parallelism",
          points: [
            "Items in a list or comparison should be in the same grammatical form.",
            "Incorrect: 'She likes dancing, to sing, and reading.'",
            "Correct: 'She likes dancing, singing, and reading.'"
          ]
        },
        {
          slno: 8,
          title: "Redundancy",
          points: [
            "Avoid double negatives: 'I don’t need no help' → 'I don’t need any help'.",
            "Avoid repeating meaning: 'Return back' → 'Return'."
          ]
        },
        {
          slno: 9,
          title: "Confusing Words",
          points: [
            "'Accept' vs 'Except' → Accept = receive, Except = exclude.",
            "'Affect' vs 'Effect' → Affect = influence (verb), Effect = result (noun).",
            "'Fewer' for countable, 'Less' for uncountable."
          ]
        },
        {
          slno: 10,
          title: "Common CDS Traps",
          points: [
            "Wrong idioms: 'Cope up with' ❌ → 'Cope with' ✅.",
            "Wrong comparison: 'He is superior than me' ❌ → 'He is superior to me' ✅.",
            "Wrong preposition with 'different': 'Different than' ❌ → 'Different from' ✅."
          ]
        }

      ],




      "sentence-improvement":[
        {
          slno: 1,
          title: "Subject-Verb Agreement",
          points: [
            "Ensure the verb matches the subject in number and person.",
            "CDS trap: Intervening phrases ('along with', 'together with') do not change verb number.",
            "Example: 'The captain, along with his men, is ready.' ✅"
          ]
        },
        {
          slno: 2,
          title: "Tense Consistency",
          points: [
            "Maintain the same tense unless a shift in time is required.",
            "Use past perfect for an earlier past action before another past action.",
            "Example: 'He had left before I reached.' ✅"
          ]
        },
        {
          slno: 3,
          title: "Pronoun Reference",
          points: [
            "Pronouns must clearly refer to the correct noun.",
            "Avoid ambiguity in pronoun usage.",
            "Example: 'When Ramesh met Suresh, he gave him a book' → unclear; specify."
          ]
        },
        {
          slno: 4,
          title: "Preposition Usage",
          points: [
            "Fixed expressions: 'good at', 'interested in', 'capable of'.",
            "Avoid extra prepositions: 'Where are you going?' not 'Where are you going to?'.",
            "CDS often tests 'different from' not 'different than'."
          ]
        },
        {
          slno: 5,
          title: "Modifiers",
          points: [
            "Modifiers should be placed close to the words they describe.",
            "Avoid dangling modifiers: 'Walking down the road, a car almost hit me' ❌",
            "Correct: 'Walking down the road, I was almost hit by a car.' ✅"
          ]
        },
        {
          slno: 6,
          title: "Parallelism",
          points: [
            "Items in a series or comparison must be in the same grammatical form.",
            "Example: 'She likes dancing, singing, and reading' ✅; not 'dancing, to sing, and reading' ❌."
          ]
        },
        {
          slno: 7,
          title: "Active vs Passive Voice",
          points: [
            "CDS prefers concise active voice unless passive is logically needed.",
            "Example: 'The committee approved the plan' ✅ instead of 'The plan was approved by the committee' ❌."
          ]
        },
        {
          slno: 8,
          title: "Idiomatic Expressions",
          points: [
            "Follow standard idiom usage: 'capable of', 'accused of', 'fond of'.",
            "Incorrect: 'He is good in cricket' ❌ → Correct: 'He is good at cricket' ✅."
          ]
        },
        {
          slno: 9,
          title: "Avoid Redundancy",
          points: [
            "Remove unnecessary words: 'Return back' → 'Return'.",
            "Avoid double negatives: 'I don’t need no help' ❌ → 'I don’t need any help' ✅."
          ]
        },
        {
          slno: 10,
          title: "Word Choice & Confusing Words",
          points: [
            "'Affect' (verb: influence) vs 'Effect' (noun: result).",
            "'Fewer' (countable) vs 'Less' (uncountable).",
            "'Accept' (receive) vs 'Except' (exclude)."
          ]
        },
        {
          slno: 11,
          title: "Comparison Rules",
          points: [
            "Use 'than' after comparative adjectives.",
            "Adjectives like 'superior', 'junior', 'senior', 'preferable' take 'to', not 'than'.",
            "Example: 'He is superior to his colleagues' ✅."
          ]
        },
        {
          slno: 12,
          title: "Conditional Sentences",
          points: [
            "Type 1: If + present, will + verb (real present/future possibility).",
            "Type 2: If + past, would + verb (hypothetical present/future).",
            "Type 3: If + past perfect, would have + past participle (hypothetical past)."
          ]
        }

      ],




      "fill-in-the-blanks":[
        {
          slno: 1,
          title: "Prepositions in Fixed Phrases",
          points: [
            "Common UPSC traps: 'accused of', 'interested in', 'fond of', 'deprived of'.",
            "Place correct preposition as per idiomatic usage.",
            "Example: He is good ___ mathematics. (at)"
          ]
        },
        {
          slno: 2,
          title: "Verb Forms & Tense Consistency",
          points: [
            "Choose correct verb form according to tense and subject.",
            "Watch out for past perfect in earlier past action.",
            "Example: By the time I reached, he ___ left. (had)"
          ]
        },
        {
          slno: 3,
          title: "Articles (a, an, the)",
          points: [
            "'A' before consonant sound, 'An' before vowel sound, 'The' for specific/unique items.",
            "CDS trap: 'The sun rises in the east', not 'A sun rises in east'."
          ]
        },
        {
          slno: 4,
          title: "Subject-Verb Agreement",
          points: [
            "Singular subject → singular verb, plural → plural verb.",
            "Ignore phrases between subject & verb when deciding.",
            "Example: The quality of apples ___ poor. (is)"
          ]
        },
        {
          slno: 5,
          title: "Conjunctions",
          points: [
            "Select correct linking word for meaning (and, but, although, because).",
            "CDS tests 'though... yet', 'either... or', 'neither... nor'."
          ]
        },
        {
          slno: 6,
          title: "Conditional Sentences",
          points: [
            "Type 1: If + present → will + verb.",
            "Type 2: If + past → would + verb.",
            "Type 3: If + past perfect → would have + past participle."
          ]
        },
        {
          slno: 7,
          title: "Vocabulary & Context Meaning",
          points: [
            "Choose word that best fits the sentence meaning.",
            "CDS loves synonyms, antonyms, and precise words.",
            "Example: He was ___ from school for indiscipline. (expelled)"
          ]
        },
        {
          slno: 8,
          title: "Phrasal Verbs",
          points: [
            "Learn common ones: 'give up' (quit), 'put off' (postpone), 'look into' (investigate).",
            "CDS asks meaning-based blanks."
          ]
        },
        {
          slno: 9,
          title: "Collocations",
          points: [
            "Certain words naturally go together: 'make a decision', 'do homework', 'heavy rain'.",
            "Incorrect collocation → wrong answer."
          ]
        },
        {
          slno: 10,
          title: "Pronoun Reference",
          points: [
            "Pronoun must agree in number, person, gender with its antecedent.",
            "Example: Everyone must bring ___ own lunch. (his/her)"
          ]
        },
        {
          slno: 11,
          title: "Degree of Comparison",
          points: [
            "Positive, comparative, superlative forms must match meaning.",
            "CDS trap: 'more better' ❌, 'better' ✅."
          ]
        },
        {
          slno: 12,
          title: "Common Confusing Words",
          points: [
            "'Affect' (verb: influence) vs 'Effect' (noun: result).",
            "'Principal' (head) vs 'Principle' (rule).",
            "'Stationary' (not moving) vs 'Stationery' (paper goods)."
          ]
        }

      ],




      "synonyms":[
        {
          slno: 1,
          title: "High-Frequency CDS Words",
          points: [
            "'Abandon' → give up, desert, forsake.",
            "'Abate' → reduce, diminish, lessen.",
            "'Abridge' → shorten, condense, curtail."
          ]
        },
        {
          slno: 2,
          title: "Personality & Behaviour Terms",
          points: [
            "'Amiable' → friendly, affable, cordial.",
            "'Arrogant' → haughty, conceited, overbearing.",
            "'Benevolent' → kind, charitable, compassionate."
          ]
        },
        {
          slno: 3,
          title: "Emotions & Feelings",
          points: [
            "'Ecstasy' → joy, delight, bliss.",
            "'Grief' → sorrow, sadness, anguish.",
            "'Irritate' → annoy, vex, provoke."
          ]
        },
        {
          slno: 4,
          title: "Military & Discipline Related",
          points: [
            "'Valour' → bravery, courage, gallantry.",
            "'Fortify' → strengthen, secure, reinforce.",
            "'Strategic' → planned, tactical, calculated."
          ]
        },
        {
          slno: 5,
          title: "Common Government/Exam Words",
          points: [
            "'Consensus' → agreement, accord, harmony.",
            "'Mandate' → order, command, directive.",
            "'Revoke' → cancel, withdraw, annul."
          ]
        },
        {
          slno: 6,
          title: "Nature & Science Related",
          points: [
            "'Arid' → dry, barren, parched.",
            "'Erode' → wear away, corrode, deteriorate.",
            "'Dense' → thick, compact, heavy."
          ]
        },
        {
          slno: 7,
          title: "Movement & Change",
          points: [
            "'Advance' → progress, proceed, promote.",
            "'Halt' → stop, cease, terminate.",
            "'Transform' → change, convert, metamorphose."
          ]
        },
        {
          slno: 8,
          title: "Negative Traits",
          points: [
            "'Malicious' → spiteful, harmful, vindictive.",
            "'Deceit' → fraud, dishonesty, trickery.",
            "'Negligent' → careless, inattentive, lax."
          ]
        },
        {
          slno: 9,
          title: "Positive Qualities",
          points: [
            "'Prudent' → wise, cautious, judicious.",
            "'Diligent' → hardworking, industrious, persistent.",
            "'Generous' → giving, kind, magnanimous."
          ]
        },
        {
          slno: 10,
          title: "CDS Trap Words",
          points: [
            "'Acute' → sharp, severe, intense.",
            "'Candid' → honest, frank, straightforward.",
            "'Erroneous' → wrong, incorrect, mistaken."
          ]
        },
        {
          slno: 11,
          title: "Time & Frequency",
          points: [
            "'Intermittent' → periodic, sporadic, occasional.",
            "'Perpetual' → everlasting, continuous, unceasing.",
            "'Prompt' → immediate, quick, instant."
          ]
        },
        {
          slno: 12,
          title: "Miscellaneous Must-Know",
          points: [
            "'Concur' → agree, consent, coincide.",
            "'Mitigate' → reduce, alleviate, relieve.",
            "'Scrutinize' → examine, inspect, investigate."
          ]
        }

      ],





      "antonyms":[
        {
          slno: 1,
          title: "Commonly Asked in CDS",
          points: [
            "'Abundant' ↔ scarce, meagre, insufficient.",
            "'Admire' ↔ despise, hate, detest.",
            "'Advance' ↔ retreat, withdraw, recede."
          ]
        },
        {
          slno: 2,
          title: "Personality & Behaviour",
          points: [
            "'Arrogant' ↔ humble, modest, meek.",
            "'Benevolent' ↔ malevolent, cruel, unkind.",
            "'Diligent' ↔ lazy, idle, negligent."
          ]
        },
        {
          slno: 3,
          title: "Emotions & Feelings",
          points: [
            "'Ecstasy' ↔ misery, sorrow, despair.",
            "'Grief' ↔ joy, happiness, delight.",
            "'Irritate' ↔ soothe, calm, pacify."
          ]
        },
        {
          slno: 4,
          title: "Military & Discipline Related",
          points: [
            "'Valour' ↔ cowardice, fear, timidity.",
            "'Fortify' ↔ weaken, undermine, impair.",
            "'Strategic' ↔ unplanned, random, aimless."
          ]
        },
        {
          slno: 5,
          title: "Government & Policy Terms",
          points: [
            "'Consensus' ↔ disagreement, discord, dissent.",
            "'Mandate' ↔ refusal, rejection, veto.",
            "'Revoke' ↔ approve, permit, sanction."
          ]
        },
        {
          slno: 6,
          title: "Nature & Science",
          points: [
            "'Arid' ↔ fertile, moist, lush.",
            "'Erode' ↔ build, restore, strengthen.",
            "'Dense' ↔ sparse, thin, light."
          ]
        },
        {
          slno: 7,
          title: "Movement & Change",
          points: [
            "'Halt' ↔ proceed, continue, advance.",
            "'Transform' ↔ preserve, maintain, retain.",
            "'Expand' ↔ contract, shrink, diminish."
          ]
        },
        {
          slno: 8,
          title: "Negative Traits",
          points: [
            "'Malicious' ↔ kind, benevolent, helpful.",
            "'Deceit' ↔ honesty, truthfulness, integrity.",
            "'Negligent' ↔ careful, attentive, vigilant."
          ]
        },
        {
          slno: 9,
          title: "Positive Qualities",
          points: [
            "'Prudent' ↔ careless, reckless, imprudent.",
            "'Generous' ↔ stingy, selfish, miserly.",
            "'Loyal' ↔ disloyal, unfaithful, treacherous."
          ]
        },
        {
          slno: 10,
          title: "CDS Trap Words",
          points: [
            "'Acute' ↔ dull, blunt, mild.",
            "'Candid' ↔ dishonest, secretive, evasive.",
            "'Erroneous' ↔ correct, accurate, true."
          ]
        },
        {
          slno: 11,
          title: "Time & Frequency",
          points: [
            "'Intermittent' ↔ continuous, constant, unbroken.",
            "'Perpetual' ↔ temporary, momentary, brief.",
            "'Prompt' ↔ delayed, late, sluggish."
          ]
        },
        {
          slno: 12,
          title: "Miscellaneous Must-Know",
          points: [
            "'Concur' ↔ disagree, oppose, dissent.",
            "'Mitigate' ↔ worsen, aggravate, intensify.",
            "'Scrutinize' ↔ neglect, ignore, overlook."
          ]
        }

      ],



      "ordering-of-words":[
        {
          slno: 1,
          title: "Basic Structure Rules",
          points: [
            "Identify Subject → Verb → Object sequence as default order.",
            "Look for connectors (and, but, because) to join clauses logically.",
            "Time phrases usually come at start or end depending on emphasis."
          ]
        },
        {
          slno: 2,
          title: "Common CDS Patterns",
          points: [
            "Introductory phrase → main action → conclusion.",
            "Cause comes before effect in most formal constructions.",
            "Pronouns must refer clearly to the nearest noun."
          ]
        },
        {
          slno: 3,
          title: "Clue Words & Triggers",
          points: [
            "Words like 'therefore', 'thus', 'hence' indicate conclusion comes later.",
            "'Although', 'despite', 'however' introduce contrast and go before opposite idea.",
            "Time order words: first, next, then, finally."
          ]
        },
        {
          slno: 4,
          title: "Elimination Strategy",
          points: [
            "Eliminate sequences where articles (a, an, the) are not followed by a noun.",
            "Remove options where verbs do not agree with subjects.",
            "Discard sentences that start with conjunctions unless linking a prior clause."
          ]
        },
        {
          slno: 5,
          title: "Frequent CDS Question Types",
          points: [
            "Rearranging a statement to form a meaningful sentence.",
            "Ordering steps of a process logically.",
            "Placing events in correct chronological order."
          ]
        },
        {
          slno: 6,
          title: "Examples to Practice",
          points: [
            "Example 1: 'in the east / rises / the sun' → 'The sun rises in the east'.",
            "Example 2: 'to win / he / determined / was' → 'He was determined to win'.",
            "Example 3: 'to the meeting / she / did not / come' → 'She did not come to the meeting'."
          ]
        },
        {
          slno: 7,
          title: "CDS Trap Avoidance",
          points: [
            "Do not be misled by correct grammar but wrong logic.",
            "Check that modifiers are placed next to the words they modify.",
            "Avoid misplaced time/place phrases."
          ]
        },
        {
          slno: 8,
          title: "Quick Revision Checklist",
          points: [
            "Subject-Verb agreement correct.",
            "Logical sequence maintained.",
            "No dangling modifiers or misplaced phrases."
          ]
        }

      ],



      "ordering-of-sentences":[
        {
          slno: 1,
          title: "Understanding the Question",
          points: [
            "You are given jumbled sentences that together form a paragraph.",
            "Goal: Arrange them in a logical, coherent sequence.",
            "Common in CDS to test reading comprehension + logic."
          ]
        },
        {
          slno: 2,
          title: "Identify Opening Sentence",
          points: [
            "Look for a sentence introducing the topic without referring to prior ideas.",
            "It usually contains general background information.",
            "Avoid starting with pronouns (he, it, they) unless context is already set."
          ]
        },
        {
          slno: 3,
          title: "Find the Conclusion",
          points: [
            "Concluding sentence often summarizes or gives a final remark.",
            "Contains clue words: therefore, thus, hence, in conclusion.",
            "No new ideas should appear in conclusion."
          ]
        },
        {
          slno: 4,
          title: "Linking Sentences",
          points: [
            "Pronouns should clearly refer to nouns in previous sentence.",
            "Cause-effect: Cause comes before effect unless emphasis dictates otherwise.",
            "Chronology: Past events first, future events later."
          ]
        },
        {
          slno: 5,
          title: "Connector Clues",
          points: [
            "'However', 'But', 'Although' → contrast follows previous idea.",
            "'Moreover', 'In addition' → add related information.",
            "'Firstly', 'Secondly', 'Finally' → signal sequence."
          ]
        },
        {
          slno: 6,
          title: "CDS-Specific Patterns",
          points: [
            "History-based: Dates/events arranged chronologically.",
            "Science/Process: Steps in logical procedural order.",
            "General Essay-type: Intro → body → conclusion."
          ]
        },
        {
          slno: 7,
          title: "Elimination Strategy",
          points: [
            "Remove sequences where logical flow is broken.",
            "Sentences that refer to undefined 'this', 'these', 'such' cannot be first.",
            "Avoid abrupt topic jumps between sentences."
          ]
        },
        {
          slno: 8,
          title: "Examples to Practice",
          points: [
            "Example 1: A: 'Mahatma Gandhi led the Salt March in 1930.' B: 'This event became a significant milestone in India's freedom struggle.' → Sequence: A → B.",
            "Example 2: A: 'First, heat the solution.' B: 'Then, add the reagent.' → Sequence: A → B."
          ]
        },
        {
          slno: 9,
          title: "Quick Revision Checklist",
          points: [
            "Intro first, conclusion last.",
            "Pronouns/nouns match correctly.",
            "Chronological or logical order maintained."
          ]
        }

      ],




      "comprehension":[
        {
          slno: 1,
          title: "Purpose in CDS Exam",
          points: [
            "Tests ability to read, understand, and interpret passages quickly.",
            "Assesses vocabulary, inference, and analytical skills.",
            "Passages are factual, narrative, or opinion-based."
          ]
        },
        {
          slno: 2,
          title: "Types of Questions",
          points: [
            "Factual: Directly answered from the passage.",
            "Inference: Based on logical conclusions not directly stated.",
            "Vocabulary: Meaning of words/phrases in context.",
            "Theme/Main Idea: Central message of the passage."
          ]
        },
        {
          slno: 3,
          title: "Reading Strategy",
          points: [
            "Read the questions first to know what to look for.",
            "Scan the passage for keywords from the question.",
            "Skim for general sense, then read carefully where needed."
          ]
        },
        {
          slno: 4,
          title: "Key Skills for CDS",
          points: [
            "Spot synonyms/antonyms in context.",
            "Identify author’s tone: critical, neutral, persuasive.",
            "Distinguish between fact and opinion."
          ]
        },
        {
          slno: 5,
          title: "Time Management",
          points: [
            "Average: ~2–3 minutes per passage in CDS.",
            "Do not over-read; focus on relevant sections.",
            "Answer direct questions first, inference questions later."
          ]
        },
        {
          slno: 6,
          title: "Common Traps",
          points: [
            "Misinterpreting words with multiple meanings.",
            "Selecting an answer that is true but not supported by passage.",
            "Overlooking qualifiers like 'always', 'never', 'some'."
          ]
        },
        {
          slno: 7,
          title: "Practice Tips",
          points: [
            "Read editorials/articles daily to improve speed.",
            "Summarize paragraphs in 1–2 lines to train for main idea questions.",
            "Underline clue words while reading."
          ]
        },
        {
          slno: 8,
          title: "CDS-Specific Example",
          points: [
            "Passage: 'During the Industrial Revolution, urban populations grew rapidly, leading to poor sanitation.'",
            "Q: 'What was the main cause of poor sanitation?' → A: 'Rapid growth of urban populations.'"
          ]
        },
        {
          slno: 9,
          title: "Quick Revision Checklist",
          points: [
            "Read questions before passage.",
            "Mark key points while reading.",
            "Verify answers are supported by passage text."
          ]
        }

      ],




      "cloze-test":[
        {
          slno: 1,
          title: "Purpose in CDS Exam",
          points: [
            "Tests grammar, vocabulary, and contextual understanding.",
            "Assesses ability to choose words that fit meaning and structure.",
            "Usually one paragraph with 10–15 blanks."
          ]
        },
        {
          slno: 2,
          title: "Types of Blanks",
          points: [
            "Grammar-based: Articles, prepositions, conjunctions, tenses.",
            "Vocabulary-based: Synonyms, antonyms, context-specific words.",
            "Idiomatic usage: Phrases or collocations fitting naturally."
          ]
        },
        {
          slno: 3,
          title: "Solving Strategy",
          points: [
            "Read the entire passage first for context.",
            "Predict the missing word before looking at options.",
            "Use grammar clues from surrounding words.",
            "Eliminate grammatically or contextually wrong choices."
          ]
        },
        {
          slno: 4,
          title: "Grammar Rules to Recall",
          points: [
            "Subject–verb agreement.",
            "Correct tense usage according to passage timeline.",
            "Prepositions commonly used with certain verbs/adjectives.",
            "Articles 'a', 'an', 'the' placement rules."
          ]
        },
        {
          slno: 5,
          title: "Vocabulary Clues",
          points: [
            "Look for synonyms/antonyms hints in nearby sentences.",
            "Identify tone (formal/informal) to pick suitable words.",
            "Recognize collocations (e.g., 'make a decision', not 'do a decision')."
          ]
        },
        {
          slno: 6,
          title: "Time Management",
          points: [
            "Spend ~1 min reading passage, then fill blanks quickly.",
            "Do not get stuck; move ahead and return if needed."
          ]
        },
        {
          slno: 7,
          title: "Common Traps",
          points: [
            "Choosing an option that fits grammar but not meaning.",
            "Ignoring transitions like 'however', 'therefore'.",
            "Missing plural/singular consistency."
          ]
        },
        {
          slno: 8,
          title: "CDS-Specific Example",
          points: [
            "Passage: 'The soldiers ____ (1) the camp early in the morning.'",
            "Options for (1): {left, leave, leaving, leaves}",
            "Correct: 'left' → Past tense matches timeline."
          ]
        },
        {
          slno: 9,
          title: "Quick Revision Checklist",
          points: [
            "Read for meaning before filling.",
            "Apply grammar rules.",
            "Check if filled sentence sounds natural."
          ]
        }

      ],




      "idioms-and-phrases":[
        {
          slno: 1,
          title: "Purpose in CDS Exam",
          points: [
            "Tests ability to interpret figurative language.",
            "Often asked as direct meaning or in sentence usage.",
            "Covers common idioms used in newspapers, military, and general English."
          ]
        },
        {
          slno: 2,
          title: "Solving Strategy",
          points: [
            "Understand figurative rather than literal meaning.",
            "Relate to familiar contexts or proverbs.",
            "Eliminate options that don't fit sentence tone."
          ]
        },
        {
          slno: 3,
          title: "High-Frequency CDS Idioms",
          points: [
            "'Burn the midnight oil' – Work late into the night.",
            "'By leaps and bounds' – Very quickly.",
            "'Hit the nail on the head' – Describe exactly what is causing a problem.",
            "'Call it a day' – Stop working for the day.",
            "'In the nick of time' – Just in time."
          ]
        },
        {
          slno: 4,
          title: "Military & CDS-Relevant Idioms",
          points: [
            "'Hold the fort' – Take care of responsibilities in someone's absence.",
            "'Bite the bullet' – Face a difficult situation bravely.",
            "'Keep your powder dry' – Be prepared for action.",
            "'On the front line' – In a position of direct involvement.",
            "'Drop your guard' – Become less careful."
          ]
        },
        {
          slno: 5,
          title: "Context Clues",
          points: [
            "Look at sentence before & after idiom.",
            "Check emotional tone (positive/negative).",
            "Match meaning with context."
          ]
        },
        {
          slno: 6,
          title: "CDS Practice Example",
          points: [
            "Sentence: 'In the debate, Rohan really hit the nail on the head.'",
            "Meaning: He addressed the exact issue."
          ]
        },
        {
          slno: 7,
          title: "Quick Revision Tips",
          points: [
            "Revise 200–250 most common idioms before exam.",
            "Focus on those repeatedly appearing in CDS papers.",
            "Make flashcards for tricky ones."
          ]
        }

      ],



      "active-passive-voice":[
        {
          slno: 1,
          title: "Purpose in CDS Exam",
          points: [
            "Tests ability to change sentence structure without changing meaning.",
            "Commonly appears in English section with 3–5 questions.",
            "Focuses on correct tense, subject-object reversal, and verb form."
          ]
        },
        {
          slno: 2,
          title: "Key Conversion Rule",
          points: [
            "Subject ↔ Object swap positions.",
            "Main verb changes to past participle (V3).",
            "Appropriate form of 'be' or 'get' is added depending on tense."
          ]
        },
        {
          slno: 3,
          title: "Tense-Wise Passive Forms",
          points: [
            "Present Simple: am/is/are + V3 → 'The work is done.'",
            "Past Simple: was/were + V3 → 'The letter was written.'",
            "Future Simple: will be + V3 → 'The meeting will be held.'",
            "Present Continuous: am/is/are being + V3 → 'The work is being done.'",
            "Past Continuous: was/were being + V3 → 'The road was being repaired.'",
            "Present Perfect: has/have been + V3 → 'The task has been completed.'"
          ]
        },
        {
          slno: 4,
          title: "Special Cases in CDS",
          points: [
            "Modals: modal + be + V3 → 'Can be done', 'Must be finished'.",
            "Imperatives: 'Let + object + be + V3' → 'Let the work be started.'",
            "Questions: Auxiliary comes before subject → 'Was the work finished?'"
          ]
        },
        {
          slno: 5,
          title: "CDS Practice Example",
          points: [
            "Active: 'The officer will review the report.'",
            "Passive: 'The report will be reviewed by the officer.'"
          ]
        },
        {
          slno: 6,
          title: "Quick Revision Tips",
          points: [
            "Memorize be-forms for all tenses.",
            "Watch for retained objects in some verbs ('give', 'show').",
            "Eliminate grammatically incorrect passive forms in MCQs."
          ]
        }

      ],



      "direct-indirect-speech":[
        {
          slno: 1,
          title: "Purpose in CDS Exam",
          points: [
            "Tests knowledge of converting quoted (exact) speech into reported speech.",
            "Focus on tense backshifting, pronoun changes, and time/place word adjustments.",
            "Usually 3–4 questions appear in the English section."
          ]
        },
        {
          slno: 2,
          title: "Basic Conversion Rules",
          points: [
            "Remove quotation marks.",
            "Reporting verb changes ('say', 'tell', 'ask').",
            "Pronouns shift according to speaker/listener context.",
            "Tense changes if reporting verb is in past tense."
          ]
        },
        {
          slno: 3,
          title: "Tense Backshift (When Reporting Verb is Past)",
          points: [
            "Present Simple → Past Simple: 'I eat' → 'He said he ate'.",
            "Present Continuous → Past Continuous: 'I am reading' → 'He said he was reading'.",
            "Present Perfect → Past Perfect: 'I have done' → 'He said he had done'.",
            "Past Simple → Past Perfect: 'I wrote' → 'He said he had written'.",
            "Will → Would: 'I will go' → 'He said he would go'."
          ]
        },
        {
          slno: 4,
          title: "No Change Cases",
          points: [
            "If reporting verb is in present/future tense.",
            "Universal truths and habitual facts: 'The sun rises in the east'.",
            "Past Perfect remains unchanged."
          ]
        },
        {
          slno: 5,
          title: "Time & Place Word Changes",
          points: [
            "now → then",
            "today → that day",
            "yesterday → the previous day",
            "tomorrow → the next day",
            "here → there",
            "this → that"
          ]
        },
        {
          slno: 6,
          title: "Reporting Questions",
          points: [
            "WH-questions: keep WH-word, change tense: 'He asked, \"Where are you going?\"' → 'He asked where I was going.'",
            "Yes/No questions: use 'if' or 'whether': 'She asked, \"Are you ready?\"' → 'She asked if I was ready.'"
          ]
        },
        {
          slno: 7,
          title: "Reporting Commands/Requests",
          points: [
            "Use 'to + verb' for affirmative commands: 'He said, \"Open the door.\"' → 'He told me to open the door.'",
            "Use 'not to + verb' for negative commands: 'She said, \"Don't shout.\"' → 'She told me not to shout.'"
          ]
        },
        {
          slno: 8,
          title: "CDS Quick Practice Example",
          points: [
            "Direct: 'He said, \"I will join the Army.\"'",
            "Indirect: 'He said that he would join the Army.'"
          ]
        },
        {
          slno: 9,
          title: "Quick Revision Tips",
          points: [
            "Always check the tense of the reporting verb first.",
            "Memorize the time/place word conversions.",
            "For CDS MCQs, eliminate options with wrong pronoun or tense shifts."
          ]
        }
        
      ]

    },




  },




  
"32":{
  "day (1)":{
    "all about (day 1) SSB":[
      {
        slno: 1,
        title: "OIR Test (Officer Intelligence Rating)",
        points: [
          "A screening test to assess candidates' reasoning and problem-solving ability.",
          "Includes verbal and non-verbal reasoning questions.",
          "Performance is graded; higher scores increase selection chances.",
          "Time-bound and requires speed with accuracy."
        ],
      },
      {
        slno: 1,
        title: "PPDT (Picture Perception and Discussion Test)",
        points: [
          "Candidates view a picture for 30 seconds and write a story around it in 4 minutes.",
          "Story should cover past, present, and future events logically.",
          "Followed by group discussion to assess communication, confidence, and cooperation.",
          "Tests observation skills, imagination, and ability to influence group."
        ],
      },
    ],
  },



  "day (2)":{
    "all about (day 2) SSB":[
      {
        slno: 1,
        title: "Thematic Apperception Test (TAT)",
        points: [
          "A projective psychological test to assess a candidate's imagination, emotions, and personality.",
          "12 ambiguous pictures are shown, each for 30 seconds.",
          "Candidates write a story for each picture within 4 minutes.",
          "Stories should cover past, present, and future aspects of the scene.",
          "Evaluates creativity, problem-solving, and alignment with OLQs (Officer Like Qualities)."
        ],
      },
      {
        slno: 2,
        title: "Word Association Test (WAT)",
        points: [
          "Assesses subconscious mind, personality traits, and quick thinking.",
          "60 words are shown on a screen one after another.",
          "Each word stays for 15 seconds, during which candidates write the first thought or sentence that comes to mind.",
          "Tests positivity, attitude, mental agility, and adaptability.",
          "Negative or defensive responses reduce chances of selection."
        ],
      },
      {
        slno: 3,
        title: "Situation Reaction Test (SRT)",
        points: [
          "Evaluates practical decision-making, problem-solving ability, and presence of mind.",
          "60 real-life situations are given in a booklet.",
          "Candidates write their immediate response to each within the given time (about 30 minutes).",
          "Responses should be logical, positive, and quick.",
          "Judges how a candidate acts under stress and urgency."
        ],
      },
      {
        slno: 4,
        title: "Self Description Test (SDT)",
        points: [
          "Tests self-awareness and how others perceive you.",
          "Candidates write 5 short paragraphs on: what parents think of you, what teachers think of you, what friends think of you, your own opinion about yourself, and your aim in life.",
          "Time allotted: 15 minutes.",
          "Responses should be honest, positive, and reflect leadership potential.",
          "Helps assess confidence, values, and clarity of life goals."
        ],
      }
    ],
  },



  "day (3)":{
    "all about (day 3) SSB":[
      {
        slno: 1,
        title: "Group Discussion (GD)",
        points: [
          "Conducted in two rounds with different topics related to social, national, or international issues.",
          "Candidates sit in a circle and express their views logically and confidently.",
          "No formal conclusion is required; assessment is on participation, clarity, confidence, and cooperation.",
          "Tests communication skills, general awareness, and team spirit.",
          "Dominating behavior or being silent for most of the discussion negatively impacts assessment."
        ],
      },
      {
        slno: 2,
        title: "Group Planning Exercise (GPE)",
        points: [
          "Candidates are given a model with a map showing certain problems and resources.",
          "Time is given to write an individual plan to solve the problems in minimum time and resources.",
          "After writing, group discussion follows to arrive at a common plan.",
          "Tests planning ability, resource management, and team coordination.",
          "Assesses logical thinking, prioritization, and ability to influence group decisions."
        ],
      },
      {
        slno: 3,
        title: "Progressive Group Task (PGT)",
        points: [
          "Series of four group tasks with increasing difficulty levels.",
          "Candidates are given helping materials like planks, ropes, and load.",
          "Rules: Cannot touch out-of-bound areas, must carry load, follow group restrictions.",
          "Tests cooperation, creativity, and practical problem-solving.",
          "Focus on active participation rather than just giving ideas."
        ],
      },
      {
        slno: 4,
        title: "Group Obstacle Race (GOR)",
        points: [
          "Also known as Snake Race.",
          "All group members carry a long rolled-up tent-like object called 'Snake'.",
          "The group passes through six obstacles in a competitive race with other groups.",
          "Encourages group bonding, physical stamina, and cooperation.",
          "Fun but physically demanding; loud war cries encouraged for motivation."
        ],
      },
    ],
  },







  "day (4)":{
    "all about (day 4) SSB":[
      {
        slno: 1,
        title: "Half Group Task (HGT)",
        points: [
          "Similar to Progressive Group Task but the group is divided into two halves.",
          "Fewer members mean more chances for individual participation.",
          "Uses same rules and materials as PGT (planks, ropes, load, etc.).",
          "Tests leadership, cooperation, and problem-solving in smaller teams.",
          "Encourages active involvement and visibility to the GTO."
        ],
      },
      {
        slno: 2,
        title: "Lecturette",
        points: [
          "Each candidate picks a topic from four options and speaks for 3 minutes.",
          "1 minute is given for preparation before speaking.",
          "Topics range from current affairs to social issues or abstract ideas.",
          "Assesses confidence, clarity of thought, general knowledge, and public speaking skills.",
          "Eye contact, body language, and structured delivery are important."
        ],
      },
      {
        slno: 3,
        title: "Individual Obstacles",
        points: [
          "10 obstacles to be completed in 3 minutes.",
          "Each obstacle has a score from 1 to 10 based on difficulty.",
          "Examples: Jumping over hurdles, balancing, climbing walls, monkey crawl, etc.",
          "Tests physical fitness, stamina, speed, and determination.",
          "Candidates may attempt obstacles multiple times for better scores."
        ],
      },
      {
        slno: 4,
        title: "Command Task",
        points: [
          "Candidate acts as a commander and leads subordinates through an obstacle.",
          "Given helping materials like planks, ropes, etc., with restrictions.",
          "Assesses leadership, problem-solving, and resource management.",
          "Commanders choose 2–3 subordinates from the group.",
          "Tests ability to take charge under GTO observation."
        ],
      },
      {
        slno: 5,
        title: "Final Group Task (FGT)",
        points: [
          "Last outdoor task of the GTO series.",
          "Similar to PGT but more difficult and completed as a full group.",
          "One single task to be solved using materials provided.",
          "Tests overall cooperation, teamwork, and problem-solving skills.",
          "Performance here often reflects the final impression for GTO assessment."
        ],
      }
    ],
  },




  "day (5)":{
    "all about (day 5) SSB":[
      {
        slno: 1,
        title: "Personal Interview",
        points: [
          "One-on-one interaction with the Interviewing Officer (IO).",
          "Covers personal background, academics, hobbies, general awareness, and situational questions.",
          "Focus on consistency between PIQ (Personal Information Questionnaire) and answers.",
          "Tests honesty, confidence, clarity of thought, and suitability for armed forces.",
          "Includes rapid-fire questions and stress-based questioning."
        ],
      },
      {
        slno: 2,
        title: "Conference",
        points: [
          "All board members (IO, GTO, Psychologist) sit together.",
          "Each candidate appears before the panel for 1–2 minutes.",
          "Panel may ask clarifying or final assessment questions.",
          "Purpose is to review and finalize the candidate's overall performance.",
          "Highly borderline cases may face detailed questioning."
        ],
      },
      {
        slno: 3,
        title: "Results Announcement",
        points: [
          "Results are declared shortly after the conference.",
          "Selected candidates are briefed about the next stage – medical examination.",
          "Unsuccessful candidates are given feedback in some boards.",
          "Marks are not disclosed; selection is based on overall performance in all tests.",
          "Those recommended proceed for further evaluation; others depart the center."
        ],
      }
    ],
  },
},
};

export default flashData;
